// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/events/v1/events.proto (package gdx.events.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Duration, Message, proto3, protoInt64, StringValue, Timestamp } from "@bufbuild/protobuf";
import { ProfileBirthday, ProfileGender } from "../../gateway/web/profile/v1/profile_pb.js";
import { CodeType, ProfileLocation } from "../../common/v1/profile_pb.js";
import { AbuseSource } from "../../gateway/web/connection/v1/connection_pb.js";
import { DialogMessageContent, RestrictionReason } from "../../gateway/web/chat/v1/dialogs_pb.js";
import { Source } from "../../gateway/web/chat/v1/source_pb.js";
import { ChargeType, OrderStatus, PaymentGateway, PaymentOrderStatusDetails } from "../../gateway/web/payment/v2/payment_pb.js";
import { Conversion, Params } from "../../gateway/web/conversion/v1/conversion_pb.js";
import { Possibility } from "../../gateway/web/possibilities/v1/possibilities_pb.js";
import { ActorType } from "../../backoffice/service/newprofiles/v1/new_profiles_pb.js";
import { CommandSourceType, Governor, Subscription } from "../../gateway/web/payment/v2/subscription_pb.js";
import { SearchCriteria, SearchMeta } from "../../gateway/web/profile/v1/search_pb.js";
import { CameBackEvent, OnboardingCompleteClientEvent, ProfileVisitedEvent, RouteVisitedEvent, SurveyType, WebPushClickClientEvent } from "../../gateway/web/myprofile/v1/client_events_pb.js";
import { CardsViewedEvent } from "../../gateway/web/profile/v1/client_events_pb.js";
import { Channel } from "../../chatters/v1/session_pb.js";
import { ExtraConnectionId, ExtraGift, ExtraMessageText, ExtraPartnerId, FeatureType } from "../../market/v1/package_pb.js";
import { Event } from "../../gateway/web/analytics/event_pb.js";

/**
 * Enumerates action completion statuses.
 *
 * @generated from enum gdx.events.v1.RetentionActionStatus
 */
export enum RetentionActionStatus {
  /**
   * @generated from enum value: RETENTION_ACTION_STATUS_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: RETENTION_ACTION_STATUS_SUCCESS = 1;
   */
  SUCCESS = 1,

  /**
   * @generated from enum value: RETENTION_ACTION_STATUS_UNABLE_TO_PERFORM = 2;
   */
  UNABLE_TO_PERFORM = 2,

  /**
   * @generated from enum value: RETENTION_ACTION_STATUS_ALREADY_USED = 3;
   */
  ALREADY_USED = 3,

  /**
   * @generated from enum value: RETENTION_ACTION_STATUS_FAILED = 4;
   */
  FAILED = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(RetentionActionStatus)
proto3.util.setEnumType(RetentionActionStatus, "gdx.events.v1.RetentionActionStatus", [
  { no: 0, name: "RETENTION_ACTION_STATUS_INVALID" },
  { no: 1, name: "RETENTION_ACTION_STATUS_SUCCESS" },
  { no: 2, name: "RETENTION_ACTION_STATUS_UNABLE_TO_PERFORM" },
  { no: 3, name: "RETENTION_ACTION_STATUS_ALREADY_USED" },
  { no: 4, name: "RETENTION_ACTION_STATUS_FAILED" },
]);

/**
 * Chatter session ending reasons.
 *
 * @generated from enum gdx.events.v1.ChatterSessionEndReason
 */
export enum ChatterSessionEndReason {
  /**
   * @generated from enum value: CHATTER_SESSION_END_REASON_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: CHATTER_SESSION_END_REASON_MANUAL = 1;
   */
  MANUAL = 1,

  /**
   * @generated from enum value: CHATTER_SESSION_END_REASON_INACTIVE = 2;
   */
  INACTIVE = 2,

  /**
   * @generated from enum value: CHATTER_SESSION_END_REASON_ADMIN = 3;
   */
  ADMIN = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(ChatterSessionEndReason)
proto3.util.setEnumType(ChatterSessionEndReason, "gdx.events.v1.ChatterSessionEndReason", [
  { no: 0, name: "CHATTER_SESSION_END_REASON_INVALID" },
  { no: 1, name: "CHATTER_SESSION_END_REASON_MANUAL" },
  { no: 2, name: "CHATTER_SESSION_END_REASON_INACTIVE" },
  { no: 3, name: "CHATTER_SESSION_END_REASON_ADMIN" },
]);

/**
 * Available package types for payment application event.
 *
 * @generated from enum gdx.events.v1.PackageType
 */
export enum PackageType {
  /**
   * @generated from enum value: PACKAGE_TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: PACKAGE_TYPE_SUBSCRIPTION = 1;
   */
  SUBSCRIPTION = 1,

  /**
   * @generated from enum value: PACKAGE_TYPE_CREDITS = 2;
   */
  CREDITS = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(PackageType)
proto3.util.setEnumType(PackageType, "gdx.events.v1.PackageType", [
  { no: 0, name: "PACKAGE_TYPE_INVALID" },
  { no: 1, name: "PACKAGE_TYPE_SUBSCRIPTION" },
  { no: 2, name: "PACKAGE_TYPE_CREDITS" },
]);

/**
 * Users push subscription statuses.
 *
 * @generated from enum gdx.events.v1.PushSubscriptionStatus
 */
export enum PushSubscriptionStatus {
  /**
   * @generated from enum value: PUSH_SUBSCRIPTION_STATUS_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: PUSH_SUBSCRIPTION_STATUS_SUBSCRIBED = 1;
   */
  SUBSCRIBED = 1,

  /**
   * @generated from enum value: PUSH_SUBSCRIPTION_STATUS_UNSUBSCRIBED = 2;
   */
  UNSUBSCRIBED = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(PushSubscriptionStatus)
proto3.util.setEnumType(PushSubscriptionStatus, "gdx.events.v1.PushSubscriptionStatus", [
  { no: 0, name: "PUSH_SUBSCRIPTION_STATUS_INVALID" },
  { no: 1, name: "PUSH_SUBSCRIPTION_STATUS_SUBSCRIBED" },
  { no: 2, name: "PUSH_SUBSCRIPTION_STATUS_UNSUBSCRIBED" },
]);

/**
 * User incoming activity level.
 *
 * @generated from enum gdx.events.v1.IncomingActivityLevel
 */
export enum IncomingActivityLevel {
  /**
   * @generated from enum value: INCOMING_ACTIVITY_LEVEL_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: INCOMING_ACTIVITY_LEVEL_LOW = 1;
   */
  LOW = 1,

  /**
   * @generated from enum value: INCOMING_ACTIVITY_LEVEL_HIGH = 2;
   */
  HIGH = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(IncomingActivityLevel)
proto3.util.setEnumType(IncomingActivityLevel, "gdx.events.v1.IncomingActivityLevel", [
  { no: 0, name: "INCOMING_ACTIVITY_LEVEL_INVALID" },
  { no: 1, name: "INCOMING_ACTIVITY_LEVEL_LOW" },
  { no: 2, name: "INCOMING_ACTIVITY_LEVEL_HIGH" },
]);

/**
 * Occurs on successful user sign up.
 * ebus:message
 *
 * @generated from message gdx.events.v1.SignUpEvent
 */
export class SignUpEvent extends Message<SignUpEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string email = 8;
   */
  email = "";

  /**
   * @generated from field: string name = 9;
   */
  name = "";

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfileGender gender = 2;
   */
  gender = ProfileGender.INVALID;

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfileGender match_gender = 3;
   */
  matchGender = ProfileGender.INVALID;

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfileBirthday birthday = 4;
   */
  birthday?: ProfileBirthday;

  /**
   * @generated from field: string provider = 10;
   */
  provider = "";

  /**
   * @generated from field: string user_agent = 5;
   */
  userAgent = "";

  /**
   * @generated from field: repeated string tags = 6;
   */
  tags: string[] = [];

  /**
   * @generated from field: string landing_url = 11;
   */
  landingUrl = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 7;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: string ip = 12;
   */
  ip = "";

  /**
   * @generated from field: int32 mirror_id = 13;
   */
  mirrorId = 0;

  /**
   * @generated from field: gdx.common.v1.ProfileLocation location = 14;
   */
  location?: ProfileLocation;

  /**
   * @generated from field: string interface_language = 15;
   */
  interfaceLanguage = "";

  /**
   * @generated from field: string registration_country_code = 16;
   */
  registrationCountryCode = "";

  constructor(data?: PartialMessage<SignUpEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.SignUpEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "gender", kind: "enum", T: proto3.getEnumType(ProfileGender) },
    { no: 3, name: "match_gender", kind: "enum", T: proto3.getEnumType(ProfileGender) },
    { no: 4, name: "birthday", kind: "message", T: ProfileBirthday },
    { no: 10, name: "provider", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "user_agent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "landing_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "created_time", kind: "message", T: Timestamp },
    { no: 12, name: "ip", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "mirror_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "location", kind: "message", T: ProfileLocation },
    { no: 15, name: "interface_language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "registration_country_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SignUpEvent {
    return new SignUpEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SignUpEvent {
    return new SignUpEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SignUpEvent {
    return new SignUpEvent().fromJsonString(jsonString, options);
  }

  static equals(a: SignUpEvent | PlainMessage<SignUpEvent> | undefined, b: SignUpEvent | PlainMessage<SignUpEvent> | undefined): boolean {
    return proto3.util.equals(SignUpEvent, a, b);
  }
}

/**
 * Utilitarian event.
 * ebus:message
 *
 * @generated from message gdx.events.v1.SetMirrorIdEvent
 */
export class SetMirrorIdEvent extends Message<SetMirrorIdEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: int32 mirror_id = 2;
   */
  mirrorId = 0;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 3;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<SetMirrorIdEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.SetMirrorIdEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "mirror_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetMirrorIdEvent {
    return new SetMirrorIdEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetMirrorIdEvent {
    return new SetMirrorIdEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetMirrorIdEvent {
    return new SetMirrorIdEvent().fromJsonString(jsonString, options);
  }

  static equals(a: SetMirrorIdEvent | PlainMessage<SetMirrorIdEvent> | undefined, b: SetMirrorIdEvent | PlainMessage<SetMirrorIdEvent> | undefined): boolean {
    return proto3.util.equals(SetMirrorIdEvent, a, b);
  }
}

/**
 * Occurs on user approved email.
 * ebus:message
 *
 * @generated from message gdx.events.v1.EmailApprovedEvent
 */
export class EmailApprovedEvent extends Message<EmailApprovedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 2;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<EmailApprovedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.EmailApprovedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EmailApprovedEvent {
    return new EmailApprovedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EmailApprovedEvent {
    return new EmailApprovedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EmailApprovedEvent {
    return new EmailApprovedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: EmailApprovedEvent | PlainMessage<EmailApprovedEvent> | undefined, b: EmailApprovedEvent | PlainMessage<EmailApprovedEvent> | undefined): boolean {
    return proto3.util.equals(EmailApprovedEvent, a, b);
  }
}

/**
 * Occurs on user email updated.
 * ebus:message
 *
 * @generated from message gdx.events.v1.EmailUpdatedEvent
 */
export class EmailUpdatedEvent extends Message<EmailUpdatedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string email = 2;
   */
  email = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 3;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<EmailUpdatedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.EmailUpdatedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EmailUpdatedEvent {
    return new EmailUpdatedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EmailUpdatedEvent {
    return new EmailUpdatedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EmailUpdatedEvent {
    return new EmailUpdatedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: EmailUpdatedEvent | PlainMessage<EmailUpdatedEvent> | undefined, b: EmailUpdatedEvent | PlainMessage<EmailUpdatedEvent> | undefined): boolean {
    return proto3.util.equals(EmailUpdatedEvent, a, b);
  }
}

/**
 * Occurs on user reset password initiated.
 * ebus:message
 *
 * @generated from message gdx.events.v1.PasswordResetInitiatedEvent
 */
export class PasswordResetInitiatedEvent extends Message<PasswordResetInitiatedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string hash = 3;
   */
  hash = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 2;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<PasswordResetInitiatedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.PasswordResetInitiatedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "hash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PasswordResetInitiatedEvent {
    return new PasswordResetInitiatedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PasswordResetInitiatedEvent {
    return new PasswordResetInitiatedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PasswordResetInitiatedEvent {
    return new PasswordResetInitiatedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: PasswordResetInitiatedEvent | PlainMessage<PasswordResetInitiatedEvent> | undefined, b: PasswordResetInitiatedEvent | PlainMessage<PasswordResetInitiatedEvent> | undefined): boolean {
    return proto3.util.equals(PasswordResetInitiatedEvent, a, b);
  }
}

/**
 * Occurs on user reset password completed.
 * ebus:message
 *
 * @generated from message gdx.events.v1.PasswordResetCompletedEvent
 */
export class PasswordResetCompletedEvent extends Message<PasswordResetCompletedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 2;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<PasswordResetCompletedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.PasswordResetCompletedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PasswordResetCompletedEvent {
    return new PasswordResetCompletedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PasswordResetCompletedEvent {
    return new PasswordResetCompletedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PasswordResetCompletedEvent {
    return new PasswordResetCompletedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: PasswordResetCompletedEvent | PlainMessage<PasswordResetCompletedEvent> | undefined, b: PasswordResetCompletedEvent | PlainMessage<PasswordResetCompletedEvent> | undefined): boolean {
    return proto3.util.equals(PasswordResetCompletedEvent, a, b);
  }
}

/**
 * Occurs on successful user sign in.
 * ebus:message
 *
 * @generated from message gdx.events.v1.SignInEvent
 */
export class SignInEvent extends Message<SignInEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string provider = 2;
   */
  provider = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 3;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: string landing_url = 4;
   */
  landingUrl = "";

  constructor(data?: PartialMessage<SignInEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.SignInEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "provider", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "created_time", kind: "message", T: Timestamp },
    { no: 4, name: "landing_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SignInEvent {
    return new SignInEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SignInEvent {
    return new SignInEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SignInEvent {
    return new SignInEvent().fromJsonString(jsonString, options);
  }

  static equals(a: SignInEvent | PlainMessage<SignInEvent> | undefined, b: SignInEvent | PlainMessage<SignInEvent> | undefined): boolean {
    return proto3.util.equals(SignInEvent, a, b);
  }
}

/**
 * Occurs on profile tags updated.
 * ebus:message
 *
 * @generated from message gdx.events.v1.ProfileTagsUpdatedEvent
 */
export class ProfileTagsUpdatedEvent extends Message<ProfileTagsUpdatedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: repeated string tags = 2;
   */
  tags: string[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 3;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: string moderator_id = 4;
   */
  moderatorId = "";

  constructor(data?: PartialMessage<ProfileTagsUpdatedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ProfileTagsUpdatedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "created_time", kind: "message", T: Timestamp },
    { no: 4, name: "moderator_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileTagsUpdatedEvent {
    return new ProfileTagsUpdatedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileTagsUpdatedEvent {
    return new ProfileTagsUpdatedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileTagsUpdatedEvent {
    return new ProfileTagsUpdatedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileTagsUpdatedEvent | PlainMessage<ProfileTagsUpdatedEvent> | undefined, b: ProfileTagsUpdatedEvent | PlainMessage<ProfileTagsUpdatedEvent> | undefined): boolean {
    return proto3.util.equals(ProfileTagsUpdatedEvent, a, b);
  }
}

/**
 * Occurs on user account deleted.
 * ebus:message
 *
 * @generated from message gdx.events.v1.UserDeletedEvent
 */
export class UserDeletedEvent extends Message<UserDeletedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string reason = 2;
   */
  reason = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 3;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: string description = 4;
   */
  description = "";

  /**
   * @generated from field: string status = 5;
   */
  status = "";

  /**
   * @generated from field: repeated string category = 6;
   */
  category: string[] = [];

  /**
   * @generated from field: string moderator_id = 7;
   */
  moderatorId = "";

  constructor(data?: PartialMessage<UserDeletedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.UserDeletedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "created_time", kind: "message", T: Timestamp },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "moderator_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserDeletedEvent {
    return new UserDeletedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserDeletedEvent {
    return new UserDeletedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserDeletedEvent {
    return new UserDeletedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: UserDeletedEvent | PlainMessage<UserDeletedEvent> | undefined, b: UserDeletedEvent | PlainMessage<UserDeletedEvent> | undefined): boolean {
    return proto3.util.equals(UserDeletedEvent, a, b);
  }
}

/**
 * Occurs on profile info updated.
 * ebus:message
 *
 * @generated from message gdx.events.v1.ProfileInfoUpdatedEvent
 */
export class ProfileInfoUpdatedEvent extends Message<ProfileInfoUpdatedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: map<string, string> updated_fields = 2;
   */
  updatedFields: { [key: string]: string } = {};

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 3;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: uint32 total_fields_count = 4;
   */
  totalFieldsCount = 0;

  /**
   * @generated from field: uint32 critical_fields_count = 5;
   */
  criticalFieldsCount = 0;

  /**
   * @generated from field: uint32 critical_fields_filled = 6;
   */
  criticalFieldsFilled = 0;

  /**
   * @generated from field: uint32 total_filled_fields = 7;
   */
  totalFilledFields = 0;

  constructor(data?: PartialMessage<ProfileInfoUpdatedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ProfileInfoUpdatedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "updated_fields", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 3, name: "created_time", kind: "message", T: Timestamp },
    { no: 4, name: "total_fields_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "critical_fields_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 6, name: "critical_fields_filled", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 7, name: "total_filled_fields", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileInfoUpdatedEvent {
    return new ProfileInfoUpdatedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileInfoUpdatedEvent {
    return new ProfileInfoUpdatedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileInfoUpdatedEvent {
    return new ProfileInfoUpdatedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileInfoUpdatedEvent | PlainMessage<ProfileInfoUpdatedEvent> | undefined, b: ProfileInfoUpdatedEvent | PlainMessage<ProfileInfoUpdatedEvent> | undefined): boolean {
    return proto3.util.equals(ProfileInfoUpdatedEvent, a, b);
  }
}

/**
 * Occurs on profile location updated.
 * ebus:message
 *
 * @generated from message gdx.events.v1.ProfileLocationUpdatedEvent
 */
export class ProfileLocationUpdatedEvent extends Message<ProfileLocationUpdatedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: gdx.common.v1.ProfileLocation location = 2;
   */
  location?: ProfileLocation;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 3;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<ProfileLocationUpdatedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ProfileLocationUpdatedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "location", kind: "message", T: ProfileLocation },
    { no: 3, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileLocationUpdatedEvent {
    return new ProfileLocationUpdatedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileLocationUpdatedEvent {
    return new ProfileLocationUpdatedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileLocationUpdatedEvent {
    return new ProfileLocationUpdatedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileLocationUpdatedEvent | PlainMessage<ProfileLocationUpdatedEvent> | undefined, b: ProfileLocationUpdatedEvent | PlainMessage<ProfileLocationUpdatedEvent> | undefined): boolean {
    return proto3.util.equals(ProfileLocationUpdatedEvent, a, b);
  }
}

/**
 * Occurs on mutual user match.
 * ebus:message
 *
 * @generated from message gdx.events.v1.UserMatchEvent
 */
export class UserMatchEvent extends Message<UserMatchEvent> {
  /**
   * @generated from field: string connection_id = 1;
   */
  connectionId = "";

  /**
   * @generated from field: string user_id = 2;
   */
  userId = "";

  /**
   * @generated from field: string subject_user_id = 3;
   */
  subjectUserId = "";

  /**
   * @generated from field: uint32 source = 5;
   */
  source = 0;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 4;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: repeated string tags = 6;
   */
  tags: string[] = [];

  /**
   * @generated from field: bool is_power_like = 7;
   */
  isPowerLike = false;

  constructor(data?: PartialMessage<UserMatchEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.UserMatchEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "subject_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "source", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
    { no: 6, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "is_power_like", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserMatchEvent {
    return new UserMatchEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserMatchEvent {
    return new UserMatchEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserMatchEvent {
    return new UserMatchEvent().fromJsonString(jsonString, options);
  }

  static equals(a: UserMatchEvent | PlainMessage<UserMatchEvent> | undefined, b: UserMatchEvent | PlainMessage<UserMatchEvent> | undefined): boolean {
    return proto3.util.equals(UserMatchEvent, a, b);
  }
}

/**
 * Occurs when user reject matched profile.
 * ebus:message
 *
 * @generated from message gdx.events.v1.UserUnmatchedEvent
 */
export class UserUnmatchedEvent extends Message<UserUnmatchedEvent> {
  /**
   * @generated from field: string connection_id = 1;
   */
  connectionId = "";

  /**
   * @generated from field: string user_id = 2;
   */
  userId = "";

  /**
   * @generated from field: string subject_user_id = 3;
   */
  subjectUserId = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 4;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: repeated string tags = 5;
   */
  tags: string[] = [];

  constructor(data?: PartialMessage<UserUnmatchedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.UserUnmatchedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "subject_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
    { no: 5, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserUnmatchedEvent {
    return new UserUnmatchedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserUnmatchedEvent {
    return new UserUnmatchedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserUnmatchedEvent {
    return new UserUnmatchedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: UserUnmatchedEvent | PlainMessage<UserUnmatchedEvent> | undefined, b: UserUnmatchedEvent | PlainMessage<UserUnmatchedEvent> | undefined): boolean {
    return proto3.util.equals(UserUnmatchedEvent, a, b);
  }
}

/**
 * Occurs when user likes some other profile.
 * ebus:message
 *
 * @generated from message gdx.events.v1.UserLikeEvent
 */
export class UserLikeEvent extends Message<UserLikeEvent> {
  /**
   * @generated from field: string connection_id = 1;
   */
  connectionId = "";

  /**
   * @generated from field: string user_id = 2;
   */
  userId = "";

  /**
   * @generated from field: string subject_user_id = 3;
   */
  subjectUserId = "";

  /**
   * @generated from field: uint32 source = 5;
   */
  source = 0;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 4;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<UserLikeEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.UserLikeEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "subject_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "source", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserLikeEvent {
    return new UserLikeEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserLikeEvent {
    return new UserLikeEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserLikeEvent {
    return new UserLikeEvent().fromJsonString(jsonString, options);
  }

  static equals(a: UserLikeEvent | PlainMessage<UserLikeEvent> | undefined, b: UserLikeEvent | PlainMessage<UserLikeEvent> | undefined): boolean {
    return proto3.util.equals(UserLikeEvent, a, b);
  }
}

/**
 * Occurs when user reports abuse.
 * ebus:message
 *
 * @generated from message gdx.events.v1.UserAbuseReportedEvent
 */
export class UserAbuseReportedEvent extends Message<UserAbuseReportedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string subject_user_id = 2;
   */
  subjectUserId = "";

  /**
   * @generated from field: uint32 reason = 4;
   */
  reason = 0;

  /**
   * @generated from field: gdx.gateway.web.connection.v1.AbuseSource source = 5;
   */
  source = AbuseSource.INVALID;

  /**
   * @generated from field: string description = 6;
   */
  description = "";

  /**
   * @generated from field: string dialog_id = 7;
   */
  dialogId = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 3;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<UserAbuseReportedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.UserAbuseReportedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "reason", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "source", kind: "enum", T: proto3.getEnumType(AbuseSource) },
    { no: 6, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "dialog_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserAbuseReportedEvent {
    return new UserAbuseReportedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserAbuseReportedEvent {
    return new UserAbuseReportedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserAbuseReportedEvent {
    return new UserAbuseReportedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: UserAbuseReportedEvent | PlainMessage<UserAbuseReportedEvent> | undefined, b: UserAbuseReportedEvent | PlainMessage<UserAbuseReportedEvent> | undefined): boolean {
    return proto3.util.equals(UserAbuseReportedEvent, a, b);
  }
}

/**
 * Occurs when user blocks some other profile.
 * ebus:message
 *
 * @generated from message gdx.events.v1.UserBlockedEvent
 */
export class UserBlockedEvent extends Message<UserBlockedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string subject_user_id = 2;
   */
  subjectUserId = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 3;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: repeated string tags = 4;
   */
  tags: string[] = [];

  constructor(data?: PartialMessage<UserBlockedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.UserBlockedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "created_time", kind: "message", T: Timestamp },
    { no: 4, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserBlockedEvent {
    return new UserBlockedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserBlockedEvent {
    return new UserBlockedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserBlockedEvent {
    return new UserBlockedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: UserBlockedEvent | PlainMessage<UserBlockedEvent> | undefined, b: UserBlockedEvent | PlainMessage<UserBlockedEvent> | undefined): boolean {
    return proto3.util.equals(UserBlockedEvent, a, b);
  }
}

/**
 * Occurs when user profile was visited.
 * ebus:message
 *
 * @generated from message gdx.events.v1.VisitEvent
 */
export class VisitEvent extends Message<VisitEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string visitor_user_id = 2;
   */
  visitorUserId = "";

  /**
   * @generated from field: gdx.events.v1.VisitEvent.Source source = 4;
   */
  source = VisitEvent_Source.INVALID;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 3;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<VisitEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.VisitEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "visitor_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "source", kind: "enum", T: proto3.getEnumType(VisitEvent_Source) },
    { no: 3, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VisitEvent {
    return new VisitEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VisitEvent {
    return new VisitEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VisitEvent {
    return new VisitEvent().fromJsonString(jsonString, options);
  }

  static equals(a: VisitEvent | PlainMessage<VisitEvent> | undefined, b: VisitEvent | PlainMessage<VisitEvent> | undefined): boolean {
    return proto3.util.equals(VisitEvent, a, b);
  }
}

/**
 * Describes event source.
 *
 * @generated from enum gdx.events.v1.VisitEvent.Source
 */
export enum VisitEvent_Source {
  /**
   * @generated from enum value: SOURCE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: SOURCE_GENERATED = 1;
   */
  GENERATED = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(VisitEvent_Source)
proto3.util.setEnumType(VisitEvent_Source, "gdx.events.v1.VisitEvent.Source", [
  { no: 0, name: "SOURCE_INVALID" },
  { no: 1, name: "SOURCE_GENERATED" },
]);

/**
 * Occurs when user visits messages route.
 * ebus:message
 *
 * @generated from message gdx.events.v1.MessagesRouteVisitedEvent
 */
export class MessagesRouteVisitedEvent extends Message<MessagesRouteVisitedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 2;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<MessagesRouteVisitedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.MessagesRouteVisitedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MessagesRouteVisitedEvent {
    return new MessagesRouteVisitedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MessagesRouteVisitedEvent {
    return new MessagesRouteVisitedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MessagesRouteVisitedEvent {
    return new MessagesRouteVisitedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: MessagesRouteVisitedEvent | PlainMessage<MessagesRouteVisitedEvent> | undefined, b: MessagesRouteVisitedEvent | PlainMessage<MessagesRouteVisitedEvent> | undefined): boolean {
    return proto3.util.equals(MessagesRouteVisitedEvent, a, b);
  }
}

/**
 * Occurs on new message in dialogs.
 * ebus:message
 *
 * @generated from message gdx.events.v1.DialogMessageSentEvent
 */
export class DialogMessageSentEvent extends Message<DialogMessageSentEvent> {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId = "";

  /**
   * @generated from field: string dialog_id = 2;
   */
  dialogId = "";

  /**
   * @generated from field: bool is_new = 3;
   */
  isNew = false;

  /**
   * @generated from field: gdx.gateway.web.chat.v1.DialogMessageContent content = 4;
   */
  content?: DialogMessageContent;

  /**
   * @generated from field: string sender_id = 5;
   */
  senderId = "";

  /**
   * @generated from field: string subject_id = 8;
   */
  subjectId = "";

  /**
   * @generated from field: gdx.gateway.web.chat.v1.Source source = 9;
   */
  source?: Source;

  /**
   * @generated from field: google.protobuf.Duration created_duration = 6;
   */
  createdDuration?: Duration;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 7;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: repeated string tags = 10;
   */
  tags: string[] = [];

  /**
   * @generated from field: uint64 subject_unread = 11;
   */
  subjectUnread = protoInt64.zero;

  /**
   * @generated from field: gdx.events.v1.ConnectionStats stats = 12;
   */
  stats?: ConnectionStats;

  constructor(data?: PartialMessage<DialogMessageSentEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.DialogMessageSentEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "message_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "dialog_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_new", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "content", kind: "message", T: DialogMessageContent },
    { no: 5, name: "sender_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "subject_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "source", kind: "message", T: Source },
    { no: 6, name: "created_duration", kind: "message", T: Duration },
    { no: 7, name: "created_time", kind: "message", T: Timestamp },
    { no: 10, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "subject_unread", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 12, name: "stats", kind: "message", T: ConnectionStats },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DialogMessageSentEvent {
    return new DialogMessageSentEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DialogMessageSentEvent {
    return new DialogMessageSentEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DialogMessageSentEvent {
    return new DialogMessageSentEvent().fromJsonString(jsonString, options);
  }

  static equals(a: DialogMessageSentEvent | PlainMessage<DialogMessageSentEvent> | undefined, b: DialogMessageSentEvent | PlainMessage<DialogMessageSentEvent> | undefined): boolean {
    return proto3.util.equals(DialogMessageSentEvent, a, b);
  }
}

/**
 * Occurs when sender read all dialog messages.
 * ebus:message
 *
 * @generated from message gdx.events.v1.DialogAllMessagesReadEvent
 */
export class DialogAllMessagesReadEvent extends Message<DialogAllMessagesReadEvent> {
  /**
   * @generated from field: string dialog_id = 1;
   */
  dialogId = "";

  /**
   * @generated from field: string sender_id = 2;
   */
  senderId = "";

  /**
   * @generated from field: repeated string tags = 3;
   */
  tags: string[] = [];

  constructor(data?: PartialMessage<DialogAllMessagesReadEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.DialogAllMessagesReadEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dialog_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sender_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DialogAllMessagesReadEvent {
    return new DialogAllMessagesReadEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DialogAllMessagesReadEvent {
    return new DialogAllMessagesReadEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DialogAllMessagesReadEvent {
    return new DialogAllMessagesReadEvent().fromJsonString(jsonString, options);
  }

  static equals(a: DialogAllMessagesReadEvent | PlainMessage<DialogAllMessagesReadEvent> | undefined, b: DialogAllMessagesReadEvent | PlainMessage<DialogAllMessagesReadEvent> | undefined): boolean {
    return proto3.util.equals(DialogAllMessagesReadEvent, a, b);
  }
}

/**
 * Occurs when message was restricted.
 * ebus:message
 *
 * @generated from message gdx.events.v1.DialogMessageRestrictedEvent
 */
export class DialogMessageRestrictedEvent extends Message<DialogMessageRestrictedEvent> {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId = "";

  /**
   * @generated from field: string dialog_id = 2;
   */
  dialogId = "";

  /**
   * @generated from field: string sender_id = 3;
   */
  senderId = "";

  /**
   * @generated from field: gdx.gateway.web.chat.v1.RestrictionReason reason = 4;
   */
  reason = RestrictionReason.INVALID;

  constructor(data?: PartialMessage<DialogMessageRestrictedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.DialogMessageRestrictedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "message_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "dialog_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sender_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "reason", kind: "enum", T: proto3.getEnumType(RestrictionReason) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DialogMessageRestrictedEvent {
    return new DialogMessageRestrictedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DialogMessageRestrictedEvent {
    return new DialogMessageRestrictedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DialogMessageRestrictedEvent {
    return new DialogMessageRestrictedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: DialogMessageRestrictedEvent | PlainMessage<DialogMessageRestrictedEvent> | undefined, b: DialogMessageRestrictedEvent | PlainMessage<DialogMessageRestrictedEvent> | undefined): boolean {
    return proto3.util.equals(DialogMessageRestrictedEvent, a, b);
  }
}

/**
 * Occurs on message deleted.
 * ebus:message
 *
 * @generated from message gdx.events.v1.DialogMessageDeletedEvent
 */
export class DialogMessageDeletedEvent extends Message<DialogMessageDeletedEvent> {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId = "";

  /**
   * @generated from field: string dialog_id = 2;
   */
  dialogId = "";

  /**
   * @generated from field: string initiator_id = 3;
   */
  initiatorId = "";

  /**
   * @generated from field: string subject_id = 5;
   */
  subjectId = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 4;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: repeated string tags = 6;
   */
  tags: string[] = [];

  /**
   * @generated from field: uint64 subject_unread = 7;
   */
  subjectUnread = protoInt64.zero;

  /**
   * @generated from field: gdx.events.v1.ConnectionStats stats = 8;
   */
  stats?: ConnectionStats;

  constructor(data?: PartialMessage<DialogMessageDeletedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.DialogMessageDeletedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "message_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "dialog_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "initiator_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "subject_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
    { no: 6, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "subject_unread", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 8, name: "stats", kind: "message", T: ConnectionStats },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DialogMessageDeletedEvent {
    return new DialogMessageDeletedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DialogMessageDeletedEvent {
    return new DialogMessageDeletedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DialogMessageDeletedEvent {
    return new DialogMessageDeletedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: DialogMessageDeletedEvent | PlainMessage<DialogMessageDeletedEvent> | undefined, b: DialogMessageDeletedEvent | PlainMessage<DialogMessageDeletedEvent> | undefined): boolean {
    return proto3.util.equals(DialogMessageDeletedEvent, a, b);
  }
}

/**
 * Occurs on tags was updated.
 * ebus:message
 *
 * @generated from message gdx.events.v1.DialogTagsUpdatedEvent
 */
export class DialogTagsUpdatedEvent extends Message<DialogTagsUpdatedEvent> {
  /**
   * @generated from field: string dialog_id = 1;
   */
  dialogId = "";

  /**
   * @generated from field: repeated string tags = 2;
   */
  tags: string[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 3;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<DialogTagsUpdatedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.DialogTagsUpdatedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dialog_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DialogTagsUpdatedEvent {
    return new DialogTagsUpdatedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DialogTagsUpdatedEvent {
    return new DialogTagsUpdatedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DialogTagsUpdatedEvent {
    return new DialogTagsUpdatedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: DialogTagsUpdatedEvent | PlainMessage<DialogTagsUpdatedEvent> | undefined, b: DialogTagsUpdatedEvent | PlainMessage<DialogTagsUpdatedEvent> | undefined): boolean {
    return proto3.util.equals(DialogTagsUpdatedEvent, a, b);
  }
}

/**
 * Occurs on dialog was marked as unread for specified participant.
 * ebus:message
 *
 * @generated from message gdx.events.v1.DialogMarkAsUnreadEvent
 */
export class DialogMarkAsUnreadEvent extends Message<DialogMarkAsUnreadEvent> {
  /**
   * @generated from field: string dialog_id = 1;
   */
  dialogId = "";

  /**
   * @generated from field: string initiator_id = 2;
   */
  initiatorId = "";

  /**
   * @generated from field: uint32 source = 3;
   */
  source = 0;

  /**
   * @generated from field: repeated string tags = 4;
   */
  tags: string[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 5;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<DialogMarkAsUnreadEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.DialogMarkAsUnreadEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dialog_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "initiator_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "source", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DialogMarkAsUnreadEvent {
    return new DialogMarkAsUnreadEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DialogMarkAsUnreadEvent {
    return new DialogMarkAsUnreadEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DialogMarkAsUnreadEvent {
    return new DialogMarkAsUnreadEvent().fromJsonString(jsonString, options);
  }

  static equals(a: DialogMarkAsUnreadEvent | PlainMessage<DialogMarkAsUnreadEvent> | undefined, b: DialogMarkAsUnreadEvent | PlainMessage<DialogMarkAsUnreadEvent> | undefined): boolean {
    return proto3.util.equals(DialogMarkAsUnreadEvent, a, b);
  }
}

/**
 * Occurs when user request photo.
 * ebus:message
 *
 * @generated from message gdx.events.v1.UserPhotoRequestedEvent
 */
export class UserPhotoRequestedEvent extends Message<UserPhotoRequestedEvent> {
  /**
   * @generated from field: string connection_id = 1;
   */
  connectionId = "";

  /**
   * @generated from field: string initiator_user_id = 2;
   */
  initiatorUserId = "";

  /**
   * @generated from field: string subject_user_id = 3;
   */
  subjectUserId = "";

  /**
   * @generated from field: uint32 source = 5;
   */
  source = 0;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 4;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<UserPhotoRequestedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.UserPhotoRequestedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "initiator_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "subject_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "source", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserPhotoRequestedEvent {
    return new UserPhotoRequestedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserPhotoRequestedEvent {
    return new UserPhotoRequestedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserPhotoRequestedEvent {
    return new UserPhotoRequestedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: UserPhotoRequestedEvent | PlainMessage<UserPhotoRequestedEvent> | undefined, b: UserPhotoRequestedEvent | PlainMessage<UserPhotoRequestedEvent> | undefined): boolean {
    return proto3.util.equals(UserPhotoRequestedEvent, a, b);
  }
}

/**
 * Occurs when user upload requested photo.
 * ebus:message
 *
 * @generated from message gdx.events.v1.UserRequestPhotoUploadedEvent
 */
export class UserRequestPhotoUploadedEvent extends Message<UserRequestPhotoUploadedEvent> {
  /**
   * @generated from field: string initiator_user_id = 1;
   */
  initiatorUserId = "";

  /**
   * @generated from field: string subject_user_id = 2;
   */
  subjectUserId = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 3;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<UserRequestPhotoUploadedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.UserRequestPhotoUploadedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "initiator_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserRequestPhotoUploadedEvent {
    return new UserRequestPhotoUploadedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserRequestPhotoUploadedEvent {
    return new UserRequestPhotoUploadedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserRequestPhotoUploadedEvent {
    return new UserRequestPhotoUploadedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: UserRequestPhotoUploadedEvent | PlainMessage<UserRequestPhotoUploadedEvent> | undefined, b: UserRequestPhotoUploadedEvent | PlainMessage<UserRequestPhotoUploadedEvent> | undefined): boolean {
    return proto3.util.equals(UserRequestPhotoUploadedEvent, a, b);
  }
}

/**
 * Occurs when astro check done.
 * ebus:message
 *
 * @generated from message gdx.events.v1.AstroCheckEvent
 */
export class AstroCheckEvent extends Message<AstroCheckEvent> {
  /**
   * @generated from field: string initiator_user_id = 1;
   */
  initiatorUserId = "";

  /**
   * @generated from field: string subject_user_id = 2;
   */
  subjectUserId = "";

  /**
   * @generated from field: uint32 source = 3;
   */
  source = 0;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 4;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<AstroCheckEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.AstroCheckEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "initiator_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "source", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AstroCheckEvent {
    return new AstroCheckEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AstroCheckEvent {
    return new AstroCheckEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AstroCheckEvent {
    return new AstroCheckEvent().fromJsonString(jsonString, options);
  }

  static equals(a: AstroCheckEvent | PlainMessage<AstroCheckEvent> | undefined, b: AstroCheckEvent | PlainMessage<AstroCheckEvent> | undefined): boolean {
    return proto3.util.equals(AstroCheckEvent, a, b);
  }
}

/**
 * Occurs when sexual check done.
 * ebus:message
 *
 * @generated from message gdx.events.v1.SexualCheckEvent
 */
export class SexualCheckEvent extends Message<SexualCheckEvent> {
  /**
   * @generated from field: string initiator_user_id = 1;
   */
  initiatorUserId = "";

  /**
   * @generated from field: string subject_user_id = 2;
   */
  subjectUserId = "";

  /**
   * @generated from field: uint32 source = 3;
   */
  source = 0;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 4;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<SexualCheckEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.SexualCheckEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "initiator_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "source", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SexualCheckEvent {
    return new SexualCheckEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SexualCheckEvent {
    return new SexualCheckEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SexualCheckEvent {
    return new SexualCheckEvent().fromJsonString(jsonString, options);
  }

  static equals(a: SexualCheckEvent | PlainMessage<SexualCheckEvent> | undefined, b: SexualCheckEvent | PlainMessage<SexualCheckEvent> | undefined): boolean {
    return proto3.util.equals(SexualCheckEvent, a, b);
  }
}

/**
 * Occurs on message suspicious content reported.
 * ebus:message
 *
 * @generated from message gdx.events.v1.SuspiciousContentReportedEvent
 */
export class SuspiciousContentReportedEvent extends Message<SuspiciousContentReportedEvent> {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId = "";

  /**
   * @generated from field: string dialog_id = 2;
   */
  dialogId = "";

  /**
   * @generated from field: string initiator_id = 3;
   */
  initiatorId = "";

  /**
   * @generated from field: string subject_id = 5;
   */
  subjectId = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 4;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<SuspiciousContentReportedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.SuspiciousContentReportedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "message_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "dialog_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "initiator_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "subject_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SuspiciousContentReportedEvent {
    return new SuspiciousContentReportedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SuspiciousContentReportedEvent {
    return new SuspiciousContentReportedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SuspiciousContentReportedEvent {
    return new SuspiciousContentReportedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: SuspiciousContentReportedEvent | PlainMessage<SuspiciousContentReportedEvent> | undefined, b: SuspiciousContentReportedEvent | PlainMessage<SuspiciousContentReportedEvent> | undefined): boolean {
    return proto3.util.equals(SuspiciousContentReportedEvent, a, b);
  }
}

/**
 * Occurs on dialog skip for BO.
 * ebus:message
 *
 * @generated from message gdx.events.v1.DialogueSkippedEvent
 */
export class DialogueSkippedEvent extends Message<DialogueSkippedEvent> {
  /**
   * @generated from field: string team_member_id = 1;
   */
  teamMemberId = "";

  /**
   * @generated from field: string team_member_email = 2;
   */
  teamMemberEmail = "";

  /**
   * @generated from field: string dialog_id = 3;
   */
  dialogId = "";

  /**
   * @generated from field: string initiator_id = 4;
   */
  initiatorId = "";

  /**
   * @generated from field: string subject_id = 5;
   */
  subjectId = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 6;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<DialogueSkippedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.DialogueSkippedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "team_member_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_member_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "dialog_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "initiator_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "subject_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DialogueSkippedEvent {
    return new DialogueSkippedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DialogueSkippedEvent {
    return new DialogueSkippedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DialogueSkippedEvent {
    return new DialogueSkippedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: DialogueSkippedEvent | PlainMessage<DialogueSkippedEvent> | undefined, b: DialogueSkippedEvent | PlainMessage<DialogueSkippedEvent> | undefined): boolean {
    return proto3.util.equals(DialogueSkippedEvent, a, b);
  }
}

/**
 * Occurs on each payment transaction update.
 * ebus:message
 *
 * @generated from message gdx.events.v1.PaymentStatusUpdatedEvent
 */
export class PaymentStatusUpdatedEvent extends Message<PaymentStatusUpdatedEvent> {
  /**
   * @generated from field: string order_id = 1;
   */
  orderId = "";

  /**
   * @generated from field: string user_id = 2;
   */
  userId = "";

  /**
   * @generated from field: gdx.events.v1.Package package = 8;
   */
  package?: Package;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 4;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: gdx.gateway.web.payment.v2.ChargeType charge_type = 5;
   */
  chargeType = ChargeType.INVALID;

  /**
   * @generated from field: gdx.gateway.web.payment.v2.PaymentOrderStatusDetails status_details = 6;
   */
  statusDetails?: PaymentOrderStatusDetails;

  /**
   * @generated from field: string card_number = 7;
   */
  cardNumber = "";

  /**
   * @generated from field: string card_brand = 15;
   */
  cardBrand = "";

  /**
   * @generated from field: gdx.gateway.web.payment.v2.OrderStatus prev_status = 9;
   */
  prevStatus = OrderStatus.ORDER_STATUS_INVALID;

  /**
   * @generated from field: gdx.gateway.web.payment.v2.PaymentGateway gateway = 10;
   */
  gateway = PaymentGateway.INVALID;

  /**
   * @generated from field: string card_type = 11;
   */
  cardType = "";

  /**
   * @generated from field: int64 amount = 12;
   */
  amount = protoInt64.zero;

  /**
   * @generated from field: int64 refunded_amount = 13;
   */
  refundedAmount = protoInt64.zero;

  /**
   * @generated from field: int64 settled_amount = 14;
   */
  settledAmount = protoInt64.zero;

  /**
   * @generated from field: string card_bank = 16;
   */
  cardBank = "";

  constructor(data?: PartialMessage<PaymentStatusUpdatedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.PaymentStatusUpdatedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "package", kind: "message", T: Package },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
    { no: 5, name: "charge_type", kind: "enum", T: proto3.getEnumType(ChargeType) },
    { no: 6, name: "status_details", kind: "message", T: PaymentOrderStatusDetails },
    { no: 7, name: "card_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "card_brand", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "prev_status", kind: "enum", T: proto3.getEnumType(OrderStatus) },
    { no: 10, name: "gateway", kind: "enum", T: proto3.getEnumType(PaymentGateway) },
    { no: 11, name: "card_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 13, name: "refunded_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 14, name: "settled_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 16, name: "card_bank", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentStatusUpdatedEvent {
    return new PaymentStatusUpdatedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentStatusUpdatedEvent {
    return new PaymentStatusUpdatedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentStatusUpdatedEvent {
    return new PaymentStatusUpdatedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: PaymentStatusUpdatedEvent | PlainMessage<PaymentStatusUpdatedEvent> | undefined, b: PaymentStatusUpdatedEvent | PlainMessage<PaymentStatusUpdatedEvent> | undefined): boolean {
    return proto3.util.equals(PaymentStatusUpdatedEvent, a, b);
  }
}

/**
 * Occurs on each payment transaction update.
 * ebus:message
 *
 * @generated from message gdx.events.v1.PaymentTransactionsUpdatedEvent
 */
export class PaymentTransactionsUpdatedEvent extends Message<PaymentTransactionsUpdatedEvent> {
  /**
   * @generated from field: string order_id = 1;
   */
  orderId = "";

  /**
   * @generated from field: repeated gdx.events.v1.PaymentTransactionsUpdatedEvent.Transaction transactions = 2;
   */
  transactions: PaymentTransactionsUpdatedEvent_Transaction[] = [];

  constructor(data?: PartialMessage<PaymentTransactionsUpdatedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.PaymentTransactionsUpdatedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "transactions", kind: "message", T: PaymentTransactionsUpdatedEvent_Transaction, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentTransactionsUpdatedEvent {
    return new PaymentTransactionsUpdatedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentTransactionsUpdatedEvent {
    return new PaymentTransactionsUpdatedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentTransactionsUpdatedEvent {
    return new PaymentTransactionsUpdatedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: PaymentTransactionsUpdatedEvent | PlainMessage<PaymentTransactionsUpdatedEvent> | undefined, b: PaymentTransactionsUpdatedEvent | PlainMessage<PaymentTransactionsUpdatedEvent> | undefined): boolean {
    return proto3.util.equals(PaymentTransactionsUpdatedEvent, a, b);
  }
}

/**
 * Describes order transaction operation.
 *
 * @generated from message gdx.events.v1.PaymentTransactionsUpdatedEvent.Transaction
 */
export class PaymentTransactionsUpdatedEvent_Transaction extends Message<PaymentTransactionsUpdatedEvent_Transaction> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string operation = 2;
   */
  operation = "";

  /**
   * @generated from field: string status = 3;
   */
  status = "";

  /**
   * @generated from field: string descriptor_text = 4;
   */
  descriptorText = "";

  /**
   * @generated from field: uint64 amount = 5;
   */
  amount = protoInt64.zero;

  /**
   * @generated from field: string currency = 6;
   */
  currency = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 7;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_time = 8;
   */
  updatedTime?: Timestamp;

  /**
   * @generated from field: gdx.events.v1.PaymentTransactionsUpdatedEvent.Card card = 9;
   */
  card?: PaymentTransactionsUpdatedEvent_Card;

  /**
   * @generated from field: gdx.events.v1.PaymentTransactionsUpdatedEvent.BillingDetails billing_details = 10;
   */
  billingDetails?: PaymentTransactionsUpdatedEvent_BillingDetails;

  constructor(data?: PartialMessage<PaymentTransactionsUpdatedEvent_Transaction>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.PaymentTransactionsUpdatedEvent.Transaction";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "operation", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "descriptor_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "amount", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 6, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "created_time", kind: "message", T: Timestamp },
    { no: 8, name: "updated_time", kind: "message", T: Timestamp },
    { no: 9, name: "card", kind: "message", T: PaymentTransactionsUpdatedEvent_Card },
    { no: 10, name: "billing_details", kind: "message", T: PaymentTransactionsUpdatedEvent_BillingDetails },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentTransactionsUpdatedEvent_Transaction {
    return new PaymentTransactionsUpdatedEvent_Transaction().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentTransactionsUpdatedEvent_Transaction {
    return new PaymentTransactionsUpdatedEvent_Transaction().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentTransactionsUpdatedEvent_Transaction {
    return new PaymentTransactionsUpdatedEvent_Transaction().fromJsonString(jsonString, options);
  }

  static equals(a: PaymentTransactionsUpdatedEvent_Transaction | PlainMessage<PaymentTransactionsUpdatedEvent_Transaction> | undefined, b: PaymentTransactionsUpdatedEvent_Transaction | PlainMessage<PaymentTransactionsUpdatedEvent_Transaction> | undefined): boolean {
    return proto3.util.equals(PaymentTransactionsUpdatedEvent_Transaction, a, b);
  }
}

/**
 * Describes transaction card details.
 *
 * @generated from message gdx.events.v1.PaymentTransactionsUpdatedEvent.Card
 */
export class PaymentTransactionsUpdatedEvent_Card extends Message<PaymentTransactionsUpdatedEvent_Card> {
  /**
   * @generated from field: string bin = 1;
   */
  bin = "";

  /**
   * @generated from field: string brand = 2;
   */
  brand = "";

  /**
   * @generated from field: string number = 3;
   */
  number = "";

  /**
   * @generated from field: string card_holder = 4;
   */
  cardHolder = "";

  /**
   * @generated from field: string bank = 5;
   */
  bank = "";

  /**
   * @generated from field: string country = 6;
   */
  country = "";

  /**
   * @generated from field: string card_exp_month = 7;
   */
  cardExpMonth = "";

  /**
   * @generated from field: int64 card_exp_year = 8;
   */
  cardExpYear = protoInt64.zero;

  /**
   * @generated from field: string card_type = 9;
   */
  cardType = "";

  constructor(data?: PartialMessage<PaymentTransactionsUpdatedEvent_Card>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.PaymentTransactionsUpdatedEvent.Card";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "bin", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "brand", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "card_holder", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "bank", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "card_exp_month", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "card_exp_year", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "card_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentTransactionsUpdatedEvent_Card {
    return new PaymentTransactionsUpdatedEvent_Card().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentTransactionsUpdatedEvent_Card {
    return new PaymentTransactionsUpdatedEvent_Card().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentTransactionsUpdatedEvent_Card {
    return new PaymentTransactionsUpdatedEvent_Card().fromJsonString(jsonString, options);
  }

  static equals(a: PaymentTransactionsUpdatedEvent_Card | PlainMessage<PaymentTransactionsUpdatedEvent_Card> | undefined, b: PaymentTransactionsUpdatedEvent_Card | PlainMessage<PaymentTransactionsUpdatedEvent_Card> | undefined): boolean {
    return proto3.util.equals(PaymentTransactionsUpdatedEvent_Card, a, b);
  }
}

/**
 * Describes transaction billing details.
 *
 * @generated from message gdx.events.v1.PaymentTransactionsUpdatedEvent.BillingDetails
 */
export class PaymentTransactionsUpdatedEvent_BillingDetails extends Message<PaymentTransactionsUpdatedEvent_BillingDetails> {
  /**
   * @generated from field: string address = 1;
   */
  address = "";

  /**
   * @generated from field: string zip = 2;
   */
  zip = "";

  /**
   * @generated from field: string country = 3;
   */
  country = "";

  /**
   * @generated from field: string city = 4;
   */
  city = "";

  /**
   * @generated from field: string state = 5;
   */
  state = "";

  constructor(data?: PartialMessage<PaymentTransactionsUpdatedEvent_BillingDetails>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.PaymentTransactionsUpdatedEvent.BillingDetails";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "zip", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentTransactionsUpdatedEvent_BillingDetails {
    return new PaymentTransactionsUpdatedEvent_BillingDetails().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentTransactionsUpdatedEvent_BillingDetails {
    return new PaymentTransactionsUpdatedEvent_BillingDetails().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentTransactionsUpdatedEvent_BillingDetails {
    return new PaymentTransactionsUpdatedEvent_BillingDetails().fromJsonString(jsonString, options);
  }

  static equals(a: PaymentTransactionsUpdatedEvent_BillingDetails | PlainMessage<PaymentTransactionsUpdatedEvent_BillingDetails> | undefined, b: PaymentTransactionsUpdatedEvent_BillingDetails | PlainMessage<PaymentTransactionsUpdatedEvent_BillingDetails> | undefined): boolean {
    return proto3.util.equals(PaymentTransactionsUpdatedEvent_BillingDetails, a, b);
  }
}

/**
 * Occurs on marketing user was detected.
 * ebus:message
 *
 * @generated from message gdx.events.v1.MarketingUserDetectedV2Event
 */
export class MarketingUserDetectedV2Event extends Message<MarketingUserDetectedV2Event> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: int32 mirror_id = 2;
   */
  mirrorId = 0;

  /**
   * @generated from field: string network = 3;
   */
  network = "";

  /**
   * @generated from field: string transaction_id = 4;
   */
  transactionId = "";

  /**
   * @generated from field: string user_agent = 5;
   */
  userAgent = "";

  /**
   * @generated from field: string ip = 6;
   */
  ip = "";

  /**
   * @generated from field: repeated gdx.gateway.web.conversion.v1.Params params = 7;
   */
  params: Params[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 8;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: string registration_url = 9;
   */
  registrationUrl = "";

  /**
   * @generated from field: google.protobuf.Timestamp birthday_time = 10;
   */
  birthdayTime?: Timestamp;

  constructor(data?: PartialMessage<MarketingUserDetectedV2Event>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.MarketingUserDetectedV2Event";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "mirror_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "network", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "user_agent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "ip", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "params", kind: "message", T: Params, repeated: true },
    { no: 8, name: "created_time", kind: "message", T: Timestamp },
    { no: 9, name: "registration_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "birthday_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MarketingUserDetectedV2Event {
    return new MarketingUserDetectedV2Event().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MarketingUserDetectedV2Event {
    return new MarketingUserDetectedV2Event().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MarketingUserDetectedV2Event {
    return new MarketingUserDetectedV2Event().fromJsonString(jsonString, options);
  }

  static equals(a: MarketingUserDetectedV2Event | PlainMessage<MarketingUserDetectedV2Event> | undefined, b: MarketingUserDetectedV2Event | PlainMessage<MarketingUserDetectedV2Event> | undefined): boolean {
    return proto3.util.equals(MarketingUserDetectedV2Event, a, b);
  }
}

/**
 * Occurs on user done conversion action.
 * ebus:message
 *
 * @generated from message gdx.events.v1.UserConversionV2Event
 */
export class UserConversionV2Event extends Message<UserConversionV2Event> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: gdx.gateway.web.conversion.v1.Conversion conversion = 2;
   */
  conversion?: Conversion;

  /**
   * @generated from field: repeated gdx.gateway.web.conversion.v1.Conversion conversions = 3;
   */
  conversions: Conversion[] = [];

  constructor(data?: PartialMessage<UserConversionV2Event>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.UserConversionV2Event";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "conversion", kind: "message", T: Conversion },
    { no: 3, name: "conversions", kind: "message", T: Conversion, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserConversionV2Event {
    return new UserConversionV2Event().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserConversionV2Event {
    return new UserConversionV2Event().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserConversionV2Event {
    return new UserConversionV2Event().fromJsonString(jsonString, options);
  }

  static equals(a: UserConversionV2Event | PlainMessage<UserConversionV2Event> | undefined, b: UserConversionV2Event | PlainMessage<UserConversionV2Event> | undefined): boolean {
    return proto3.util.equals(UserConversionV2Event, a, b);
  }
}

/**
 * Notify that user has undelivered conversions.
 * ebus:message
 *
 * @generated from message gdx.events.v1.UserHasUndeliveredConversionsV2Event
 */
export class UserHasUndeliveredConversionsV2Event extends Message<UserHasUndeliveredConversionsV2Event> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 2;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<UserHasUndeliveredConversionsV2Event>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.UserHasUndeliveredConversionsV2Event";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserHasUndeliveredConversionsV2Event {
    return new UserHasUndeliveredConversionsV2Event().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserHasUndeliveredConversionsV2Event {
    return new UserHasUndeliveredConversionsV2Event().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserHasUndeliveredConversionsV2Event {
    return new UserHasUndeliveredConversionsV2Event().fromJsonString(jsonString, options);
  }

  static equals(a: UserHasUndeliveredConversionsV2Event | PlainMessage<UserHasUndeliveredConversionsV2Event> | undefined, b: UserHasUndeliveredConversionsV2Event | PlainMessage<UserHasUndeliveredConversionsV2Event> | undefined): boolean {
    return proto3.util.equals(UserHasUndeliveredConversionsV2Event, a, b);
  }
}

/**
 * Occurs on conversion was delivered.
 * ebus:message
 *
 * @generated from message gdx.events.v1.UserConversionDeliveredV2Event
 */
export class UserConversionDeliveredV2Event extends Message<UserConversionDeliveredV2Event> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: gdx.gateway.web.conversion.v1.Conversion conversion = 2;
   */
  conversion?: Conversion;

  /**
   * @generated from field: google.protobuf.Timestamp delivered_time = 3;
   */
  deliveredTime?: Timestamp;

  /**
   * @generated from field: repeated string targets = 4;
   */
  targets: string[] = [];

  constructor(data?: PartialMessage<UserConversionDeliveredV2Event>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.UserConversionDeliveredV2Event";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "conversion", kind: "message", T: Conversion },
    { no: 3, name: "delivered_time", kind: "message", T: Timestamp },
    { no: 4, name: "targets", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserConversionDeliveredV2Event {
    return new UserConversionDeliveredV2Event().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserConversionDeliveredV2Event {
    return new UserConversionDeliveredV2Event().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserConversionDeliveredV2Event {
    return new UserConversionDeliveredV2Event().fromJsonString(jsonString, options);
  }

  static equals(a: UserConversionDeliveredV2Event | PlainMessage<UserConversionDeliveredV2Event> | undefined, b: UserConversionDeliveredV2Event | PlainMessage<UserConversionDeliveredV2Event> | undefined): boolean {
    return proto3.util.equals(UserConversionDeliveredV2Event, a, b);
  }
}

/**
 * Occurs on user done conversion action.
 * ebus:message
 *
 * @generated from message gdx.events.v1.UserConversionEvent
 */
export class UserConversionEvent extends Message<UserConversionEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string email = 11;
   */
  email = "";

  /**
   * @generated from field: string action = 2;
   */
  action = "";

  /**
   * @generated from field: string network = 3;
   */
  network = "";

  /**
   * @generated from field: string transaction_id = 4;
   */
  transactionId = "";

  /**
   * @generated from field: string mirror = 5;
   */
  mirror = "";

  /**
   * @generated from field: string landing = 6;
   */
  landing = "";

  /**
   * @generated from field: string user_agent = 9;
   */
  userAgent = "";

  /**
   * @generated from field: string ip = 10;
   */
  ip = "";

  /**
   * @generated from field: repeated gdx.events.v1.UserConversionEvent.UserConversionEventParam params = 7;
   */
  params: UserConversionEvent_UserConversionEventParam[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 8;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<UserConversionEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.UserConversionEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "action", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "network", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "mirror", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "landing", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "user_agent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "ip", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "params", kind: "message", T: UserConversionEvent_UserConversionEventParam, repeated: true },
    { no: 8, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserConversionEvent {
    return new UserConversionEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserConversionEvent {
    return new UserConversionEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserConversionEvent {
    return new UserConversionEvent().fromJsonString(jsonString, options);
  }

  static equals(a: UserConversionEvent | PlainMessage<UserConversionEvent> | undefined, b: UserConversionEvent | PlainMessage<UserConversionEvent> | undefined): boolean {
    return proto3.util.equals(UserConversionEvent, a, b);
  }
}

/**
 * Params.
 *
 * @generated from message gdx.events.v1.UserConversionEvent.UserConversionEventParam
 */
export class UserConversionEvent_UserConversionEventParam extends Message<UserConversionEvent_UserConversionEventParam> {
  /**
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * @generated from field: string value = 2;
   */
  value = "";

  constructor(data?: PartialMessage<UserConversionEvent_UserConversionEventParam>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.UserConversionEvent.UserConversionEventParam";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserConversionEvent_UserConversionEventParam {
    return new UserConversionEvent_UserConversionEventParam().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserConversionEvent_UserConversionEventParam {
    return new UserConversionEvent_UserConversionEventParam().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserConversionEvent_UserConversionEventParam {
    return new UserConversionEvent_UserConversionEventParam().fromJsonString(jsonString, options);
  }

  static equals(a: UserConversionEvent_UserConversionEventParam | PlainMessage<UserConversionEvent_UserConversionEventParam> | undefined, b: UserConversionEvent_UserConversionEventParam | PlainMessage<UserConversionEvent_UserConversionEventParam> | undefined): boolean {
    return proto3.util.equals(UserConversionEvent_UserConversionEventParam, a, b);
  }
}

/**
 * Occurs on conversion was delivered.
 * ebus:message
 *
 * @generated from message gdx.events.v1.UserConversionDeliveredEvent
 */
export class UserConversionDeliveredEvent extends Message<UserConversionDeliveredEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string conversion = 2;
   */
  conversion = "";

  /**
   * @generated from field: string network = 3;
   */
  network = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 4;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<UserConversionDeliveredEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.UserConversionDeliveredEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "conversion", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "network", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserConversionDeliveredEvent {
    return new UserConversionDeliveredEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserConversionDeliveredEvent {
    return new UserConversionDeliveredEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserConversionDeliveredEvent {
    return new UserConversionDeliveredEvent().fromJsonString(jsonString, options);
  }

  static equals(a: UserConversionDeliveredEvent | PlainMessage<UserConversionDeliveredEvent> | undefined, b: UserConversionDeliveredEvent | PlainMessage<UserConversionDeliveredEvent> | undefined): boolean {
    return proto3.util.equals(UserConversionDeliveredEvent, a, b);
  }
}

/**
 * Occurs when test campaign user detected.
 * ebus:message
 *
 * @generated from message gdx.events.v1.TestCampaignUserDetectedEvent
 */
export class TestCampaignUserDetectedEvent extends Message<TestCampaignUserDetectedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  constructor(data?: PartialMessage<TestCampaignUserDetectedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.TestCampaignUserDetectedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TestCampaignUserDetectedEvent {
    return new TestCampaignUserDetectedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TestCampaignUserDetectedEvent {
    return new TestCampaignUserDetectedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TestCampaignUserDetectedEvent {
    return new TestCampaignUserDetectedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: TestCampaignUserDetectedEvent | PlainMessage<TestCampaignUserDetectedEvent> | undefined, b: TestCampaignUserDetectedEvent | PlainMessage<TestCampaignUserDetectedEvent> | undefined): boolean {
    return proto3.util.equals(TestCampaignUserDetectedEvent, a, b);
  }
}

/**
 * Occurs on user boosted.
 * ebus:message
 *
 * @generated from message gdx.events.v1.BoosterPurchasedEvent
 */
export class BoosterPurchasedEvent extends Message<BoosterPurchasedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string type = 2;
   */
  type = "";

  /**
   * @generated from field: google.protobuf.Duration duration = 3;
   */
  duration?: Duration;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 5;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<BoosterPurchasedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.BoosterPurchasedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "duration", kind: "message", T: Duration },
    { no: 5, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BoosterPurchasedEvent {
    return new BoosterPurchasedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BoosterPurchasedEvent {
    return new BoosterPurchasedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BoosterPurchasedEvent {
    return new BoosterPurchasedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: BoosterPurchasedEvent | PlainMessage<BoosterPurchasedEvent> | undefined, b: BoosterPurchasedEvent | PlainMessage<BoosterPurchasedEvent> | undefined): boolean {
    return proto3.util.equals(BoosterPurchasedEvent, a, b);
  }
}

/**
 * Occurs on user buy some possibilities.
 * ebus:message
 *
 * @generated from message gdx.events.v1.PossibilitiesPurchasedEvent
 */
export class PossibilitiesPurchasedEvent extends Message<PossibilitiesPurchasedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * purchased possibilities
   *
   * @generated from field: repeated gdx.gateway.web.possibilities.v1.Possibility possibilities = 2;
   */
  possibilities: Possibility[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 3;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<PossibilitiesPurchasedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.PossibilitiesPurchasedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "possibilities", kind: "message", T: Possibility, repeated: true },
    { no: 3, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PossibilitiesPurchasedEvent {
    return new PossibilitiesPurchasedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PossibilitiesPurchasedEvent {
    return new PossibilitiesPurchasedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PossibilitiesPurchasedEvent {
    return new PossibilitiesPurchasedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: PossibilitiesPurchasedEvent | PlainMessage<PossibilitiesPurchasedEvent> | undefined, b: PossibilitiesPurchasedEvent | PlainMessage<PossibilitiesPurchasedEvent> | undefined): boolean {
    return proto3.util.equals(PossibilitiesPurchasedEvent, a, b);
  }
}

/**
 * Occurs on user's possibilities was updated.
 * ebus:message
 *
 * @generated from message gdx.events.v1.PossibilitiesUpdatedEvent
 */
export class PossibilitiesUpdatedEvent extends Message<PossibilitiesUpdatedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * actual possibilities
   *
   * @generated from field: repeated gdx.gateway.web.possibilities.v1.Possibility possibilities = 2;
   */
  possibilities: Possibility[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 3;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<PossibilitiesUpdatedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.PossibilitiesUpdatedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "possibilities", kind: "message", T: Possibility, repeated: true },
    { no: 3, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PossibilitiesUpdatedEvent {
    return new PossibilitiesUpdatedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PossibilitiesUpdatedEvent {
    return new PossibilitiesUpdatedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PossibilitiesUpdatedEvent {
    return new PossibilitiesUpdatedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: PossibilitiesUpdatedEvent | PlainMessage<PossibilitiesUpdatedEvent> | undefined, b: PossibilitiesUpdatedEvent | PlainMessage<PossibilitiesUpdatedEvent> | undefined): boolean {
    return proto3.util.equals(PossibilitiesUpdatedEvent, a, b);
  }
}

/**
 * Occurs on credit card added event.
 * ebus:message
 *
 * @generated from message gdx.events.v1.CreditCardAddedEvent
 */
export class CreditCardAddedEvent extends Message<CreditCardAddedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string brand = 2;
   */
  brand = "";

  /**
   * @generated from field: string id = 3;
   */
  id = "";

  /**
   * @generated from field: string number = 4;
   */
  number = "";

  /**
   * @generated from field: string source = 5;
   */
  source = "";

  /**
   * @generated from field: string type = 6;
   */
  type = "";

  /**
   * @generated from field: gdx.gateway.web.payment.v2.PaymentGateway gateway = 7;
   */
  gateway = PaymentGateway.INVALID;

  constructor(data?: PartialMessage<CreditCardAddedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.CreditCardAddedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "brand", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "gateway", kind: "enum", T: proto3.getEnumType(PaymentGateway) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditCardAddedEvent {
    return new CreditCardAddedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditCardAddedEvent {
    return new CreditCardAddedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditCardAddedEvent {
    return new CreditCardAddedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: CreditCardAddedEvent | PlainMessage<CreditCardAddedEvent> | undefined, b: CreditCardAddedEvent | PlainMessage<CreditCardAddedEvent> | undefined): boolean {
    return proto3.util.equals(CreditCardAddedEvent, a, b);
  }
}

/**
 * Occurs on credit card removed event.
 * ebus:message
 *
 * @generated from message gdx.events.v1.CreditCardRemovedEvent
 */
export class CreditCardRemovedEvent extends Message<CreditCardRemovedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string number = 4;
   */
  number = "";

  constructor(data?: PartialMessage<CreditCardRemovedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.CreditCardRemovedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditCardRemovedEvent {
    return new CreditCardRemovedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditCardRemovedEvent {
    return new CreditCardRemovedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditCardRemovedEvent {
    return new CreditCardRemovedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: CreditCardRemovedEvent | PlainMessage<CreditCardRemovedEvent> | undefined, b: CreditCardRemovedEvent | PlainMessage<CreditCardRemovedEvent> | undefined): boolean {
    return proto3.util.equals(CreditCardRemovedEvent, a, b);
  }
}

/**
 * Occurs on credits updated.
 * ebus:message
 *
 * @generated from message gdx.events.v1.CreditsUpdatedEvent
 */
export class CreditsUpdatedEvent extends Message<CreditsUpdatedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: int64 initial_amount = 7;
   */
  initialAmount = protoInt64.zero;

  /**
   * @generated from field: int64 current_amount = 2;
   */
  currentAmount = protoInt64.zero;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 3;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: string ext_order_id = 4;
   */
  extOrderId = "";

  /**
   * @generated from field: repeated gdx.events.v1.CreditsUpdatedEvent.Extra extra = 6;
   */
  extra: CreditsUpdatedEvent_Extra[] = [];

  /**
   * @generated from field: int64 action_type = 5;
   */
  actionType = protoInt64.zero;

  constructor(data?: PartialMessage<CreditsUpdatedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.CreditsUpdatedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "initial_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "current_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "created_time", kind: "message", T: Timestamp },
    { no: 4, name: "ext_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "extra", kind: "message", T: CreditsUpdatedEvent_Extra, repeated: true },
    { no: 5, name: "action_type", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditsUpdatedEvent {
    return new CreditsUpdatedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditsUpdatedEvent {
    return new CreditsUpdatedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditsUpdatedEvent {
    return new CreditsUpdatedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: CreditsUpdatedEvent | PlainMessage<CreditsUpdatedEvent> | undefined, b: CreditsUpdatedEvent | PlainMessage<CreditsUpdatedEvent> | undefined): boolean {
    return proto3.util.equals(CreditsUpdatedEvent, a, b);
  }
}

/**
 * Params.
 *
 * @generated from message gdx.events.v1.CreditsUpdatedEvent.Extra
 */
export class CreditsUpdatedEvent_Extra extends Message<CreditsUpdatedEvent_Extra> {
  /**
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * @generated from field: string value = 2;
   */
  value = "";

  constructor(data?: PartialMessage<CreditsUpdatedEvent_Extra>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.CreditsUpdatedEvent.Extra";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditsUpdatedEvent_Extra {
    return new CreditsUpdatedEvent_Extra().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditsUpdatedEvent_Extra {
    return new CreditsUpdatedEvent_Extra().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditsUpdatedEvent_Extra {
    return new CreditsUpdatedEvent_Extra().fromJsonString(jsonString, options);
  }

  static equals(a: CreditsUpdatedEvent_Extra | PlainMessage<CreditsUpdatedEvent_Extra> | undefined, b: CreditsUpdatedEvent_Extra | PlainMessage<CreditsUpdatedEvent_Extra> | undefined): boolean {
    return proto3.util.equals(CreditsUpdatedEvent_Extra, a, b);
  }
}

/**
 * Occurs on credits refilled.
 * ebus:message
 *
 * @generated from message gdx.events.v1.CreditsRefilledEvent
 */
export class CreditsRefilledEvent extends Message<CreditsRefilledEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: int64 initial_amount = 2;
   */
  initialAmount = protoInt64.zero;

  /**
   * @generated from field: int64 current_amount = 3;
   */
  currentAmount = protoInt64.zero;

  /**
   * @generated from field: string ext_order_id = 4;
   */
  extOrderId = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 5;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<CreditsRefilledEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.CreditsRefilledEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "initial_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "current_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "ext_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditsRefilledEvent {
    return new CreditsRefilledEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditsRefilledEvent {
    return new CreditsRefilledEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditsRefilledEvent {
    return new CreditsRefilledEvent().fromJsonString(jsonString, options);
  }

  static equals(a: CreditsRefilledEvent | PlainMessage<CreditsRefilledEvent> | undefined, b: CreditsRefilledEvent | PlainMessage<CreditsRefilledEvent> | undefined): boolean {
    return proto3.util.equals(CreditsRefilledEvent, a, b);
  }
}

/**
 * Occurs on credits refill failed.
 * ebus:message
 *
 * @generated from message gdx.events.v1.CreditsRefillFailedEvent
 */
export class CreditsRefillFailedEvent extends Message<CreditsRefillFailedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 2;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: int64 action_type = 3;
   */
  actionType = protoInt64.zero;

  /**
   * @generated from field: string ext_order_id = 4;
   */
  extOrderId = "";

  /**
   * @generated from field: repeated gdx.events.v1.CreditsRefillFailedEvent.Extra extra = 6;
   */
  extra: CreditsRefillFailedEvent_Extra[] = [];

  constructor(data?: PartialMessage<CreditsRefillFailedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.CreditsRefillFailedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "created_time", kind: "message", T: Timestamp },
    { no: 3, name: "action_type", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "ext_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "extra", kind: "message", T: CreditsRefillFailedEvent_Extra, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditsRefillFailedEvent {
    return new CreditsRefillFailedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditsRefillFailedEvent {
    return new CreditsRefillFailedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditsRefillFailedEvent {
    return new CreditsRefillFailedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: CreditsRefillFailedEvent | PlainMessage<CreditsRefillFailedEvent> | undefined, b: CreditsRefillFailedEvent | PlainMessage<CreditsRefillFailedEvent> | undefined): boolean {
    return proto3.util.equals(CreditsRefillFailedEvent, a, b);
  }
}

/**
 * Params.
 *
 * @generated from message gdx.events.v1.CreditsRefillFailedEvent.Extra
 */
export class CreditsRefillFailedEvent_Extra extends Message<CreditsRefillFailedEvent_Extra> {
  /**
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * @generated from field: string value = 2;
   */
  value = "";

  constructor(data?: PartialMessage<CreditsRefillFailedEvent_Extra>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.CreditsRefillFailedEvent.Extra";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditsRefillFailedEvent_Extra {
    return new CreditsRefillFailedEvent_Extra().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditsRefillFailedEvent_Extra {
    return new CreditsRefillFailedEvent_Extra().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditsRefillFailedEvent_Extra {
    return new CreditsRefillFailedEvent_Extra().fromJsonString(jsonString, options);
  }

  static equals(a: CreditsRefillFailedEvent_Extra | PlainMessage<CreditsRefillFailedEvent_Extra> | undefined, b: CreditsRefillFailedEvent_Extra | PlainMessage<CreditsRefillFailedEvent_Extra> | undefined): boolean {
    return proto3.util.equals(CreditsRefillFailedEvent_Extra, a, b);
  }
}

/**
 * Occurs on credits aurefillrefill setting changed.
 * ebus:message
 *
 * @generated from message gdx.events.v1.ProfileSettingsUpdatedEvent
 */
export class ProfileSettingsUpdatedEvent extends Message<ProfileSettingsUpdatedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: gdx.events.v1.ProfileSettingsUpdatedEvent.Settings settings = 2;
   */
  settings?: ProfileSettingsUpdatedEvent_Settings;

  /**
   * @generated from field: gdx.events.v1.ProfileSettingsUpdatedEvent.Settings prev_settings = 3;
   */
  prevSettings?: ProfileSettingsUpdatedEvent_Settings;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 4;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<ProfileSettingsUpdatedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ProfileSettingsUpdatedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "settings", kind: "message", T: ProfileSettingsUpdatedEvent_Settings },
    { no: 3, name: "prev_settings", kind: "message", T: ProfileSettingsUpdatedEvent_Settings },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileSettingsUpdatedEvent {
    return new ProfileSettingsUpdatedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileSettingsUpdatedEvent {
    return new ProfileSettingsUpdatedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileSettingsUpdatedEvent {
    return new ProfileSettingsUpdatedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileSettingsUpdatedEvent | PlainMessage<ProfileSettingsUpdatedEvent> | undefined, b: ProfileSettingsUpdatedEvent | PlainMessage<ProfileSettingsUpdatedEvent> | undefined): boolean {
    return proto3.util.equals(ProfileSettingsUpdatedEvent, a, b);
  }
}

/**
 * Describes profile settings.
 *
 * @generated from message gdx.events.v1.ProfileSettingsUpdatedEvent.Settings
 */
export class ProfileSettingsUpdatedEvent_Settings extends Message<ProfileSettingsUpdatedEvent_Settings> {
  /**
   * @generated from field: bool is_verified = 1;
   */
  isVerified = false;

  /**
   * @generated from field: repeated string verified_by = 2;
   */
  verifiedBy: string[] = [];

  /**
   * @generated from field: bool is_highlighted = 3;
   */
  isHighlighted = false;

  /**
   * @generated from field: bool is_online_status_hidden = 4;
   */
  isOnlineStatusHidden = false;

  /**
   * @generated from field: bool is_profile_hidden_in_search = 5;
   */
  isProfileHiddenInSearch = false;

  /**
   * @generated from field: bool are_photos_blurred = 6;
   */
  arePhotosBlurred = false;

  /**
   * @generated from field: bool is_my_activity_hidden = 7;
   */
  isMyActivityHidden = false;

  /**
   * @generated from field: bool are_web_push_notifications_enabled = 8;
   */
  areWebPushNotificationsEnabled = false;

  /**
   * @generated from field: string interface_language = 9;
   */
  interfaceLanguage = "";

  /**
   * @generated from field: int32 initially_uploaded_photos = 10;
   */
  initiallyUploadedPhotos = 0;

  /**
   * @generated from field: bool shadow_ban = 11;
   */
  shadowBan = false;

  constructor(data?: PartialMessage<ProfileSettingsUpdatedEvent_Settings>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ProfileSettingsUpdatedEvent.Settings";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "is_verified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "verified_by", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "is_highlighted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "is_online_status_hidden", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "is_profile_hidden_in_search", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "are_photos_blurred", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "is_my_activity_hidden", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "are_web_push_notifications_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "interface_language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "initially_uploaded_photos", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "shadow_ban", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileSettingsUpdatedEvent_Settings {
    return new ProfileSettingsUpdatedEvent_Settings().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileSettingsUpdatedEvent_Settings {
    return new ProfileSettingsUpdatedEvent_Settings().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileSettingsUpdatedEvent_Settings {
    return new ProfileSettingsUpdatedEvent_Settings().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileSettingsUpdatedEvent_Settings | PlainMessage<ProfileSettingsUpdatedEvent_Settings> | undefined, b: ProfileSettingsUpdatedEvent_Settings | PlainMessage<ProfileSettingsUpdatedEvent_Settings> | undefined): boolean {
    return proto3.util.equals(ProfileSettingsUpdatedEvent_Settings, a, b);
  }
}

/**
 * Occurs on credits aurefillrefill setting changed.
 * ebus:message
 *
 * @generated from message gdx.events.v1.CreditsAutorefillUpdatedEvent
 */
export class CreditsAutorefillUpdatedEvent extends Message<CreditsAutorefillUpdatedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: bool is_autorefill_enabled = 2;
   */
  isAutorefillEnabled = false;

  constructor(data?: PartialMessage<CreditsAutorefillUpdatedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.CreditsAutorefillUpdatedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_autorefill_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditsAutorefillUpdatedEvent {
    return new CreditsAutorefillUpdatedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditsAutorefillUpdatedEvent {
    return new CreditsAutorefillUpdatedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditsAutorefillUpdatedEvent {
    return new CreditsAutorefillUpdatedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: CreditsAutorefillUpdatedEvent | PlainMessage<CreditsAutorefillUpdatedEvent> | undefined, b: CreditsAutorefillUpdatedEvent | PlainMessage<CreditsAutorefillUpdatedEvent> | undefined): boolean {
    return proto3.util.equals(CreditsAutorefillUpdatedEvent, a, b);
  }
}

/**
 * Notify about mail event.
 * ebus:message
 *
 * @generated from message gdx.events.v1.MailStatusEvent
 */
export class MailStatusEvent extends Message<MailStatusEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string mail_id = 2;
   */
  mailId = "";

  /**
   * @generated from field: string source = 3;
   */
  source = "";

  /**
   * @generated from field: string status = 4;
   */
  status = "";

  /**
   * @generated from field: repeated gdx.events.v1.MailStatusEvent.MailStatusEventCampaign campaigns = 5;
   */
  campaigns: MailStatusEvent_MailStatusEventCampaign[] = [];

  /**
   * @generated from field: repeated string tags = 6;
   */
  tags: string[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 10;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<MailStatusEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.MailStatusEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "mail_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "campaigns", kind: "message", T: MailStatusEvent_MailStatusEventCampaign, repeated: true },
    { no: 6, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MailStatusEvent {
    return new MailStatusEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MailStatusEvent {
    return new MailStatusEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MailStatusEvent {
    return new MailStatusEvent().fromJsonString(jsonString, options);
  }

  static equals(a: MailStatusEvent | PlainMessage<MailStatusEvent> | undefined, b: MailStatusEvent | PlainMessage<MailStatusEvent> | undefined): boolean {
    return proto3.util.equals(MailStatusEvent, a, b);
  }
}

/**
 * Campaigns.
 *
 * @generated from message gdx.events.v1.MailStatusEvent.MailStatusEventCampaign
 */
export class MailStatusEvent_MailStatusEventCampaign extends Message<MailStatusEvent_MailStatusEventCampaign> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  constructor(data?: PartialMessage<MailStatusEvent_MailStatusEventCampaign>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.MailStatusEvent.MailStatusEventCampaign";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MailStatusEvent_MailStatusEventCampaign {
    return new MailStatusEvent_MailStatusEventCampaign().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MailStatusEvent_MailStatusEventCampaign {
    return new MailStatusEvent_MailStatusEventCampaign().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MailStatusEvent_MailStatusEventCampaign {
    return new MailStatusEvent_MailStatusEventCampaign().fromJsonString(jsonString, options);
  }

  static equals(a: MailStatusEvent_MailStatusEventCampaign | PlainMessage<MailStatusEvent_MailStatusEventCampaign> | undefined, b: MailStatusEvent_MailStatusEventCampaign | PlainMessage<MailStatusEvent_MailStatusEventCampaign> | undefined): boolean {
    return proto3.util.equals(MailStatusEvent_MailStatusEventCampaign, a, b);
  }
}

/**
 * Occurs when team member session status is changing.
 * ebus:message
 *
 * @generated from message gdx.events.v1.TeamMemberSessionStatusChangedEvent
 */
export class TeamMemberSessionStatusChangedEvent extends Message<TeamMemberSessionStatusChangedEvent> {
  /**
   * @generated from field: string team_member_email = 1;
   */
  teamMemberEmail = "";

  /**
   * @generated from field: string team_member_id = 2;
   */
  teamMemberId = "";

  /**
   * @generated from field: gdx.events.v1.TeamMemberSessionStatusChangedEvent.Status status = 3;
   */
  status = TeamMemberSessionStatusChangedEvent_Status.INVALID;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 4;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<TeamMemberSessionStatusChangedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.TeamMemberSessionStatusChangedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "team_member_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_member_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(TeamMemberSessionStatusChangedEvent_Status) },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeamMemberSessionStatusChangedEvent {
    return new TeamMemberSessionStatusChangedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeamMemberSessionStatusChangedEvent {
    return new TeamMemberSessionStatusChangedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeamMemberSessionStatusChangedEvent {
    return new TeamMemberSessionStatusChangedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: TeamMemberSessionStatusChangedEvent | PlainMessage<TeamMemberSessionStatusChangedEvent> | undefined, b: TeamMemberSessionStatusChangedEvent | PlainMessage<TeamMemberSessionStatusChangedEvent> | undefined): boolean {
    return proto3.util.equals(TeamMemberSessionStatusChangedEvent, a, b);
  }
}

/**
 * Enumerates possible session statuses for team member.
 *
 * @generated from enum gdx.events.v1.TeamMemberSessionStatusChangedEvent.Status
 */
export enum TeamMemberSessionStatusChangedEvent_Status {
  /**
   * @generated from enum value: STATUS_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: STATUS_ON_BREAK = 2;
   */
  ON_BREAK = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(TeamMemberSessionStatusChangedEvent_Status)
proto3.util.setEnumType(TeamMemberSessionStatusChangedEvent_Status, "gdx.events.v1.TeamMemberSessionStatusChangedEvent.Status", [
  { no: 0, name: "STATUS_INVALID" },
  { no: 1, name: "STATUS_ACTIVE" },
  { no: 2, name: "STATUS_ON_BREAK" },
]);

/**
 * Occurs when uploaded photo declined by moderator, AI, etc.
 * ebus:message
 *
 * @generated from message gdx.events.v1.ProfilePhotoModerationDeclinedEvent
 */
export class ProfilePhotoModerationDeclinedEvent extends Message<ProfilePhotoModerationDeclinedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string photo_id = 2;
   */
  photoId = "";

  /**
   * @generated from field: string reason_description = 3;
   */
  reasonDescription = "";

  /**
   * @generated from field: gdx.backoffice.service.newprofiles.v1.ActorType actor_type = 4;
   */
  actorType = ActorType.INVALID;

  constructor(data?: PartialMessage<ProfilePhotoModerationDeclinedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ProfilePhotoModerationDeclinedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "photo_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "reason_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "actor_type", kind: "enum", T: proto3.getEnumType(ActorType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfilePhotoModerationDeclinedEvent {
    return new ProfilePhotoModerationDeclinedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfilePhotoModerationDeclinedEvent {
    return new ProfilePhotoModerationDeclinedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfilePhotoModerationDeclinedEvent {
    return new ProfilePhotoModerationDeclinedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ProfilePhotoModerationDeclinedEvent | PlainMessage<ProfilePhotoModerationDeclinedEvent> | undefined, b: ProfilePhotoModerationDeclinedEvent | PlainMessage<ProfilePhotoModerationDeclinedEvent> | undefined): boolean {
    return proto3.util.equals(ProfilePhotoModerationDeclinedEvent, a, b);
  }
}

/**
 * Occurs when uploaded photo approved by moderator, AI, etc.
 * ebus:message
 *
 * @generated from message gdx.events.v1.ProfilePhotoModerationApprovedEvent
 */
export class ProfilePhotoModerationApprovedEvent extends Message<ProfilePhotoModerationApprovedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string photo_id = 2;
   */
  photoId = "";

  /**
   * @generated from field: gdx.backoffice.service.newprofiles.v1.ActorType actor_type = 4;
   */
  actorType = ActorType.INVALID;

  constructor(data?: PartialMessage<ProfilePhotoModerationApprovedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ProfilePhotoModerationApprovedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "photo_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "actor_type", kind: "enum", T: proto3.getEnumType(ActorType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfilePhotoModerationApprovedEvent {
    return new ProfilePhotoModerationApprovedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfilePhotoModerationApprovedEvent {
    return new ProfilePhotoModerationApprovedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfilePhotoModerationApprovedEvent {
    return new ProfilePhotoModerationApprovedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ProfilePhotoModerationApprovedEvent | PlainMessage<ProfilePhotoModerationApprovedEvent> | undefined, b: ProfilePhotoModerationApprovedEvent | PlainMessage<ProfilePhotoModerationApprovedEvent> | undefined): boolean {
    return proto3.util.equals(ProfilePhotoModerationApprovedEvent, a, b);
  }
}

/**
 * Occurs on any likes count update after view updated.
 * ebus:message
 *
 * @generated from message gdx.events.v1.ProfileLikesCountViewUpdatedEvent
 */
export class ProfileLikesCountViewUpdatedEvent extends Message<ProfileLikesCountViewUpdatedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: uint32 likes_count = 2;
   */
  likesCount = 0;

  constructor(data?: PartialMessage<ProfileLikesCountViewUpdatedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ProfileLikesCountViewUpdatedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "likes_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileLikesCountViewUpdatedEvent {
    return new ProfileLikesCountViewUpdatedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileLikesCountViewUpdatedEvent {
    return new ProfileLikesCountViewUpdatedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileLikesCountViewUpdatedEvent {
    return new ProfileLikesCountViewUpdatedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileLikesCountViewUpdatedEvent | PlainMessage<ProfileLikesCountViewUpdatedEvent> | undefined, b: ProfileLikesCountViewUpdatedEvent | PlainMessage<ProfileLikesCountViewUpdatedEvent> | undefined): boolean {
    return proto3.util.equals(ProfileLikesCountViewUpdatedEvent, a, b);
  }
}

/**
 * Occurs on any unread messages count update after view updated.
 * ebus:message
 *
 * @generated from message gdx.events.v1.ProfileUnreadMessagesCountViewUpdatedEvent
 */
export class ProfileUnreadMessagesCountViewUpdatedEvent extends Message<ProfileUnreadMessagesCountViewUpdatedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: uint32 unread_messages_count = 2;
   */
  unreadMessagesCount = 0;

  constructor(data?: PartialMessage<ProfileUnreadMessagesCountViewUpdatedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ProfileUnreadMessagesCountViewUpdatedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "unread_messages_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileUnreadMessagesCountViewUpdatedEvent {
    return new ProfileUnreadMessagesCountViewUpdatedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileUnreadMessagesCountViewUpdatedEvent {
    return new ProfileUnreadMessagesCountViewUpdatedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileUnreadMessagesCountViewUpdatedEvent {
    return new ProfileUnreadMessagesCountViewUpdatedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileUnreadMessagesCountViewUpdatedEvent | PlainMessage<ProfileUnreadMessagesCountViewUpdatedEvent> | undefined, b: ProfileUnreadMessagesCountViewUpdatedEvent | PlainMessage<ProfileUnreadMessagesCountViewUpdatedEvent> | undefined): boolean {
    return proto3.util.equals(ProfileUnreadMessagesCountViewUpdatedEvent, a, b);
  }
}

/**
 * Occurs on premium subscription activation after view updated.
 * ebus:message
 *
 * @generated from message gdx.events.v1.SubscriptionViewUpdatedEvent
 */
export class SubscriptionViewUpdatedEvent extends Message<SubscriptionViewUpdatedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: google.protobuf.Timestamp expires_at_time = 2;
   */
  expiresAtTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 3;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<SubscriptionViewUpdatedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.SubscriptionViewUpdatedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "expires_at_time", kind: "message", T: Timestamp },
    { no: 3, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubscriptionViewUpdatedEvent {
    return new SubscriptionViewUpdatedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubscriptionViewUpdatedEvent {
    return new SubscriptionViewUpdatedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubscriptionViewUpdatedEvent {
    return new SubscriptionViewUpdatedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: SubscriptionViewUpdatedEvent | PlainMessage<SubscriptionViewUpdatedEvent> | undefined, b: SubscriptionViewUpdatedEvent | PlainMessage<SubscriptionViewUpdatedEvent> | undefined): boolean {
    return proto3.util.equals(SubscriptionViewUpdatedEvent, a, b);
  }
}

/**
 * Occurs on each subscription update.
 * ebus:message
 *
 * @generated from message gdx.events.v1.SubscriptionUpdatedEvent
 */
export class SubscriptionUpdatedEvent extends Message<SubscriptionUpdatedEvent> {
  /**
   * @generated from field: gdx.gateway.web.payment.v2.Subscription subscription = 1;
   */
  subscription?: Subscription;

  /**
   * @generated from field: gdx.gateway.web.payment.v2.Subscription prev_subscription_state = 3;
   */
  prevSubscriptionState?: Subscription;

  /**
   * @generated from field: string user_id = 2;
   */
  userId = "";

  /**
   * @generated from field: gdx.gateway.web.payment.v2.CommandSourceType source_type = 4;
   */
  sourceType = CommandSourceType.INVALID;

  constructor(data?: PartialMessage<SubscriptionUpdatedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.SubscriptionUpdatedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subscription", kind: "message", T: Subscription },
    { no: 3, name: "prev_subscription_state", kind: "message", T: Subscription },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "source_type", kind: "enum", T: proto3.getEnumType(CommandSourceType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubscriptionUpdatedEvent {
    return new SubscriptionUpdatedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubscriptionUpdatedEvent {
    return new SubscriptionUpdatedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubscriptionUpdatedEvent {
    return new SubscriptionUpdatedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: SubscriptionUpdatedEvent | PlainMessage<SubscriptionUpdatedEvent> | undefined, b: SubscriptionUpdatedEvent | PlainMessage<SubscriptionUpdatedEvent> | undefined): boolean {
    return proto3.util.equals(SubscriptionUpdatedEvent, a, b);
  }
}

/**
 * Occurs on each subscription payment success.
 * ebus:message
 *
 * @generated from message gdx.events.v1.SubscriptionPaymentSuccessEvent
 */
export class SubscriptionPaymentSuccessEvent extends Message<SubscriptionPaymentSuccessEvent> {
  /**
   * @generated from field: string order_id = 1;
   */
  orderId = "";

  /**
   * @generated from field: string order_descriptor = 7;
   */
  orderDescriptor = "";

  /**
   * @generated from field: string user_id = 2;
   */
  userId = "";

  /**
   * @generated from field: string next_package_id = 9;
   */
  nextPackageId = "";

  /**
   * @generated from field: string card_number = 11;
   */
  cardNumber = "";

  /**
   * @generated from field: string card_brand = 12;
   */
  cardBrand = "";

  /**
   * @generated from field: gdx.gateway.web.payment.v2.PaymentGateway gateway = 10;
   */
  gateway = PaymentGateway.INVALID;

  /**
   * @generated from field: gdx.events.v1.Package package = 6;
   */
  package?: Package;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 4;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: gdx.gateway.web.payment.v2.ChargeType charge_type = 5;
   */
  chargeType = ChargeType.INVALID;

  /**
   * @generated from field: google.protobuf.Timestamp override_expiration_time = 8;
   */
  overrideExpirationTime?: Timestamp;

  constructor(data?: PartialMessage<SubscriptionPaymentSuccessEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.SubscriptionPaymentSuccessEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "order_descriptor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "next_package_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "card_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "card_brand", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "gateway", kind: "enum", T: proto3.getEnumType(PaymentGateway) },
    { no: 6, name: "package", kind: "message", T: Package },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
    { no: 5, name: "charge_type", kind: "enum", T: proto3.getEnumType(ChargeType) },
    { no: 8, name: "override_expiration_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubscriptionPaymentSuccessEvent {
    return new SubscriptionPaymentSuccessEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubscriptionPaymentSuccessEvent {
    return new SubscriptionPaymentSuccessEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubscriptionPaymentSuccessEvent {
    return new SubscriptionPaymentSuccessEvent().fromJsonString(jsonString, options);
  }

  static equals(a: SubscriptionPaymentSuccessEvent | PlainMessage<SubscriptionPaymentSuccessEvent> | undefined, b: SubscriptionPaymentSuccessEvent | PlainMessage<SubscriptionPaymentSuccessEvent> | undefined): boolean {
    return proto3.util.equals(SubscriptionPaymentSuccessEvent, a, b);
  }
}

/**
 * Occurs on each subscription payment fail.
 * ebus:message
 *
 * @generated from message gdx.events.v1.SubscriptionPaymentFailedEvent
 */
export class SubscriptionPaymentFailedEvent extends Message<SubscriptionPaymentFailedEvent> {
  /**
   * @generated from field: string order_id = 1;
   */
  orderId = "";

  /**
   * @generated from field: string order_error = 8;
   */
  orderError = "";

  /**
   * @generated from field: string order_message = 9;
   */
  orderMessage = "";

  /**
   * @generated from field: string user_id = 2;
   */
  userId = "";

  /**
   * @generated from field: string card_number = 10;
   */
  cardNumber = "";

  /**
   * @generated from field: string card_brand = 12;
   */
  cardBrand = "";

  /**
   * @generated from field: gdx.gateway.web.payment.v2.PaymentGateway gateway = 11;
   */
  gateway = PaymentGateway.INVALID;

  /**
   * @generated from field: gdx.events.v1.Package package = 7;
   */
  package?: Package;

  /**
   * @generated from field: google.protobuf.Timestamp next_charge_time = 4;
   */
  nextChargeTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 5;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: gdx.gateway.web.payment.v2.ChargeType charge_type = 6;
   */
  chargeType = ChargeType.INVALID;

  constructor(data?: PartialMessage<SubscriptionPaymentFailedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.SubscriptionPaymentFailedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "order_error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "order_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "card_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "card_brand", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "gateway", kind: "enum", T: proto3.getEnumType(PaymentGateway) },
    { no: 7, name: "package", kind: "message", T: Package },
    { no: 4, name: "next_charge_time", kind: "message", T: Timestamp },
    { no: 5, name: "created_time", kind: "message", T: Timestamp },
    { no: 6, name: "charge_type", kind: "enum", T: proto3.getEnumType(ChargeType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubscriptionPaymentFailedEvent {
    return new SubscriptionPaymentFailedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubscriptionPaymentFailedEvent {
    return new SubscriptionPaymentFailedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubscriptionPaymentFailedEvent {
    return new SubscriptionPaymentFailedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: SubscriptionPaymentFailedEvent | PlainMessage<SubscriptionPaymentFailedEvent> | undefined, b: SubscriptionPaymentFailedEvent | PlainMessage<SubscriptionPaymentFailedEvent> | undefined): boolean {
    return proto3.util.equals(SubscriptionPaymentFailedEvent, a, b);
  }
}

/**
 * Occurs on user unsubscribe premium autoprolongation.
 * ebus:message
 *
 * @generated from message gdx.events.v1.UnsubscribedEvent
 */
export class UnsubscribedEvent extends Message<UnsubscribedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string package_id = 3;
   */
  packageId = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 2;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: gdx.backoffice.service.newprofiles.v1.ActorType actor_type = 4;
   */
  actorType = ActorType.INVALID;

  constructor(data?: PartialMessage<UnsubscribedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.UnsubscribedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "package_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "created_time", kind: "message", T: Timestamp },
    { no: 4, name: "actor_type", kind: "enum", T: proto3.getEnumType(ActorType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UnsubscribedEvent {
    return new UnsubscribedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UnsubscribedEvent {
    return new UnsubscribedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UnsubscribedEvent {
    return new UnsubscribedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: UnsubscribedEvent | PlainMessage<UnsubscribedEvent> | undefined, b: UnsubscribedEvent | PlainMessage<UnsubscribedEvent> | undefined): boolean {
    return proto3.util.equals(UnsubscribedEvent, a, b);
  }
}

/**
 * Reason to send notification about future payment to user.
 * ebus:message
 *
 * @generated from message gdx.events.v1.FuturePaymentNotifyEvent
 */
export class FuturePaymentNotifyEvent extends Message<FuturePaymentNotifyEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string package_id = 2;
   */
  packageId = "";

  /**
   * @generated from field: gdx.gateway.web.payment.v2.Governor governor = 3;
   */
  governor = Governor.INVALID;

  /**
   * @generated from field: string order_descriptor = 6;
   */
  orderDescriptor = "";

  /**
   * @generated from field: bool is_organic_user = 7;
   */
  isOrganicUser = false;

  /**
   * @generated from field: string card_number = 8;
   */
  cardNumber = "";

  /**
   * @generated from field: google.protobuf.Timestamp renewal_time = 4;
   */
  renewalTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 5;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<FuturePaymentNotifyEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.FuturePaymentNotifyEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "package_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "governor", kind: "enum", T: proto3.getEnumType(Governor) },
    { no: 6, name: "order_descriptor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "is_organic_user", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "card_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "renewal_time", kind: "message", T: Timestamp },
    { no: 5, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FuturePaymentNotifyEvent {
    return new FuturePaymentNotifyEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FuturePaymentNotifyEvent {
    return new FuturePaymentNotifyEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FuturePaymentNotifyEvent {
    return new FuturePaymentNotifyEvent().fromJsonString(jsonString, options);
  }

  static equals(a: FuturePaymentNotifyEvent | PlainMessage<FuturePaymentNotifyEvent> | undefined, b: FuturePaymentNotifyEvent | PlainMessage<FuturePaymentNotifyEvent> | undefined): boolean {
    return proto3.util.equals(FuturePaymentNotifyEvent, a, b);
  }
}

/**
 * Occurs when back-end should notify clients about promos.
 * ebus:message
 *
 * @generated from message gdx.events.v1.ShowPromosForUserEvent
 */
export class ShowPromosForUserEvent extends Message<ShowPromosForUserEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  constructor(data?: PartialMessage<ShowPromosForUserEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ShowPromosForUserEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ShowPromosForUserEvent {
    return new ShowPromosForUserEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ShowPromosForUserEvent {
    return new ShowPromosForUserEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ShowPromosForUserEvent {
    return new ShowPromosForUserEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ShowPromosForUserEvent | PlainMessage<ShowPromosForUserEvent> | undefined, b: ShowPromosForUserEvent | PlainMessage<ShowPromosForUserEvent> | undefined): boolean {
    return proto3.util.equals(ShowPromosForUserEvent, a, b);
  }
}

/**
 * Occurs on any action made by user on platform.
 * ebus:message
 *
 * @generated from message gdx.events.v1.LastUserActionEvent
 */
export class LastUserActionEvent extends Message<LastUserActionEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: google.protobuf.Timestamp action_time = 2;
   */
  actionTime?: Timestamp;

  /**
   * @generated from field: string action_info = 3;
   */
  actionInfo = "";

  constructor(data?: PartialMessage<LastUserActionEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.LastUserActionEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "action_time", kind: "message", T: Timestamp },
    { no: 3, name: "action_info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LastUserActionEvent {
    return new LastUserActionEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LastUserActionEvent {
    return new LastUserActionEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LastUserActionEvent {
    return new LastUserActionEvent().fromJsonString(jsonString, options);
  }

  static equals(a: LastUserActionEvent | PlainMessage<LastUserActionEvent> | undefined, b: LastUserActionEvent | PlainMessage<LastUserActionEvent> | undefined): boolean {
    return proto3.util.equals(LastUserActionEvent, a, b);
  }
}

/**
 * Occurs when user do search action.
 * ebus:message
 *
 * @generated from message gdx.events.v1.SearchEvent
 */
export class SearchEvent extends Message<SearchEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: gdx.gateway.web.profile.v1.SearchCriteria criteria = 2;
   */
  criteria?: SearchCriteria;

  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.SearchMeta meta = 4;
   */
  meta: SearchMeta[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 3;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<SearchEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.SearchEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "criteria", kind: "message", T: SearchCriteria },
    { no: 4, name: "meta", kind: "message", T: SearchMeta, repeated: true },
    { no: 3, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchEvent {
    return new SearchEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchEvent {
    return new SearchEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchEvent {
    return new SearchEvent().fromJsonString(jsonString, options);
  }

  static equals(a: SearchEvent | PlainMessage<SearchEvent> | undefined, b: SearchEvent | PlainMessage<SearchEvent> | undefined): boolean {
    return proto3.util.equals(SearchEvent, a, b);
  }
}

/**
 * Occurs when user stores client event.
 * ebus:message
 *
 * @generated from message gdx.events.v1.ClientEvent
 */
export class ClientEvent extends Message<ClientEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 2;
   */
  createdTime?: Timestamp;

  /**
   * @generated from oneof gdx.events.v1.ClientEvent.event
   */
  event: {
    /**
     * @generated from field: gdx.gateway.web.myprofile.v1.OnboardingCompleteClientEvent onboarding_complete = 5;
     */
    value: OnboardingCompleteClientEvent;
    case: "onboardingComplete";
  } | {
    /**
     * @generated from field: gdx.gateway.web.myprofile.v1.WebPushClickClientEvent web_push_click = 6;
     */
    value: WebPushClickClientEvent;
    case: "webPushClick";
  } | {
    /**
     * @generated from field: gdx.gateway.web.profile.v1.CardsViewedEvent cards_viewed = 3;
     */
    value: CardsViewedEvent;
    case: "cardsViewed";
  } | {
    /**
     * @generated from field: gdx.gateway.web.myprofile.v1.RouteVisitedEvent route_visited = 4;
     */
    value: RouteVisitedEvent;
    case: "routeVisited";
  } | {
    /**
     * @generated from field: gdx.gateway.web.myprofile.v1.CameBackEvent came_back = 8;
     */
    value: CameBackEvent;
    case: "cameBack";
  } | {
    /**
     * @generated from field: gdx.gateway.web.myprofile.v1.ProfileVisitedEvent profile_visited = 9;
     */
    value: ProfileVisitedEvent;
    case: "profileVisited";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<ClientEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ClientEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "created_time", kind: "message", T: Timestamp },
    { no: 5, name: "onboarding_complete", kind: "message", T: OnboardingCompleteClientEvent, oneof: "event" },
    { no: 6, name: "web_push_click", kind: "message", T: WebPushClickClientEvent, oneof: "event" },
    { no: 3, name: "cards_viewed", kind: "message", T: CardsViewedEvent, oneof: "event" },
    { no: 4, name: "route_visited", kind: "message", T: RouteVisitedEvent, oneof: "event" },
    { no: 8, name: "came_back", kind: "message", T: CameBackEvent, oneof: "event" },
    { no: 9, name: "profile_visited", kind: "message", T: ProfileVisitedEvent, oneof: "event" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClientEvent {
    return new ClientEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClientEvent {
    return new ClientEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClientEvent {
    return new ClientEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ClientEvent | PlainMessage<ClientEvent> | undefined, b: ClientEvent | PlainMessage<ClientEvent> | undefined): boolean {
    return proto3.util.equals(ClientEvent, a, b);
  }
}

/**
 * Occurs when user submits a survey.
 * ebus:message
 *
 * @generated from message gdx.events.v1.UserSurveySubmittedEvent
 */
export class UserSurveySubmittedEvent extends Message<UserSurveySubmittedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string response = 2;
   */
  response = "";

  /**
   * @generated from field: string response_description = 5;
   */
  responseDescription = "";

  /**
   * @generated from field: gdx.gateway.web.myprofile.v1.SurveyType type = 3;
   */
  type = SurveyType.INVALID;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 4;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<UserSurveySubmittedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.UserSurveySubmittedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "response", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "response_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "type", kind: "enum", T: proto3.getEnumType(SurveyType) },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserSurveySubmittedEvent {
    return new UserSurveySubmittedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserSurveySubmittedEvent {
    return new UserSurveySubmittedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserSurveySubmittedEvent {
    return new UserSurveySubmittedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: UserSurveySubmittedEvent | PlainMessage<UserSurveySubmittedEvent> | undefined, b: UserSurveySubmittedEvent | PlainMessage<UserSurveySubmittedEvent> | undefined): boolean {
    return proto3.util.equals(UserSurveySubmittedEvent, a, b);
  }
}

/**
 * Occurs when users push subscription status is changed.
 * ebus:message
 *
 * @generated from message gdx.events.v1.UserPushSubscriptionStatusEvent
 */
export class UserPushSubscriptionStatusEvent extends Message<UserPushSubscriptionStatusEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: gdx.events.v1.PushSubscriptionStatus status = 2;
   */
  status = PushSubscriptionStatus.INVALID;

  /**
   * @generated from field: repeated string tokens = 3;
   */
  tokens: string[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 4;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<UserPushSubscriptionStatusEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.UserPushSubscriptionStatusEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(PushSubscriptionStatus) },
    { no: 3, name: "tokens", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserPushSubscriptionStatusEvent {
    return new UserPushSubscriptionStatusEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserPushSubscriptionStatusEvent {
    return new UserPushSubscriptionStatusEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserPushSubscriptionStatusEvent {
    return new UserPushSubscriptionStatusEvent().fromJsonString(jsonString, options);
  }

  static equals(a: UserPushSubscriptionStatusEvent | PlainMessage<UserPushSubscriptionStatusEvent> | undefined, b: UserPushSubscriptionStatusEvent | PlainMessage<UserPushSubscriptionStatusEvent> | undefined): boolean {
    return proto3.util.equals(UserPushSubscriptionStatusEvent, a, b);
  }
}

/**
 * Occurs when order chargeback callback is triggered.
 * ebus:message
 *
 * @generated from message gdx.events.v1.OrderChargebackEvent
 */
export class OrderChargebackEvent extends Message<OrderChargebackEvent> {
  /**
   * @generated from field: gdx.events.v1.OrderChargebackEvent.Chargeback chargeback = 1;
   */
  chargeback?: OrderChargebackEvent_Chargeback;

  /**
   * @generated from field: gdx.events.v1.Order order = 2;
   */
  order?: Order;

  constructor(data?: PartialMessage<OrderChargebackEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.OrderChargebackEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "chargeback", kind: "message", T: OrderChargebackEvent_Chargeback },
    { no: 2, name: "order", kind: "message", T: Order },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrderChargebackEvent {
    return new OrderChargebackEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrderChargebackEvent {
    return new OrderChargebackEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrderChargebackEvent {
    return new OrderChargebackEvent().fromJsonString(jsonString, options);
  }

  static equals(a: OrderChargebackEvent | PlainMessage<OrderChargebackEvent> | undefined, b: OrderChargebackEvent | PlainMessage<OrderChargebackEvent> | undefined): boolean {
    return proto3.util.equals(OrderChargebackEvent, a, b);
  }
}

/**
 * Describes chargeback.
 *
 * @generated from message gdx.events.v1.OrderChargebackEvent.Chargeback
 */
export class OrderChargebackEvent_Chargeback extends Message<OrderChargebackEvent_Chargeback> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: google.protobuf.Timestamp dispute_date_time = 2;
   */
  disputeDateTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp settlement_date_time = 3;
   */
  settlementDateTime?: Timestamp;

  /**
   * @generated from field: int64 amount = 4;
   */
  amount = protoInt64.zero;

  /**
   * @generated from field: string currency = 5;
   */
  currency = "";

  /**
   * @generated from field: string reason_code = 6;
   */
  reasonCode = "";

  /**
   * @generated from field: string status = 7;
   */
  status = "";

  /**
   * @generated from field: string reason_group = 8;
   */
  reasonGroup = "";

  /**
   * @generated from field: string reason_description = 9;
   */
  reasonDescription = "";

  /**
   * @generated from field: string type = 10;
   */
  type = "";

  constructor(data?: PartialMessage<OrderChargebackEvent_Chargeback>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.OrderChargebackEvent.Chargeback";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "dispute_date_time", kind: "message", T: Timestamp },
    { no: 3, name: "settlement_date_time", kind: "message", T: Timestamp },
    { no: 4, name: "amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "reason_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "reason_group", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "reason_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrderChargebackEvent_Chargeback {
    return new OrderChargebackEvent_Chargeback().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrderChargebackEvent_Chargeback {
    return new OrderChargebackEvent_Chargeback().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrderChargebackEvent_Chargeback {
    return new OrderChargebackEvent_Chargeback().fromJsonString(jsonString, options);
  }

  static equals(a: OrderChargebackEvent_Chargeback | PlainMessage<OrderChargebackEvent_Chargeback> | undefined, b: OrderChargebackEvent_Chargeback | PlainMessage<OrderChargebackEvent_Chargeback> | undefined): boolean {
    return proto3.util.equals(OrderChargebackEvent_Chargeback, a, b);
  }
}

/**
 * Occurs when pay-pal order dispute callback is triggered.
 * ebus:message
 *
 * @generated from message gdx.events.v1.PayPalOrderDisputeEvent
 */
export class PayPalOrderDisputeEvent extends Message<PayPalOrderDisputeEvent> {
  /**
   * @generated from field: string dispute_id = 1;
   */
  disputeId = "";

  /**
   * @generated from field: string order_id = 2;
   */
  orderId = "";

  /**
   * @generated from field: string subscription_product_id = 3;
   */
  subscriptionProductId = "";

  /**
   * @generated from field: string subscription_service_id = 4;
   */
  subscriptionServiceId = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 5;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_time = 6;
   */
  updatedTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp seller_response_due_time = 7;
   */
  sellerResponseDueTime?: Timestamp;

  /**
   * @generated from field: int32 dispute_amount = 8;
   */
  disputeAmount = 0;

  /**
   * @generated from field: string dispute_currency = 9;
   */
  disputeCurrency = "";

  /**
   * @generated from field: string dispute_lifecycle_state = 10;
   */
  disputeLifecycleState = "";

  /**
   * @generated from field: string dispute_channel = 11;
   */
  disputeChannel = "";

  /**
   * @generated from field: google.protobuf.Timestamp dispute_create_time = 12;
   */
  disputeCreateTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp dispute_update_time = 13;
   */
  disputeUpdateTime?: Timestamp;

  /**
   * @generated from field: string reason = 14;
   */
  reason = "";

  /**
   * @generated from field: string status = 15;
   */
  status = "";

  /**
   * @generated from field: string customer_account_id = 16;
   */
  customerAccountId = "";

  /**
   * @generated from field: string customer_email = 17;
   */
  customerEmail = "";

  /**
   * @generated from field: string outcome = 18;
   */
  outcome = "";

  constructor(data?: PartialMessage<PayPalOrderDisputeEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.PayPalOrderDisputeEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dispute_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "subscription_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "subscription_service_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_time", kind: "message", T: Timestamp },
    { no: 6, name: "updated_time", kind: "message", T: Timestamp },
    { no: 7, name: "seller_response_due_time", kind: "message", T: Timestamp },
    { no: 8, name: "dispute_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "dispute_currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "dispute_lifecycle_state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "dispute_channel", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "dispute_create_time", kind: "message", T: Timestamp },
    { no: 13, name: "dispute_update_time", kind: "message", T: Timestamp },
    { no: 14, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "customer_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "customer_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "outcome", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PayPalOrderDisputeEvent {
    return new PayPalOrderDisputeEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PayPalOrderDisputeEvent {
    return new PayPalOrderDisputeEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PayPalOrderDisputeEvent {
    return new PayPalOrderDisputeEvent().fromJsonString(jsonString, options);
  }

  static equals(a: PayPalOrderDisputeEvent | PlainMessage<PayPalOrderDisputeEvent> | undefined, b: PayPalOrderDisputeEvent | PlainMessage<PayPalOrderDisputeEvent> | undefined): boolean {
    return proto3.util.equals(PayPalOrderDisputeEvent, a, b);
  }
}

/**
 * Occurs when STRIPE order dispute callback is triggered.
 * ebus:message
 *
 * @generated from message gdx.events.v1.StripeOrderDisputeEvent
 */
export class StripeOrderDisputeEvent extends Message<StripeOrderDisputeEvent> {
  /**
   * @generated from field: gdx.events.v1.StripeOrderDisputeEvent.Dispute dispute = 1;
   */
  dispute?: StripeOrderDisputeEvent_Dispute;

  constructor(data?: PartialMessage<StripeOrderDisputeEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.StripeOrderDisputeEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dispute", kind: "message", T: StripeOrderDisputeEvent_Dispute },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StripeOrderDisputeEvent {
    return new StripeOrderDisputeEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StripeOrderDisputeEvent {
    return new StripeOrderDisputeEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StripeOrderDisputeEvent {
    return new StripeOrderDisputeEvent().fromJsonString(jsonString, options);
  }

  static equals(a: StripeOrderDisputeEvent | PlainMessage<StripeOrderDisputeEvent> | undefined, b: StripeOrderDisputeEvent | PlainMessage<StripeOrderDisputeEvent> | undefined): boolean {
    return proto3.util.equals(StripeOrderDisputeEvent, a, b);
  }
}

/**
 * Describes dispute.
 *
 * @generated from message gdx.events.v1.StripeOrderDisputeEvent.Dispute
 */
export class StripeOrderDisputeEvent_Dispute extends Message<StripeOrderDisputeEvent_Dispute> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string order_id = 2;
   */
  orderId = "";

  /**
   * @generated from field: int64 amount = 3;
   */
  amount = protoInt64.zero;

  /**
   * @generated from field: string charge_id = 4;
   */
  chargeId = "";

  /**
   * @generated from field: string currency = 5;
   */
  currency = "";

  /**
   * @generated from field: string payment_intent_id = 6;
   */
  paymentIntentId = "";

  /**
   * @generated from field: string reason = 7;
   */
  reason = "";

  /**
   * @generated from field: string status = 8;
   */
  status = "";

  /**
   * @generated from field: bool is_charge_refundable = 9;
   */
  isChargeRefundable = false;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 10;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_time = 11;
   */
  updatedTime?: Timestamp;

  constructor(data?: PartialMessage<StripeOrderDisputeEvent_Dispute>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.StripeOrderDisputeEvent.Dispute";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "charge_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "payment_intent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "is_charge_refundable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "created_time", kind: "message", T: Timestamp },
    { no: 11, name: "updated_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StripeOrderDisputeEvent_Dispute {
    return new StripeOrderDisputeEvent_Dispute().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StripeOrderDisputeEvent_Dispute {
    return new StripeOrderDisputeEvent_Dispute().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StripeOrderDisputeEvent_Dispute {
    return new StripeOrderDisputeEvent_Dispute().fromJsonString(jsonString, options);
  }

  static equals(a: StripeOrderDisputeEvent_Dispute | PlainMessage<StripeOrderDisputeEvent_Dispute> | undefined, b: StripeOrderDisputeEvent_Dispute | PlainMessage<StripeOrderDisputeEvent_Dispute> | undefined): boolean {
    return proto3.util.equals(StripeOrderDisputeEvent_Dispute, a, b);
  }
}

/**
 * Occurs when order chargeback alert callback is triggered.
 * ebus:message
 *
 * @generated from message gdx.events.v1.OrderChargebackAlertEvent
 */
export class OrderChargebackAlertEvent extends Message<OrderChargebackAlertEvent> {
  /**
   * @generated from field: gdx.events.v1.OrderChargebackAlertEvent.Alert alert = 1;
   */
  alert?: OrderChargebackAlertEvent_Alert;

  /**
   * @generated from field: gdx.events.v1.Order order = 2;
   */
  order?: Order;

  constructor(data?: PartialMessage<OrderChargebackAlertEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.OrderChargebackAlertEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "alert", kind: "message", T: OrderChargebackAlertEvent_Alert },
    { no: 2, name: "order", kind: "message", T: Order },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrderChargebackAlertEvent {
    return new OrderChargebackAlertEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrderChargebackAlertEvent {
    return new OrderChargebackAlertEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrderChargebackAlertEvent {
    return new OrderChargebackAlertEvent().fromJsonString(jsonString, options);
  }

  static equals(a: OrderChargebackAlertEvent | PlainMessage<OrderChargebackAlertEvent> | undefined, b: OrderChargebackAlertEvent | PlainMessage<OrderChargebackAlertEvent> | undefined): boolean {
    return proto3.util.equals(OrderChargebackAlertEvent, a, b);
  }
}

/**
 * Enumerates alert types.
 *
 * @generated from enum gdx.events.v1.OrderChargebackAlertEvent.Type
 */
export enum OrderChargebackAlertEvent_Type {
  /**
   * @generated from enum value: TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: TYPE_INQUIRY = 1;
   */
  INQUIRY = 1,

  /**
   * @generated from enum value: TYPE_INIT_REFUND = 2;
   */
  INIT_REFUND = 2,

  /**
   * @generated from enum value: TYPE_RESOLVED = 3;
   */
  RESOLVED = 3,

  /**
   * @generated from enum value: TYPE_PREVENTED = 4;
   */
  PREVENTED = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(OrderChargebackAlertEvent_Type)
proto3.util.setEnumType(OrderChargebackAlertEvent_Type, "gdx.events.v1.OrderChargebackAlertEvent.Type", [
  { no: 0, name: "TYPE_INVALID" },
  { no: 1, name: "TYPE_INQUIRY" },
  { no: 2, name: "TYPE_INIT_REFUND" },
  { no: 3, name: "TYPE_RESOLVED" },
  { no: 4, name: "TYPE_PREVENTED" },
]);

/**
 * Describes chargeback alert.
 *
 * @generated from message gdx.events.v1.OrderChargebackAlertEvent.Alert
 */
export class OrderChargebackAlertEvent_Alert extends Message<OrderChargebackAlertEvent_Alert> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string provider_name = 2;
   */
  providerName = "";

  /**
   * @generated from field: string provider_id = 3;
   */
  providerId = "";

  /**
   * @generated from field: google.protobuf.Timestamp alert_date_time = 4;
   */
  alertDateTime?: Timestamp;

  /**
   * @generated from field: int64 amount = 5;
   */
  amount = protoInt64.zero;

  /**
   * @generated from field: string currency = 6;
   */
  currency = "";

  /**
   * @generated from field: gdx.events.v1.OrderChargebackAlertEvent.Type type = 7;
   */
  type = OrderChargebackAlertEvent_Type.INVALID;

  /**
   * @generated from field: string outcome = 8;
   */
  outcome = "";

  constructor(data?: PartialMessage<OrderChargebackAlertEvent_Alert>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.OrderChargebackAlertEvent.Alert";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "provider_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "provider_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "alert_date_time", kind: "message", T: Timestamp },
    { no: 5, name: "amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "type", kind: "enum", T: proto3.getEnumType(OrderChargebackAlertEvent_Type) },
    { no: 8, name: "outcome", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrderChargebackAlertEvent_Alert {
    return new OrderChargebackAlertEvent_Alert().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrderChargebackAlertEvent_Alert {
    return new OrderChargebackAlertEvent_Alert().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrderChargebackAlertEvent_Alert {
    return new OrderChargebackAlertEvent_Alert().fromJsonString(jsonString, options);
  }

  static equals(a: OrderChargebackAlertEvent_Alert | PlainMessage<OrderChargebackAlertEvent_Alert> | undefined, b: OrderChargebackAlertEvent_Alert | PlainMessage<OrderChargebackAlertEvent_Alert> | undefined): boolean {
    return proto3.util.equals(OrderChargebackAlertEvent_Alert, a, b);
  }
}

/**
 * Occurs when order SOLID network token is updated.
 * ebus:message
 *
 * @generated from message gdx.events.v1.NetworkTokenUpdatedEvent
 */
export class NetworkTokenUpdatedEvent extends Message<NetworkTokenUpdatedEvent> {
  /**
   * @generated from field: string card_id = 1;
   */
  cardId = "";

  /**
   * @generated from field: string tokenization_type = 2;
   */
  tokenizationType = "";

  /**
   * @generated from field: string status = 3;
   */
  status = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 4;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_time = 5;
   */
  updatedTime?: Timestamp;

  constructor(data?: PartialMessage<NetworkTokenUpdatedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.NetworkTokenUpdatedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "card_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tokenization_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
    { no: 5, name: "updated_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NetworkTokenUpdatedEvent {
    return new NetworkTokenUpdatedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NetworkTokenUpdatedEvent {
    return new NetworkTokenUpdatedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NetworkTokenUpdatedEvent {
    return new NetworkTokenUpdatedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: NetworkTokenUpdatedEvent | PlainMessage<NetworkTokenUpdatedEvent> | undefined, b: NetworkTokenUpdatedEvent | PlainMessage<NetworkTokenUpdatedEvent> | undefined): boolean {
    return proto3.util.equals(NetworkTokenUpdatedEvent, a, b);
  }
}

/**
 * Occurs profile fraud score is updated.
 * ebus:message
 *
 * @generated from message gdx.events.v1.ProfileFraudScoresUpdatedEvent
 */
export class ProfileFraudScoresUpdatedEvent extends Message<ProfileFraudScoresUpdatedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: float registration_score = 2;
   */
  registrationScore = 0;

  /**
   * @generated from field: float payment_score = 3;
   */
  paymentScore = 0;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 4;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<ProfileFraudScoresUpdatedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ProfileFraudScoresUpdatedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "registration_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "payment_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileFraudScoresUpdatedEvent {
    return new ProfileFraudScoresUpdatedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileFraudScoresUpdatedEvent {
    return new ProfileFraudScoresUpdatedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileFraudScoresUpdatedEvent {
    return new ProfileFraudScoresUpdatedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileFraudScoresUpdatedEvent | PlainMessage<ProfileFraudScoresUpdatedEvent> | undefined, b: ProfileFraudScoresUpdatedEvent | PlainMessage<ProfileFraudScoresUpdatedEvent> | undefined): boolean {
    return proto3.util.equals(ProfileFraudScoresUpdatedEvent, a, b);
  }
}

/**
 * Occurs when session status changes.
 * ebus:message
 *
 * @generated from message gdx.events.v1.ChatterSessionStatusEvent
 */
export class ChatterSessionStatusEvent extends Message<ChatterSessionStatusEvent> {
  /**
   * @generated from field: string team_member_id = 1;
   */
  teamMemberId = "";

  /**
   * @generated from field: string team_member_email = 2;
   */
  teamMemberEmail = "";

  /**
   * @generated from field: google.protobuf.Timestamp changed_at_time = 3;
   */
  changedAtTime?: Timestamp;

  /**
   * @generated from field: gdx.events.v1.ChatterSessionStatusEvent.Status status = 4;
   */
  status = ChatterSessionStatusEvent_Status.INVALID;

  constructor(data?: PartialMessage<ChatterSessionStatusEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ChatterSessionStatusEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "team_member_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_member_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "changed_at_time", kind: "message", T: Timestamp },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(ChatterSessionStatusEvent_Status) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChatterSessionStatusEvent {
    return new ChatterSessionStatusEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChatterSessionStatusEvent {
    return new ChatterSessionStatusEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChatterSessionStatusEvent {
    return new ChatterSessionStatusEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ChatterSessionStatusEvent | PlainMessage<ChatterSessionStatusEvent> | undefined, b: ChatterSessionStatusEvent | PlainMessage<ChatterSessionStatusEvent> | undefined): boolean {
    return proto3.util.equals(ChatterSessionStatusEvent, a, b);
  }
}

/**
 * Enumerates session statuses.
 *
 * @generated from enum gdx.events.v1.ChatterSessionStatusEvent.Status
 */
export enum ChatterSessionStatusEvent_Status {
  /**
   * @generated from enum value: STATUS_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: STATUS_ON_BREAK = 2;
   */
  ON_BREAK = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(ChatterSessionStatusEvent_Status)
proto3.util.setEnumType(ChatterSessionStatusEvent_Status, "gdx.events.v1.ChatterSessionStatusEvent.Status", [
  { no: 0, name: "STATUS_INVALID" },
  { no: 1, name: "STATUS_ACTIVE" },
  { no: 2, name: "STATUS_ON_BREAK" },
]);

/**
 * Occurs when team member starts chatter session.
 * ebus:message
 *
 * @generated from message gdx.events.v1.ChatterSessionStartedEvent
 */
export class ChatterSessionStartedEvent extends Message<ChatterSessionStartedEvent> {
  /**
   * @generated from field: string team_member_id = 1;
   */
  teamMemberId = "";

  /**
   * @generated from field: string team_member_email = 2;
   */
  teamMemberEmail = "";

  /**
   * @generated from field: google.protobuf.Timestamp started_time = 3;
   */
  startedTime?: Timestamp;

  /**
   * @generated from field: repeated gdx.chatters.v1.Channel channels = 4;
   */
  channels: Channel[] = [];

  /**
   * @generated from field: repeated string locales = 5;
   */
  locales: string[] = [];

  constructor(data?: PartialMessage<ChatterSessionStartedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ChatterSessionStartedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "team_member_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_member_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "started_time", kind: "message", T: Timestamp },
    { no: 4, name: "channels", kind: "enum", T: proto3.getEnumType(Channel), repeated: true },
    { no: 5, name: "locales", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChatterSessionStartedEvent {
    return new ChatterSessionStartedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChatterSessionStartedEvent {
    return new ChatterSessionStartedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChatterSessionStartedEvent {
    return new ChatterSessionStartedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ChatterSessionStartedEvent | PlainMessage<ChatterSessionStartedEvent> | undefined, b: ChatterSessionStartedEvent | PlainMessage<ChatterSessionStartedEvent> | undefined): boolean {
    return proto3.util.equals(ChatterSessionStartedEvent, a, b);
  }
}

/**
 * Occurs when team member ends chatter session.
 * ebus:message
 *
 * @generated from message gdx.events.v1.ChatterSessionEndedEvent
 */
export class ChatterSessionEndedEvent extends Message<ChatterSessionEndedEvent> {
  /**
   * @generated from field: string team_member_id = 1;
   */
  teamMemberId = "";

  /**
   * @generated from field: string team_member_email = 2;
   */
  teamMemberEmail = "";

  /**
   * @generated from field: gdx.events.v1.ChatterSessionEndReason reason = 3;
   */
  reason = ChatterSessionEndReason.INVALID;

  /**
   * @generated from field: uint64 inbound_messages = 4;
   */
  inboundMessages = protoInt64.zero;

  /**
   * @generated from field: uint64 outbound_messages = 5;
   */
  outboundMessages = protoInt64.zero;

  /**
   * @generated from field: uint64 free_messages = 7;
   */
  freeMessages = protoInt64.zero;

  /**
   * @generated from field: uint64 trial_messages = 8;
   */
  trialMessages = protoInt64.zero;

  /**
   * @generated from field: uint64 premium_messages = 9;
   */
  premiumMessages = protoInt64.zero;

  /**
   * @generated from field: uint64 power_like_messages = 10;
   */
  powerLikeMessages = protoInt64.zero;

  /**
   * @generated from field: google.protobuf.Timestamp ended_time = 6;
   */
  endedTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Duration total_break_duration = 14;
   */
  totalBreakDuration?: Duration;

  /**
   * @generated from field: float average_velocity = 15;
   */
  averageVelocity = 0;

  constructor(data?: PartialMessage<ChatterSessionEndedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ChatterSessionEndedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "team_member_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_member_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "reason", kind: "enum", T: proto3.getEnumType(ChatterSessionEndReason) },
    { no: 4, name: "inbound_messages", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 5, name: "outbound_messages", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 7, name: "free_messages", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 8, name: "trial_messages", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 9, name: "premium_messages", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 10, name: "power_like_messages", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 6, name: "ended_time", kind: "message", T: Timestamp },
    { no: 14, name: "total_break_duration", kind: "message", T: Duration },
    { no: 15, name: "average_velocity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChatterSessionEndedEvent {
    return new ChatterSessionEndedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChatterSessionEndedEvent {
    return new ChatterSessionEndedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChatterSessionEndedEvent {
    return new ChatterSessionEndedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ChatterSessionEndedEvent | PlainMessage<ChatterSessionEndedEvent> | undefined, b: ChatterSessionEndedEvent | PlainMessage<ChatterSessionEndedEvent> | undefined): boolean {
    return proto3.util.equals(ChatterSessionEndedEvent, a, b);
  }
}

/**
 * Occurs when team member changed session channels.
 * ebus:message
 *
 * @generated from message gdx.events.v1.SessionChannelsChangedEvent
 */
export class SessionChannelsChangedEvent extends Message<SessionChannelsChangedEvent> {
  /**
   * @generated from field: string team_member_id = 1;
   */
  teamMemberId = "";

  /**
   * @generated from field: string team_member_email = 2;
   */
  teamMemberEmail = "";

  /**
   * @generated from field: google.protobuf.Timestamp changed_time = 3;
   */
  changedTime?: Timestamp;

  /**
   * @generated from field: repeated gdx.chatters.v1.Channel channels = 4;
   */
  channels: Channel[] = [];

  /**
   * @generated from field: repeated string locales = 5;
   */
  locales: string[] = [];

  constructor(data?: PartialMessage<SessionChannelsChangedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.SessionChannelsChangedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "team_member_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_member_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "changed_time", kind: "message", T: Timestamp },
    { no: 4, name: "channels", kind: "enum", T: proto3.getEnumType(Channel), repeated: true },
    { no: 5, name: "locales", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SessionChannelsChangedEvent {
    return new SessionChannelsChangedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SessionChannelsChangedEvent {
    return new SessionChannelsChangedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SessionChannelsChangedEvent {
    return new SessionChannelsChangedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: SessionChannelsChangedEvent | PlainMessage<SessionChannelsChangedEvent> | undefined, b: SessionChannelsChangedEvent | PlainMessage<SessionChannelsChangedEvent> | undefined): boolean {
    return proto3.util.equals(SessionChannelsChangedEvent, a, b);
  }
}

/**
 * Occurs after payout is submitted with corresponding status.
 * ebus:message
 *
 * @generated from message gdx.events.v1.AtlasPayoutSubmittedEvent
 */
export class AtlasPayoutSubmittedEvent extends Message<AtlasPayoutSubmittedEvent> {
  /**
   * @generated from field: string payout_id = 1;
   */
  payoutId = "";

  /**
   * @generated from field: string calculation_id = 2;
   */
  calculationId = "";

  /**
   * @generated from field: bool is_success = 3;
   */
  isSuccess = false;

  /**
   * @generated from field: repeated string errors = 4;
   */
  errors: string[] = [];

  /**
   * @generated from field: int32 total_payouts = 5;
   */
  totalPayouts = 0;

  /**
   * @generated from field: int32 submitted_payouts = 6;
   */
  submittedPayouts = 0;

  constructor(data?: PartialMessage<AtlasPayoutSubmittedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.AtlasPayoutSubmittedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "payout_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "calculation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "errors", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "total_payouts", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "submitted_payouts", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AtlasPayoutSubmittedEvent {
    return new AtlasPayoutSubmittedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AtlasPayoutSubmittedEvent {
    return new AtlasPayoutSubmittedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AtlasPayoutSubmittedEvent {
    return new AtlasPayoutSubmittedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: AtlasPayoutSubmittedEvent | PlainMessage<AtlasPayoutSubmittedEvent> | undefined, b: AtlasPayoutSubmittedEvent | PlainMessage<AtlasPayoutSubmittedEvent> | undefined): boolean {
    return proto3.util.equals(AtlasPayoutSubmittedEvent, a, b);
  }
}

/**
 * Occurs profile fraud score is updated.
 * ebus:message
 *
 * @generated from message gdx.events.v1.ProfileStatusUpdatedEvent
 */
export class ProfileStatusUpdatedEvent extends Message<ProfileStatusUpdatedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * @generated from field: string reason = 3;
   */
  reason = "";

  /**
   * @generated from field: string status = 4;
   */
  status = "";

  /**
   * @generated from field: repeated string category = 8;
   */
  category: string[] = [];

  /**
   * @generated from field: string moderator_id = 9;
   */
  moderatorId = "";

  /**
   * @generated from field: gdx.backoffice.service.newprofiles.v1.ActorType actor_type = 5;
   */
  actorType = ActorType.INVALID;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 6;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Duration duration = 7;
   */
  duration?: Duration;

  constructor(data?: PartialMessage<ProfileStatusUpdatedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ProfileStatusUpdatedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: "moderator_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "actor_type", kind: "enum", T: proto3.getEnumType(ActorType) },
    { no: 6, name: "created_time", kind: "message", T: Timestamp },
    { no: 7, name: "duration", kind: "message", T: Duration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileStatusUpdatedEvent {
    return new ProfileStatusUpdatedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileStatusUpdatedEvent {
    return new ProfileStatusUpdatedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileStatusUpdatedEvent {
    return new ProfileStatusUpdatedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileStatusUpdatedEvent | PlainMessage<ProfileStatusUpdatedEvent> | undefined, b: ProfileStatusUpdatedEvent | PlainMessage<ProfileStatusUpdatedEvent> | undefined): boolean {
    return proto3.util.equals(ProfileStatusUpdatedEvent, a, b);
  }
}

/**
 * Occurs if user used a promotion.
 * ebus:message
 *
 * @generated from message gdx.events.v1.PromotionUsedEvent
 */
export class PromotionUsedEvent extends Message<PromotionUsedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string offer_id = 2;
   */
  offerId = "";

  /**
   * @generated from field: string order_id = 3;
   */
  orderId = "";

  /**
   * @generated from field: google.protobuf.Timestamp used_at_time = 4;
   */
  usedAtTime?: Timestamp;

  constructor(data?: PartialMessage<PromotionUsedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.PromotionUsedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "offer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "used_at_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PromotionUsedEvent {
    return new PromotionUsedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PromotionUsedEvent {
    return new PromotionUsedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PromotionUsedEvent {
    return new PromotionUsedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: PromotionUsedEvent | PlainMessage<PromotionUsedEvent> | undefined, b: PromotionUsedEvent | PlainMessage<PromotionUsedEvent> | undefined): boolean {
    return proto3.util.equals(PromotionUsedEvent, a, b);
  }
}

/**
 * Notify power like send success.
 * ebus:message
 *
 * @generated from message gdx.events.v1.PowerLikeSendSuccessEvent
 */
export class PowerLikeSendSuccessEvent extends Message<PowerLikeSendSuccessEvent> {
  /**
   * @generated from field: string connection_id = 1;
   */
  connectionId = "";

  /**
   * @generated from field: string user_id = 2;
   */
  userId = "";

  /**
   * @generated from field: string subject_id = 3;
   */
  subjectId = "";

  /**
   * @generated from field: uint32 source = 4;
   */
  source = 0;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 5;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: repeated string tags = 6;
   */
  tags: string[] = [];

  constructor(data?: PartialMessage<PowerLikeSendSuccessEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.PowerLikeSendSuccessEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "subject_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "source", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "created_time", kind: "message", T: Timestamp },
    { no: 6, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PowerLikeSendSuccessEvent {
    return new PowerLikeSendSuccessEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PowerLikeSendSuccessEvent {
    return new PowerLikeSendSuccessEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PowerLikeSendSuccessEvent {
    return new PowerLikeSendSuccessEvent().fromJsonString(jsonString, options);
  }

  static equals(a: PowerLikeSendSuccessEvent | PlainMessage<PowerLikeSendSuccessEvent> | undefined, b: PowerLikeSendSuccessEvent | PlainMessage<PowerLikeSendSuccessEvent> | undefined): boolean {
    return proto3.util.equals(PowerLikeSendSuccessEvent, a, b);
  }
}

/**
 * Power like send fail.
 * ebus:message
 *
 * @generated from message gdx.events.v1.PowerLikeSendFailEvent
 */
export class PowerLikeSendFailEvent extends Message<PowerLikeSendFailEvent> {
  /**
   * @generated from field: string connection_id = 1;
   */
  connectionId = "";

  /**
   * @generated from field: string user_id = 2;
   */
  userId = "";

  /**
   * @generated from field: string subject_id = 3;
   */
  subjectId = "";

  /**
   * @generated from field: uint32 source = 4;
   */
  source = 0;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 5;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<PowerLikeSendFailEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.PowerLikeSendFailEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "subject_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "source", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PowerLikeSendFailEvent {
    return new PowerLikeSendFailEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PowerLikeSendFailEvent {
    return new PowerLikeSendFailEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PowerLikeSendFailEvent {
    return new PowerLikeSendFailEvent().fromJsonString(jsonString, options);
  }

  static equals(a: PowerLikeSendFailEvent | PlainMessage<PowerLikeSendFailEvent> | undefined, b: PowerLikeSendFailEvent | PlainMessage<PowerLikeSendFailEvent> | undefined): boolean {
    return proto3.util.equals(PowerLikeSendFailEvent, a, b);
  }
}

/**
 * Power like accepted.
 * ebus:message
 *
 * @generated from message gdx.events.v1.PowerLikeAcceptedEvent
 */
export class PowerLikeAcceptedEvent extends Message<PowerLikeAcceptedEvent> {
  /**
   * @generated from field: string connection_id = 1;
   */
  connectionId = "";

  /**
   * @generated from field: string user_id = 2;
   */
  userId = "";

  /**
   * @generated from field: string subject_id = 3;
   */
  subjectId = "";

  constructor(data?: PartialMessage<PowerLikeAcceptedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.PowerLikeAcceptedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "subject_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PowerLikeAcceptedEvent {
    return new PowerLikeAcceptedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PowerLikeAcceptedEvent {
    return new PowerLikeAcceptedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PowerLikeAcceptedEvent {
    return new PowerLikeAcceptedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: PowerLikeAcceptedEvent | PlainMessage<PowerLikeAcceptedEvent> | undefined, b: PowerLikeAcceptedEvent | PlainMessage<PowerLikeAcceptedEvent> | undefined): boolean {
    return proto3.util.equals(PowerLikeAcceptedEvent, a, b);
  }
}

/**
 * Power like cancelled.
 * ebus:message
 *
 * @generated from message gdx.events.v1.PowerLikeCancelledEvent
 */
export class PowerLikeCancelledEvent extends Message<PowerLikeCancelledEvent> {
  /**
   * @generated from field: string connection_id = 1;
   */
  connectionId = "";

  /**
   * @generated from field: string user_id = 2;
   */
  userId = "";

  /**
   * @generated from field: string subject_id = 3;
   */
  subjectId = "";

  constructor(data?: PartialMessage<PowerLikeCancelledEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.PowerLikeCancelledEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "subject_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PowerLikeCancelledEvent {
    return new PowerLikeCancelledEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PowerLikeCancelledEvent {
    return new PowerLikeCancelledEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PowerLikeCancelledEvent {
    return new PowerLikeCancelledEvent().fromJsonString(jsonString, options);
  }

  static equals(a: PowerLikeCancelledEvent | PlainMessage<PowerLikeCancelledEvent> | undefined, b: PowerLikeCancelledEvent | PlainMessage<PowerLikeCancelledEvent> | undefined): boolean {
    return proto3.util.equals(PowerLikeCancelledEvent, a, b);
  }
}

/**
 * Occurs when retention action is processed.
 * ebus:message
 *
 * @generated from message gdx.events.v1.RetentionActionResultEvent
 */
export class RetentionActionResultEvent extends Message<RetentionActionResultEvent> {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId = "";

  /**
   * @generated from field: string user_id = 2;
   */
  userId = "";

  /**
   * @generated from field: gdx.events.v1.RetentionActionStatus status = 3;
   */
  status = RetentionActionStatus.INVALID;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 4;
   */
  createdTime?: Timestamp;

  /**
   * @generated from oneof gdx.events.v1.RetentionActionResultEvent.action
   */
  action: {
    /**
     * @generated from field: gdx.events.v1.RetentionActionResultEvent.ActionConnection connection = 5;
     */
    value: RetentionActionResultEvent_ActionConnection;
    case: "connection";
  } | {
    /**
     * @generated from field: gdx.events.v1.RetentionActionResultEvent.ActionPackage package = 6;
     */
    value: RetentionActionResultEvent_ActionPackage;
    case: "package";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<RetentionActionResultEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.RetentionActionResultEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "action_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(RetentionActionStatus) },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
    { no: 5, name: "connection", kind: "message", T: RetentionActionResultEvent_ActionConnection, oneof: "action" },
    { no: 6, name: "package", kind: "message", T: RetentionActionResultEvent_ActionPackage, oneof: "action" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RetentionActionResultEvent {
    return new RetentionActionResultEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RetentionActionResultEvent {
    return new RetentionActionResultEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RetentionActionResultEvent {
    return new RetentionActionResultEvent().fromJsonString(jsonString, options);
  }

  static equals(a: RetentionActionResultEvent | PlainMessage<RetentionActionResultEvent> | undefined, b: RetentionActionResultEvent | PlainMessage<RetentionActionResultEvent> | undefined): boolean {
    return proto3.util.equals(RetentionActionResultEvent, a, b);
  }
}

/**
 * Action detail about connection.
 *
 * @generated from message gdx.events.v1.RetentionActionResultEvent.ActionConnection
 */
export class RetentionActionResultEvent_ActionConnection extends Message<RetentionActionResultEvent_ActionConnection> {
  /**
   * @generated from field: string connection_id = 1;
   */
  connectionId = "";

  constructor(data?: PartialMessage<RetentionActionResultEvent_ActionConnection>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.RetentionActionResultEvent.ActionConnection";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RetentionActionResultEvent_ActionConnection {
    return new RetentionActionResultEvent_ActionConnection().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RetentionActionResultEvent_ActionConnection {
    return new RetentionActionResultEvent_ActionConnection().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RetentionActionResultEvent_ActionConnection {
    return new RetentionActionResultEvent_ActionConnection().fromJsonString(jsonString, options);
  }

  static equals(a: RetentionActionResultEvent_ActionConnection | PlainMessage<RetentionActionResultEvent_ActionConnection> | undefined, b: RetentionActionResultEvent_ActionConnection | PlainMessage<RetentionActionResultEvent_ActionConnection> | undefined): boolean {
    return proto3.util.equals(RetentionActionResultEvent_ActionConnection, a, b);
  }
}

/**
 * Action purchase package.
 *
 * @generated from message gdx.events.v1.RetentionActionResultEvent.ActionPackage
 */
export class RetentionActionResultEvent_ActionPackage extends Message<RetentionActionResultEvent_ActionPackage> {
  /**
   * @generated from field: string package_id = 1;
   */
  packageId = "";

  /**
   * @generated from field: string offer_id = 2;
   */
  offerId = "";

  constructor(data?: PartialMessage<RetentionActionResultEvent_ActionPackage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.RetentionActionResultEvent.ActionPackage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "package_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "offer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RetentionActionResultEvent_ActionPackage {
    return new RetentionActionResultEvent_ActionPackage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RetentionActionResultEvent_ActionPackage {
    return new RetentionActionResultEvent_ActionPackage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RetentionActionResultEvent_ActionPackage {
    return new RetentionActionResultEvent_ActionPackage().fromJsonString(jsonString, options);
  }

  static equals(a: RetentionActionResultEvent_ActionPackage | PlainMessage<RetentionActionResultEvent_ActionPackage> | undefined, b: RetentionActionResultEvent_ActionPackage | PlainMessage<RetentionActionResultEvent_ActionPackage> | undefined): boolean {
    return proto3.util.equals(RetentionActionResultEvent_ActionPackage, a, b);
  }
}

/**
 * Occurs when feature purchase done.
 * ebus:message
 *
 * @generated from message gdx.events.v1.FeatureRestrictedEvent
 */
export class FeatureRestrictedEvent extends Message<FeatureRestrictedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: gdx.market.v1.FeatureType feature_type = 2;
   */
  featureType = FeatureType.INVALID;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 3;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: uint32 source = 4;
   */
  source = 0;

  constructor(data?: PartialMessage<FeatureRestrictedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.FeatureRestrictedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "feature_type", kind: "enum", T: proto3.getEnumType(FeatureType) },
    { no: 3, name: "created_time", kind: "message", T: Timestamp },
    { no: 4, name: "source", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FeatureRestrictedEvent {
    return new FeatureRestrictedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FeatureRestrictedEvent {
    return new FeatureRestrictedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FeatureRestrictedEvent {
    return new FeatureRestrictedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: FeatureRestrictedEvent | PlainMessage<FeatureRestrictedEvent> | undefined, b: FeatureRestrictedEvent | PlainMessage<FeatureRestrictedEvent> | undefined): boolean {
    return proto3.util.equals(FeatureRestrictedEvent, a, b);
  }
}

/**
 * Occurs when feature purchase done.
 * ebus:message
 *
 * @generated from message gdx.events.v1.FeaturePurchasedEvent
 */
export class FeaturePurchasedEvent extends Message<FeaturePurchasedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: gdx.market.v1.FeatureType feature_type = 2;
   */
  featureType = FeatureType.INVALID;

  /**
   * @generated from oneof gdx.events.v1.FeaturePurchasedEvent.extra
   */
  extra: {
    /**
     * @generated from field: gdx.market.v1.ExtraMessageText message_text = 3;
     */
    value: ExtraMessageText;
    case: "messageText";
  } | {
    /**
     * @generated from field: gdx.market.v1.ExtraConnectionId connection_id = 4;
     */
    value: ExtraConnectionId;
    case: "connectionId";
  } | {
    /**
     * @generated from field: gdx.market.v1.ExtraGift gift = 5;
     */
    value: ExtraGift;
    case: "gift";
  } | {
    /**
     * @generated from field: gdx.market.v1.ExtraPartnerId partner_id = 6;
     */
    value: ExtraPartnerId;
    case: "partnerId";
  } | { case: undefined; value?: undefined } = { case: undefined };

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 7;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: uint32 source = 8;
   */
  source = 0;

  constructor(data?: PartialMessage<FeaturePurchasedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.FeaturePurchasedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "feature_type", kind: "enum", T: proto3.getEnumType(FeatureType) },
    { no: 3, name: "message_text", kind: "message", T: ExtraMessageText, oneof: "extra" },
    { no: 4, name: "connection_id", kind: "message", T: ExtraConnectionId, oneof: "extra" },
    { no: 5, name: "gift", kind: "message", T: ExtraGift, oneof: "extra" },
    { no: 6, name: "partner_id", kind: "message", T: ExtraPartnerId, oneof: "extra" },
    { no: 7, name: "created_time", kind: "message", T: Timestamp },
    { no: 8, name: "source", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FeaturePurchasedEvent {
    return new FeaturePurchasedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FeaturePurchasedEvent {
    return new FeaturePurchasedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FeaturePurchasedEvent {
    return new FeaturePurchasedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: FeaturePurchasedEvent | PlainMessage<FeaturePurchasedEvent> | undefined, b: FeaturePurchasedEvent | PlainMessage<FeaturePurchasedEvent> | undefined): boolean {
    return proto3.util.equals(FeaturePurchasedEvent, a, b);
  }
}

/**
 * Occurs when feature purchase failed.
 * ebus:message
 *
 * @generated from message gdx.events.v1.FeaturePurchaseFailedEvent
 */
export class FeaturePurchaseFailedEvent extends Message<FeaturePurchaseFailedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: gdx.market.v1.FeatureType feature_type = 2;
   */
  featureType = FeatureType.INVALID;

  /**
   * @generated from oneof gdx.events.v1.FeaturePurchaseFailedEvent.extra
   */
  extra: {
    /**
     * @generated from field: gdx.market.v1.ExtraMessageText message_text = 3;
     */
    value: ExtraMessageText;
    case: "messageText";
  } | {
    /**
     * @generated from field: gdx.market.v1.ExtraConnectionId connection_id = 4;
     */
    value: ExtraConnectionId;
    case: "connectionId";
  } | {
    /**
     * @generated from field: gdx.market.v1.ExtraGift gift = 5;
     */
    value: ExtraGift;
    case: "gift";
  } | {
    /**
     * @generated from field: gdx.market.v1.ExtraPartnerId partner_id = 6;
     */
    value: ExtraPartnerId;
    case: "partnerId";
  } | { case: undefined; value?: undefined } = { case: undefined };

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 7;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: uint32 source = 8;
   */
  source = 0;

  /**
   * @generated from field: bool is_failed_autocharge = 9;
   */
  isFailedAutocharge = false;

  constructor(data?: PartialMessage<FeaturePurchaseFailedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.FeaturePurchaseFailedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "feature_type", kind: "enum", T: proto3.getEnumType(FeatureType) },
    { no: 3, name: "message_text", kind: "message", T: ExtraMessageText, oneof: "extra" },
    { no: 4, name: "connection_id", kind: "message", T: ExtraConnectionId, oneof: "extra" },
    { no: 5, name: "gift", kind: "message", T: ExtraGift, oneof: "extra" },
    { no: 6, name: "partner_id", kind: "message", T: ExtraPartnerId, oneof: "extra" },
    { no: 7, name: "created_time", kind: "message", T: Timestamp },
    { no: 8, name: "source", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 9, name: "is_failed_autocharge", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FeaturePurchaseFailedEvent {
    return new FeaturePurchaseFailedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FeaturePurchaseFailedEvent {
    return new FeaturePurchaseFailedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FeaturePurchaseFailedEvent {
    return new FeaturePurchaseFailedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: FeaturePurchaseFailedEvent | PlainMessage<FeaturePurchaseFailedEvent> | undefined, b: FeaturePurchaseFailedEvent | PlainMessage<FeaturePurchaseFailedEvent> | undefined): boolean {
    return proto3.util.equals(FeaturePurchaseFailedEvent, a, b);
  }
}

/**
 * Occurs retention reward is awarded.
 * ebus:message
 *
 * @generated from message gdx.events.v1.RetentionRewardReceivedEvent
 */
export class RetentionRewardReceivedEvent extends Message<RetentionRewardReceivedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: gdx.events.v1.RetentionRewardReceivedEvent.PromotionType promotion = 2;
   */
  promotion = RetentionRewardReceivedEvent_PromotionType.INVALID;

  /**
   * @generated from field: uint32 stage_id = 3;
   */
  stageId = 0;

  /**
   * @generated from field: repeated gdx.events.v1.RetentionRewardReceivedEvent.Reward rewards = 4;
   */
  rewards: RetentionRewardReceivedEvent_Reward[] = [];

  constructor(data?: PartialMessage<RetentionRewardReceivedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.RetentionRewardReceivedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "promotion", kind: "enum", T: proto3.getEnumType(RetentionRewardReceivedEvent_PromotionType) },
    { no: 3, name: "stage_id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "rewards", kind: "message", T: RetentionRewardReceivedEvent_Reward, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RetentionRewardReceivedEvent {
    return new RetentionRewardReceivedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RetentionRewardReceivedEvent {
    return new RetentionRewardReceivedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RetentionRewardReceivedEvent {
    return new RetentionRewardReceivedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: RetentionRewardReceivedEvent | PlainMessage<RetentionRewardReceivedEvent> | undefined, b: RetentionRewardReceivedEvent | PlainMessage<RetentionRewardReceivedEvent> | undefined): boolean {
    return proto3.util.equals(RetentionRewardReceivedEvent, a, b);
  }
}

/**
 * Enumerates retention promotion types.
 *
 * @generated from enum gdx.events.v1.RetentionRewardReceivedEvent.PromotionType
 */
export enum RetentionRewardReceivedEvent_PromotionType {
  /**
   * @generated from enum value: PROMOTION_TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: PROMOTION_TYPE_SEVEN_DAYS = 1;
   */
  SEVEN_DAYS = 1,

  /**
   * @generated from enum value: PROMOTION_TYPE_PHOTO_UPLOAD = 2;
   */
  PHOTO_UPLOAD = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(RetentionRewardReceivedEvent_PromotionType)
proto3.util.setEnumType(RetentionRewardReceivedEvent_PromotionType, "gdx.events.v1.RetentionRewardReceivedEvent.PromotionType", [
  { no: 0, name: "PROMOTION_TYPE_INVALID" },
  { no: 1, name: "PROMOTION_TYPE_SEVEN_DAYS" },
  { no: 2, name: "PROMOTION_TYPE_PHOTO_UPLOAD" },
]);

/**
 * Enumerates retention reward types.
 *
 * @generated from enum gdx.events.v1.RetentionRewardReceivedEvent.RewardType
 */
export enum RetentionRewardReceivedEvent_RewardType {
  /**
   * @generated from enum value: REWARD_TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: REWARD_TYPE_DAILY_FREE_GIFT = 1;
   */
  DAILY_FREE_GIFT = 1,

  /**
   * @generated from enum value: REWARD_TYPE_FREE_GIFT = 2;
   */
  FREE_GIFT = 2,

  /**
   * @generated from enum value: REWARD_TYPE_ASTROLOGICAL_COMPATIBILITY = 3;
   */
  ASTROLOGICAL_COMPATIBILITY = 3,

  /**
   * @generated from enum value: REWARD_TYPE_SEXUAL_COMPATIBILITY = 4;
   */
  SEXUAL_COMPATIBILITY = 4,

  /**
   * @generated from enum value: REWARD_TYPE_CREDITS = 5;
   */
  CREDITS = 5,

  /**
   * @generated from enum value: REWARD_TYPE_TOP_PROFILE = 6;
   */
  TOP_PROFILE = 6,

  /**
   * @generated from enum value: REWARD_TYPE_POWER_LIKE = 7;
   */
  POWER_LIKE = 7,
}
// Retrieve enum metadata with: proto3.getEnumType(RetentionRewardReceivedEvent_RewardType)
proto3.util.setEnumType(RetentionRewardReceivedEvent_RewardType, "gdx.events.v1.RetentionRewardReceivedEvent.RewardType", [
  { no: 0, name: "REWARD_TYPE_INVALID" },
  { no: 1, name: "REWARD_TYPE_DAILY_FREE_GIFT" },
  { no: 2, name: "REWARD_TYPE_FREE_GIFT" },
  { no: 3, name: "REWARD_TYPE_ASTROLOGICAL_COMPATIBILITY" },
  { no: 4, name: "REWARD_TYPE_SEXUAL_COMPATIBILITY" },
  { no: 5, name: "REWARD_TYPE_CREDITS" },
  { no: 6, name: "REWARD_TYPE_TOP_PROFILE" },
  { no: 7, name: "REWARD_TYPE_POWER_LIKE" },
]);

/**
 * Describes rewards.
 *
 * @generated from message gdx.events.v1.RetentionRewardReceivedEvent.Reward
 */
export class RetentionRewardReceivedEvent_Reward extends Message<RetentionRewardReceivedEvent_Reward> {
  /**
   * @generated from field: gdx.events.v1.RetentionRewardReceivedEvent.RewardType type = 1;
   */
  type = RetentionRewardReceivedEvent_RewardType.INVALID;

  /**
   * @generated from field: int32 quantity = 2;
   */
  quantity = 0;

  constructor(data?: PartialMessage<RetentionRewardReceivedEvent_Reward>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.RetentionRewardReceivedEvent.Reward";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(RetentionRewardReceivedEvent_RewardType) },
    { no: 2, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RetentionRewardReceivedEvent_Reward {
    return new RetentionRewardReceivedEvent_Reward().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RetentionRewardReceivedEvent_Reward {
    return new RetentionRewardReceivedEvent_Reward().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RetentionRewardReceivedEvent_Reward {
    return new RetentionRewardReceivedEvent_Reward().fromJsonString(jsonString, options);
  }

  static equals(a: RetentionRewardReceivedEvent_Reward | PlainMessage<RetentionRewardReceivedEvent_Reward> | undefined, b: RetentionRewardReceivedEvent_Reward | PlainMessage<RetentionRewardReceivedEvent_Reward> | undefined): boolean {
    return proto3.util.equals(RetentionRewardReceivedEvent_Reward, a, b);
  }
}

/**
 * Occurs on failed autocharge initiate.
 * ebus:message
 *
 * @generated from message gdx.events.v1.AutochargeInitiateFailedEvent
 */
export class AutochargeInitiateFailedEvent extends Message<AutochargeInitiateFailedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string reason = 2;
   */
  reason = "";

  /**
   * @generated from field: bool is_subscription = 3;
   */
  isSubscription = false;

  /**
   * @generated from field: gdx.gateway.web.payment.v2.PaymentGateway gateway = 4;
   */
  gateway = PaymentGateway.INVALID;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 5;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<AutochargeInitiateFailedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.AutochargeInitiateFailedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_subscription", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "gateway", kind: "enum", T: proto3.getEnumType(PaymentGateway) },
    { no: 5, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AutochargeInitiateFailedEvent {
    return new AutochargeInitiateFailedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AutochargeInitiateFailedEvent {
    return new AutochargeInitiateFailedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AutochargeInitiateFailedEvent {
    return new AutochargeInitiateFailedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: AutochargeInitiateFailedEvent | PlainMessage<AutochargeInitiateFailedEvent> | undefined, b: AutochargeInitiateFailedEvent | PlainMessage<AutochargeInitiateFailedEvent> | undefined): boolean {
    return proto3.util.equals(AutochargeInitiateFailedEvent, a, b);
  }
}

/**
 * Occurs on user requested verification email.
 * ebus:message
 *
 * @generated from message gdx.events.v1.VerificationEmailRequestedEvent
 */
export class VerificationEmailRequestedEvent extends Message<VerificationEmailRequestedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 2;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<VerificationEmailRequestedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.VerificationEmailRequestedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VerificationEmailRequestedEvent {
    return new VerificationEmailRequestedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VerificationEmailRequestedEvent {
    return new VerificationEmailRequestedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VerificationEmailRequestedEvent {
    return new VerificationEmailRequestedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: VerificationEmailRequestedEvent | PlainMessage<VerificationEmailRequestedEvent> | undefined, b: VerificationEmailRequestedEvent | PlainMessage<VerificationEmailRequestedEvent> | undefined): boolean {
    return proto3.util.equals(VerificationEmailRequestedEvent, a, b);
  }
}

/**
 * Occurs on order with routing.
 * ebus:message
 *
 * @generated from message gdx.events.v1.OrderCascadeRecordedEvent
 */
export class OrderCascadeRecordedEvent extends Message<OrderCascadeRecordedEvent> {
  /**
   * @generated from field: string order_id = 1;
   */
  orderId = "";

  /**
   * @generated from field: uint32 status = 2;
   */
  status = 0;

  /**
   * @generated from field: repeated gdx.events.v1.OrderCascadeRecordedEvent.Step steps = 3;
   */
  steps: OrderCascadeRecordedEvent_Step[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 4;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<OrderCascadeRecordedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.OrderCascadeRecordedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "steps", kind: "message", T: OrderCascadeRecordedEvent_Step, repeated: true },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrderCascadeRecordedEvent {
    return new OrderCascadeRecordedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrderCascadeRecordedEvent {
    return new OrderCascadeRecordedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrderCascadeRecordedEvent {
    return new OrderCascadeRecordedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: OrderCascadeRecordedEvent | PlainMessage<OrderCascadeRecordedEvent> | undefined, b: OrderCascadeRecordedEvent | PlainMessage<OrderCascadeRecordedEvent> | undefined): boolean {
    return proto3.util.equals(OrderCascadeRecordedEvent, a, b);
  }
}

/**
 * Order cascade routing step.
 *
 * @generated from message gdx.events.v1.OrderCascadeRecordedEvent.Step
 */
export class OrderCascadeRecordedEvent_Step extends Message<OrderCascadeRecordedEvent_Step> {
  /**
   * @generated from field: string mid = 1;
   */
  mid = "";

  /**
   * @generated from field: string mid_descriptor = 2;
   */
  midDescriptor = "";

  /**
   * @generated from field: string route_id = 3;
   */
  routeId = "";

  /**
   * @generated from field: int64 cascade_number = 4;
   */
  cascadeNumber = protoInt64.zero;

  constructor(data?: PartialMessage<OrderCascadeRecordedEvent_Step>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.OrderCascadeRecordedEvent.Step";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "mid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "mid_descriptor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "route_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "cascade_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrderCascadeRecordedEvent_Step {
    return new OrderCascadeRecordedEvent_Step().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrderCascadeRecordedEvent_Step {
    return new OrderCascadeRecordedEvent_Step().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrderCascadeRecordedEvent_Step {
    return new OrderCascadeRecordedEvent_Step().fromJsonString(jsonString, options);
  }

  static equals(a: OrderCascadeRecordedEvent_Step | PlainMessage<OrderCascadeRecordedEvent_Step> | undefined, b: OrderCascadeRecordedEvent_Step | PlainMessage<OrderCascadeRecordedEvent_Step> | undefined): boolean {
    return proto3.util.equals(OrderCascadeRecordedEvent_Step, a, b);
  }
}

/**
 * Occurs on operator message problem.
 * ebus:message
 *
 * @generated from message gdx.events.v1.OperatorMessageAlertEvent
 */
export class OperatorMessageAlertEvent extends Message<OperatorMessageAlertEvent> {
  /**
   * @generated from field: string team_member_id = 1;
   */
  teamMemberId = "";

  /**
   * @generated from field: string team_member_email = 2;
   */
  teamMemberEmail = "";

  /**
   * @generated from field: string connection_id = 3;
   */
  connectionId = "";

  /**
   * @generated from field: string message_id = 4;
   */
  messageId = "";

  /**
   * @generated from field: string message = 5;
   */
  message = "";

  /**
   * @generated from field: gdx.events.v1.OperatorMessageAlertEvent.Type type = 6;
   */
  type = OperatorMessageAlertEvent_Type.INVALID;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 7;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<OperatorMessageAlertEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.OperatorMessageAlertEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "team_member_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_member_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "connection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "message_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "type", kind: "enum", T: proto3.getEnumType(OperatorMessageAlertEvent_Type) },
    { no: 7, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OperatorMessageAlertEvent {
    return new OperatorMessageAlertEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OperatorMessageAlertEvent {
    return new OperatorMessageAlertEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OperatorMessageAlertEvent {
    return new OperatorMessageAlertEvent().fromJsonString(jsonString, options);
  }

  static equals(a: OperatorMessageAlertEvent | PlainMessage<OperatorMessageAlertEvent> | undefined, b: OperatorMessageAlertEvent | PlainMessage<OperatorMessageAlertEvent> | undefined): boolean {
    return proto3.util.equals(OperatorMessageAlertEvent, a, b);
  }
}

/**
 * Enumerates available alert types.
 *
 * @generated from enum gdx.events.v1.OperatorMessageAlertEvent.Type
 */
export enum OperatorMessageAlertEvent_Type {
  /**
   * @generated from enum value: TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: TYPE_BLOCK_WORDS = 1;
   */
  BLOCK_WORDS = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(OperatorMessageAlertEvent_Type)
proto3.util.setEnumType(OperatorMessageAlertEvent_Type, "gdx.events.v1.OperatorMessageAlertEvent.Type", [
  { no: 0, name: "TYPE_INVALID" },
  { no: 1, name: "TYPE_BLOCK_WORDS" },
]);

/**
 * Occurs on solid gate fraud report alert webhook.
 * ebus:message
 *
 * @generated from message gdx.events.v1.SolidGateFraudAlertEvent
 */
export class SolidGateFraudAlertEvent extends Message<SolidGateFraudAlertEvent> {
  /**
   * @generated from field: string order_id = 1;
   */
  orderId = "";

  /**
   * @generated from field: int64 fraud_amount = 2;
   */
  fraudAmount = protoInt64.zero;

  /**
   * @generated from field: string fraud_currency = 3;
   */
  fraudCurrency = "";

  /**
   * @generated from field: int64 fraud_amount_usd = 4;
   */
  fraudAmountUsd = protoInt64.zero;

  /**
   * @generated from field: string fraud_type = 5;
   */
  fraudType = "";

  /**
   * @generated from field: google.protobuf.Timestamp fraud_report_time = 6;
   */
  fraudReportTime?: Timestamp;

  /**
   * @generated from field: string card_scheme = 7;
   */
  cardScheme = "";

  /**
   * @generated from field: string reason_code_description = 8;
   */
  reasonCodeDescription = "";

  constructor(data?: PartialMessage<SolidGateFraudAlertEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.SolidGateFraudAlertEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "fraud_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "fraud_currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "fraud_amount_usd", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "fraud_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "fraud_report_time", kind: "message", T: Timestamp },
    { no: 7, name: "card_scheme", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "reason_code_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SolidGateFraudAlertEvent {
    return new SolidGateFraudAlertEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SolidGateFraudAlertEvent {
    return new SolidGateFraudAlertEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SolidGateFraudAlertEvent {
    return new SolidGateFraudAlertEvent().fromJsonString(jsonString, options);
  }

  static equals(a: SolidGateFraudAlertEvent | PlainMessage<SolidGateFraudAlertEvent> | undefined, b: SolidGateFraudAlertEvent | PlainMessage<SolidGateFraudAlertEvent> | undefined): boolean {
    return proto3.util.equals(SolidGateFraudAlertEvent, a, b);
  }
}

/**
 * Occurs for photo moderation backoffice metrics.
 * ebus:message
 *
 * @generated from message gdx.events.v1.PhotoModerationEvent
 */
export class PhotoModerationEvent extends Message<PhotoModerationEvent> {
  /**
   * @generated from field: string photo_id = 1;
   */
  photoId = "";

  /**
   * @generated from field: string user_id = 5;
   */
  userId = "";

  /**
   * @generated from field: string team_member_email = 2;
   */
  teamMemberEmail = "";

  /**
   * @generated from field: gdx.events.v1.PhotoModerationEvent.Status status = 3;
   */
  status = PhotoModerationEvent_Status.INVALID;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 4;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<PhotoModerationEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.PhotoModerationEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "photo_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_member_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(PhotoModerationEvent_Status) },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PhotoModerationEvent {
    return new PhotoModerationEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PhotoModerationEvent {
    return new PhotoModerationEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PhotoModerationEvent {
    return new PhotoModerationEvent().fromJsonString(jsonString, options);
  }

  static equals(a: PhotoModerationEvent | PlainMessage<PhotoModerationEvent> | undefined, b: PhotoModerationEvent | PlainMessage<PhotoModerationEvent> | undefined): boolean {
    return proto3.util.equals(PhotoModerationEvent, a, b);
  }
}

/**
 * Enumerates photo moderation statuses.
 *
 * @generated from enum gdx.events.v1.PhotoModerationEvent.Status
 */
export enum PhotoModerationEvent_Status {
  /**
   * @generated from enum value: STATUS_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: STATUS_NEW = 1;
   */
  NEW = 1,

  /**
   * @generated from enum value: STATUS_APPROVED = 2;
   */
  APPROVED = 2,

  /**
   * @generated from enum value: STATUS_APPROVED_TOP = 3;
   */
  APPROVED_TOP = 3,

  /**
   * @generated from enum value: STATUS_DECLINED = 4;
   */
  DECLINED = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(PhotoModerationEvent_Status)
proto3.util.setEnumType(PhotoModerationEvent_Status, "gdx.events.v1.PhotoModerationEvent.Status", [
  { no: 0, name: "STATUS_INVALID" },
  { no: 1, name: "STATUS_NEW" },
  { no: 2, name: "STATUS_APPROVED" },
  { no: 3, name: "STATUS_APPROVED_TOP" },
  { no: 4, name: "STATUS_DECLINED" },
]);

/**
 * Occurs when temp profile is added from BO.
 * ebus:message
 *
 * @generated from message gdx.events.v1.TempProfileAddedEvent
 */
export class TempProfileAddedEvent extends Message<TempProfileAddedEvent> {
  /**
   * @generated from field: string team_member_email = 1;
   */
  teamMemberEmail = "";

  /**
   * @generated from field: string profile_id = 2;
   */
  profileId = "";

  /**
   * @generated from field: int32 photos_count = 3;
   */
  photosCount = 0;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 4;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<TempProfileAddedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.TempProfileAddedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "team_member_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "profile_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "photos_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TempProfileAddedEvent {
    return new TempProfileAddedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TempProfileAddedEvent {
    return new TempProfileAddedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TempProfileAddedEvent {
    return new TempProfileAddedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: TempProfileAddedEvent | PlainMessage<TempProfileAddedEvent> | undefined, b: TempProfileAddedEvent | PlainMessage<TempProfileAddedEvent> | undefined): boolean {
    return proto3.util.equals(TempProfileAddedEvent, a, b);
  }
}

/**
 * Occurs keywords moderation backoffice metrics.
 * ebus:message
 *
 * @generated from message gdx.events.v1.KeywordModerationEvent
 */
export class KeywordModerationEvent extends Message<KeywordModerationEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string team_member_email = 2;
   */
  teamMemberEmail = "";

  /**
   * @generated from field: gdx.events.v1.KeywordModerationEvent.Status status = 3;
   */
  status = KeywordModerationEvent_Status.INVALID;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 4;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<KeywordModerationEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.KeywordModerationEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_member_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(KeywordModerationEvent_Status) },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): KeywordModerationEvent {
    return new KeywordModerationEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): KeywordModerationEvent {
    return new KeywordModerationEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): KeywordModerationEvent {
    return new KeywordModerationEvent().fromJsonString(jsonString, options);
  }

  static equals(a: KeywordModerationEvent | PlainMessage<KeywordModerationEvent> | undefined, b: KeywordModerationEvent | PlainMessage<KeywordModerationEvent> | undefined): boolean {
    return proto3.util.equals(KeywordModerationEvent, a, b);
  }
}

/**
 * Enumerates keywords moderation statuses.
 *
 * @generated from enum gdx.events.v1.KeywordModerationEvent.Status
 */
export enum KeywordModerationEvent_Status {
  /**
   * @generated from enum value: STATUS_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: STATUS_NEW = 1;
   */
  NEW = 1,

  /**
   * @generated from enum value: STATUS_RESOLVED = 2;
   */
  RESOLVED = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(KeywordModerationEvent_Status)
proto3.util.setEnumType(KeywordModerationEvent_Status, "gdx.events.v1.KeywordModerationEvent.Status", [
  { no: 0, name: "STATUS_INVALID" },
  { no: 1, name: "STATUS_NEW" },
  { no: 2, name: "STATUS_RESOLVED" },
]);

/**
 * Occurs report of abuse moderation backoffice metrics.
 * ebus:message
 *
 * @generated from message gdx.events.v1.ReportOfAbuseModerationEvent
 */
export class ReportOfAbuseModerationEvent extends Message<ReportOfAbuseModerationEvent> {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId = "";

  /**
   * @generated from field: string team_member_email = 2;
   */
  teamMemberEmail = "";

  /**
   * @generated from field: gdx.events.v1.ReportOfAbuseModerationEvent.Status status = 3;
   */
  status = ReportOfAbuseModerationEvent_Status.INVALID;

  /**
   * @generated from field: gdx.events.v1.ReportOfAbuseModerationEvent.Category reason = 4;
   */
  reason = ReportOfAbuseModerationEvent_Category.INVALID;

  /**
   * @generated from field: string details = 5;
   */
  details = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 6;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: repeated string initiator_tags = 7;
   */
  initiatorTags: string[] = [];

  /**
   * @generated from field: repeated string subject_tags = 8;
   */
  subjectTags: string[] = [];

  /**
   * @generated from field: bool is_complaint_justified = 9;
   */
  isComplaintJustified = false;

  /**
   * @generated from field: string complaint_category = 10;
   */
  complaintCategory = "";

  constructor(data?: PartialMessage<ReportOfAbuseModerationEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ReportOfAbuseModerationEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "report_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_member_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(ReportOfAbuseModerationEvent_Status) },
    { no: 4, name: "reason", kind: "enum", T: proto3.getEnumType(ReportOfAbuseModerationEvent_Category) },
    { no: 5, name: "details", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created_time", kind: "message", T: Timestamp },
    { no: 7, name: "initiator_tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "subject_tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: "is_complaint_justified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "complaint_category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportOfAbuseModerationEvent {
    return new ReportOfAbuseModerationEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportOfAbuseModerationEvent {
    return new ReportOfAbuseModerationEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportOfAbuseModerationEvent {
    return new ReportOfAbuseModerationEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ReportOfAbuseModerationEvent | PlainMessage<ReportOfAbuseModerationEvent> | undefined, b: ReportOfAbuseModerationEvent | PlainMessage<ReportOfAbuseModerationEvent> | undefined): boolean {
    return proto3.util.equals(ReportOfAbuseModerationEvent, a, b);
  }
}

/**
 * Enumerates reports moderation statuses.
 *
 * @generated from enum gdx.events.v1.ReportOfAbuseModerationEvent.Status
 */
export enum ReportOfAbuseModerationEvent_Status {
  /**
   * @generated from enum value: STATUS_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: STATUS_NEW = 1;
   */
  NEW = 1,

  /**
   * @generated from enum value: STATUS_RESOLVED = 2;
   */
  RESOLVED = 2,

  /**
   * @generated from enum value: STATUS_UPDATED = 3;
   */
  UPDATED = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(ReportOfAbuseModerationEvent_Status)
proto3.util.setEnumType(ReportOfAbuseModerationEvent_Status, "gdx.events.v1.ReportOfAbuseModerationEvent.Status", [
  { no: 0, name: "STATUS_INVALID" },
  { no: 1, name: "STATUS_NEW" },
  { no: 2, name: "STATUS_RESOLVED" },
  { no: 3, name: "STATUS_UPDATED" },
]);

/**
 * Enumerates reports moderation categories.
 *
 * @generated from enum gdx.events.v1.ReportOfAbuseModerationEvent.Category
 */
export enum ReportOfAbuseModerationEvent_Category {
  /**
   * @generated from enum value: CATEGORY_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: CATEGORY_BLOCK = 1;
   */
  BLOCK = 1,

  /**
   * @generated from enum value: CATEGORY_UNCOMFORTABLE = 2;
   */
  UNCOMFORTABLE = 2,

  /**
   * @generated from enum value: CATEGORY_ABUSIVE = 3;
   */
  ABUSIVE = 3,

  /**
   * @generated from enum value: CATEGORY_INAPPROPRIATE = 4;
   */
  INAPPROPRIATE = 4,

  /**
   * @generated from enum value: CATEGORY_SPAM = 5;
   */
  SPAM = 5,

  /**
   * @generated from enum value: CATEGORY_STOLEN_PHOTO = 6;
   */
  STOLEN_PHOTO = 6,

  /**
   * @generated from enum value: CATEGORY_OTHER = 7;
   */
  OTHER = 7,
}
// Retrieve enum metadata with: proto3.getEnumType(ReportOfAbuseModerationEvent_Category)
proto3.util.setEnumType(ReportOfAbuseModerationEvent_Category, "gdx.events.v1.ReportOfAbuseModerationEvent.Category", [
  { no: 0, name: "CATEGORY_INVALID" },
  { no: 1, name: "CATEGORY_BLOCK" },
  { no: 2, name: "CATEGORY_UNCOMFORTABLE" },
  { no: 3, name: "CATEGORY_ABUSIVE" },
  { no: 4, name: "CATEGORY_INAPPROPRIATE" },
  { no: 5, name: "CATEGORY_SPAM" },
  { no: 6, name: "CATEGORY_STOLEN_PHOTO" },
  { no: 7, name: "CATEGORY_OTHER" },
]);

/**
 * Occurs on automation generated messages.
 * ebus:message
 *
 * @generated from message gdx.events.v1.AutomationMessageEvent
 */
export class AutomationMessageEvent extends Message<AutomationMessageEvent> {
  /**
   * @generated from field: string dialog_id = 1;
   */
  dialogId = "";

  /**
   * @generated from field: string entity = 2;
   */
  entity = "";

  /**
   * @generated from field: string message_id = 3;
   */
  messageId = "";

  /**
   * @generated from field: repeated string moods = 4;
   */
  moods: string[] = [];

  /**
   * @generated from field: string nature = 5;
   */
  nature = "";

  /**
   * @generated from field: string person = 6;
   */
  person = "";

  /**
   * @generated from field: string looking_for = 7;
   */
  lookingFor = "";

  constructor(data?: PartialMessage<AutomationMessageEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.AutomationMessageEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dialog_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "entity", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "moods", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "nature", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "person", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "looking_for", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AutomationMessageEvent {
    return new AutomationMessageEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AutomationMessageEvent {
    return new AutomationMessageEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AutomationMessageEvent {
    return new AutomationMessageEvent().fromJsonString(jsonString, options);
  }

  static equals(a: AutomationMessageEvent | PlainMessage<AutomationMessageEvent> | undefined, b: AutomationMessageEvent | PlainMessage<AutomationMessageEvent> | undefined): boolean {
    return proto3.util.equals(AutomationMessageEvent, a, b);
  }
}

/**
 * Occurs on automation generated messages.
 * ebus:message
 *
 * @generated from message gdx.events.v1.PhotoBankUpdatedEvent
 */
export class PhotoBankUpdatedEvent extends Message<PhotoBankUpdatedEvent> {
  /**
   * @generated from field: string profile_id = 1;
   */
  profileId = "";

  /**
   * @generated from field: string team_member_email = 2;
   */
  teamMemberEmail = "";

  /**
   * @generated from field: uint32 added = 3;
   */
  added = 0;

  /**
   * @generated from field: uint32 removed = 4;
   */
  removed = 0;

  /**
   * @generated from field: google.protobuf.Timestamp updated_time = 5;
   */
  updatedTime?: Timestamp;

  constructor(data?: PartialMessage<PhotoBankUpdatedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.PhotoBankUpdatedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profile_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_member_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "added", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "removed", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "updated_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PhotoBankUpdatedEvent {
    return new PhotoBankUpdatedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PhotoBankUpdatedEvent {
    return new PhotoBankUpdatedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PhotoBankUpdatedEvent {
    return new PhotoBankUpdatedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: PhotoBankUpdatedEvent | PlainMessage<PhotoBankUpdatedEvent> | undefined, b: PhotoBankUpdatedEvent | PlainMessage<PhotoBankUpdatedEvent> | undefined): boolean {
    return proto3.util.equals(PhotoBankUpdatedEvent, a, b);
  }
}

/**
 * Occurs on automation generated messages.
 * ebus:message
 *
 * @generated from message gdx.events.v1.UserFoulsModeratedEvent
 */
export class UserFoulsModeratedEvent extends Message<UserFoulsModeratedEvent> {
  /**
   * @generated from field: string profile_id = 1;
   */
  profileId = "";

  /**
   * @generated from field: string team_member_email = 2;
   */
  teamMemberEmail = "";

  /**
   * @generated from field: repeated string foul_ids = 3;
   */
  foulIds: string[] = [];

  /**
   * @generated from field: string status = 4;
   */
  status = "";

  /**
   * @generated from field: google.protobuf.Timestamp updated_time = 5;
   */
  updatedTime?: Timestamp;

  /**
   * @generated from field: repeated google.protobuf.Timestamp foul_creation_time = 6;
   */
  foulCreationTime: Timestamp[] = [];

  constructor(data?: PartialMessage<UserFoulsModeratedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.UserFoulsModeratedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profile_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_member_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "foul_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "updated_time", kind: "message", T: Timestamp },
    { no: 6, name: "foul_creation_time", kind: "message", T: Timestamp, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserFoulsModeratedEvent {
    return new UserFoulsModeratedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserFoulsModeratedEvent {
    return new UserFoulsModeratedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserFoulsModeratedEvent {
    return new UserFoulsModeratedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: UserFoulsModeratedEvent | PlainMessage<UserFoulsModeratedEvent> | undefined, b: UserFoulsModeratedEvent | PlainMessage<UserFoulsModeratedEvent> | undefined): boolean {
    return proto3.util.equals(UserFoulsModeratedEvent, a, b);
  }
}

/**
 * Occurs on moderator interacting with anti-fraud service.
 * ebus:message
 *
 * @generated from message gdx.events.v1.UserAntiFraudScoreEvent
 */
export class UserAntiFraudScoreEvent extends Message<UserAntiFraudScoreEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string team_member_email = 2;
   */
  teamMemberEmail = "";

  /**
   * @generated from field: uint32 score = 3;
   */
  score = 0;

  /**
   * @generated from field: gdx.events.v1.UserAntiFraudScoreEvent.Action action = 4;
   */
  action = UserAntiFraudScoreEvent_Action.INVALID;

  /**
   * @generated from field: google.protobuf.Timestamp action_time = 5;
   */
  actionTime?: Timestamp;

  constructor(data?: PartialMessage<UserAntiFraudScoreEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.UserAntiFraudScoreEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_member_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "score", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "action", kind: "enum", T: proto3.getEnumType(UserAntiFraudScoreEvent_Action) },
    { no: 5, name: "action_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserAntiFraudScoreEvent {
    return new UserAntiFraudScoreEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserAntiFraudScoreEvent {
    return new UserAntiFraudScoreEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserAntiFraudScoreEvent {
    return new UserAntiFraudScoreEvent().fromJsonString(jsonString, options);
  }

  static equals(a: UserAntiFraudScoreEvent | PlainMessage<UserAntiFraudScoreEvent> | undefined, b: UserAntiFraudScoreEvent | PlainMessage<UserAntiFraudScoreEvent> | undefined): boolean {
    return proto3.util.equals(UserAntiFraudScoreEvent, a, b);
  }
}

/**
 * Enumerates possible actions with anti-fraud scoring.
 *
 * @generated from enum gdx.events.v1.UserAntiFraudScoreEvent.Action
 */
export enum UserAntiFraudScoreEvent_Action {
  /**
   * @generated from enum value: ACTION_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: ACTION_BAN = 1;
   */
  BAN = 1,

  /**
   * @generated from enum value: ACTION_DELETE = 2;
   */
  DELETE = 2,

  /**
   * @generated from enum value: ACTION_OPEN_FOUL = 3;
   */
  OPEN_FOUL = 3,

  /**
   * @generated from enum value: ACTION_IGNORE_FOUL = 4;
   */
  IGNORE_FOUL = 4,

  /**
   * @generated from enum value: ACTION_RESOLVE_FOUL = 5;
   */
  RESOLVE_FOUL = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(UserAntiFraudScoreEvent_Action)
proto3.util.setEnumType(UserAntiFraudScoreEvent_Action, "gdx.events.v1.UserAntiFraudScoreEvent.Action", [
  { no: 0, name: "ACTION_INVALID" },
  { no: 1, name: "ACTION_BAN" },
  { no: 2, name: "ACTION_DELETE" },
  { no: 3, name: "ACTION_OPEN_FOUL" },
  { no: 4, name: "ACTION_IGNORE_FOUL" },
  { no: 5, name: "ACTION_RESOLVE_FOUL" },
]);

/**
 * Occurs on review submitted.
 * ebus:message
 *
 * @generated from message gdx.events.v1.ReviewSubmittedEvent
 */
export class ReviewSubmittedEvent extends Message<ReviewSubmittedEvent> {
  /**
   * @generated from field: gdx.events.v1.ReviewPopUpEvent payload = 1;
   */
  payload?: ReviewPopUpEvent;

  constructor(data?: PartialMessage<ReviewSubmittedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ReviewSubmittedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "payload", kind: "message", T: ReviewPopUpEvent },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReviewSubmittedEvent {
    return new ReviewSubmittedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReviewSubmittedEvent {
    return new ReviewSubmittedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReviewSubmittedEvent {
    return new ReviewSubmittedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ReviewSubmittedEvent | PlainMessage<ReviewSubmittedEvent> | undefined, b: ReviewSubmittedEvent | PlainMessage<ReviewSubmittedEvent> | undefined): boolean {
    return proto3.util.equals(ReviewSubmittedEvent, a, b);
  }
}

/**
 * Occurs on review popup triggered.
 * ebus:message
 *
 * @generated from message gdx.events.v1.ReviewPopUpEvent
 */
export class ReviewPopUpEvent extends Message<ReviewPopUpEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: gdx.events.v1.ReviewPopUpEvent.ReviewPopupType type = 2;
   */
  type = ReviewPopUpEvent_ReviewPopupType.INVALID;

  /**
   * indicates popup number, starts from 1.
   *
   * @generated from field: uint32 show_count = 3;
   */
  showCount = 0;

  /**
   * @generated from field: uint32 score = 4;
   */
  score = 0;

  /**
   * @generated from field: string comment = 5;
   */
  comment = "";

  /**
   * @generated from field: string trigger = 7;
   */
  trigger = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 6;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<ReviewPopUpEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ReviewPopUpEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: proto3.getEnumType(ReviewPopUpEvent_ReviewPopupType) },
    { no: 3, name: "show_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "score", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "comment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "trigger", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReviewPopUpEvent {
    return new ReviewPopUpEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReviewPopUpEvent {
    return new ReviewPopUpEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReviewPopUpEvent {
    return new ReviewPopUpEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ReviewPopUpEvent | PlainMessage<ReviewPopUpEvent> | undefined, b: ReviewPopUpEvent | PlainMessage<ReviewPopUpEvent> | undefined): boolean {
    return proto3.util.equals(ReviewPopUpEvent, a, b);
  }
}

/**
 * Enumerates possible review popup types.
 *
 * @generated from enum gdx.events.v1.ReviewPopUpEvent.ReviewPopupType
 */
export enum ReviewPopUpEvent_ReviewPopupType {
  /**
   * @generated from enum value: REVIEW_POPUP_TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: REVIEW_POPUP_TYPE_TRIAL = 1;
   */
  TRIAL = 1,

  /**
   * @generated from enum value: REVIEW_POPUP_TYPE_PREMIUM = 2;
   */
  PREMIUM = 2,

  /**
   * @generated from enum value: REVIEW_POPUP_TYPE_FREE = 3;
   */
  FREE = 3,

  /**
   * @generated from enum value: REVIEW_POPUP_TYPE_ALL = 4;
   */
  ALL = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(ReviewPopUpEvent_ReviewPopupType)
proto3.util.setEnumType(ReviewPopUpEvent_ReviewPopupType, "gdx.events.v1.ReviewPopUpEvent.ReviewPopupType", [
  { no: 0, name: "REVIEW_POPUP_TYPE_INVALID" },
  { no: 1, name: "REVIEW_POPUP_TYPE_TRIAL" },
  { no: 2, name: "REVIEW_POPUP_TYPE_PREMIUM" },
  { no: 3, name: "REVIEW_POPUP_TYPE_FREE" },
  { no: 4, name: "REVIEW_POPUP_TYPE_ALL" },
]);

/**
 * Occurs on profile shadow ban set.
 * ebus:message
 *
 * @generated from message gdx.events.v1.ProfileShadowBanSetEvent
 */
export class ProfileShadowBanSetEvent extends Message<ProfileShadowBanSetEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: bool is_shadow_ban = 2;
   */
  isShadowBan = false;

  /**
   * @generated from field: uint64 fraud_score = 3;
   */
  fraudScore = protoInt64.zero;

  /**
   * @generated from field: gdx.backoffice.service.newprofiles.v1.ActorType actor_type = 4;
   */
  actorType = ActorType.INVALID;

  /**
   * @generated from field: string actor_id = 5;
   */
  actorId = "";

  constructor(data?: PartialMessage<ProfileShadowBanSetEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ProfileShadowBanSetEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_shadow_ban", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "fraud_score", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "actor_type", kind: "enum", T: proto3.getEnumType(ActorType) },
    { no: 5, name: "actor_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileShadowBanSetEvent {
    return new ProfileShadowBanSetEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileShadowBanSetEvent {
    return new ProfileShadowBanSetEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileShadowBanSetEvent {
    return new ProfileShadowBanSetEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileShadowBanSetEvent | PlainMessage<ProfileShadowBanSetEvent> | undefined, b: ProfileShadowBanSetEvent | PlainMessage<ProfileShadowBanSetEvent> | undefined): boolean {
    return proto3.util.equals(ProfileShadowBanSetEvent, a, b);
  }
}

/**
 * Occurs on analytics save record.
 * ebus:message
 *
 * @generated from message gdx.events.v1.RecordAnalyticsEvent
 */
export class RecordAnalyticsEvent extends Message<RecordAnalyticsEvent> {
  /**
   * @generated from field: gdx.gateway.web.analytics.v1.Event event = 1;
   */
  event?: Event;

  /**
   * @generated from field: string user_agent = 3;
   */
  userAgent = "";

  /**
   * @generated from field: string ip_address = 4;
   */
  ipAddress = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 2;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<RecordAnalyticsEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.RecordAnalyticsEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "event", kind: "message", T: Event },
    { no: 3, name: "user_agent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "ip_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RecordAnalyticsEvent {
    return new RecordAnalyticsEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RecordAnalyticsEvent {
    return new RecordAnalyticsEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RecordAnalyticsEvent {
    return new RecordAnalyticsEvent().fromJsonString(jsonString, options);
  }

  static equals(a: RecordAnalyticsEvent | PlainMessage<RecordAnalyticsEvent> | undefined, b: RecordAnalyticsEvent | PlainMessage<RecordAnalyticsEvent> | undefined): boolean {
    return proto3.util.equals(RecordAnalyticsEvent, a, b);
  }
}

/**
 * Occurs BO dialog status changes.
 * ebus:message
 *
 * @generated from message gdx.events.v1.DialogQueueStatusChangedEvent
 */
export class DialogQueueStatusChangedEvent extends Message<DialogQueueStatusChangedEvent> {
  /**
   * @generated from field: string dialog_id = 1;
   */
  dialogId = "";

  /**
   * @generated from field: string team_member_email = 2;
   */
  teamMemberEmail = "";

  /**
   * @generated from field: bool has_reply = 3;
   */
  hasReply = false;

  /**
   * @generated from field: gdx.events.v1.DialogQueueStatusChangedEvent.Event event = 4;
   */
  event = DialogQueueStatusChangedEvent_Event.INVALID;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 5;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<DialogQueueStatusChangedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.DialogQueueStatusChangedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dialog_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_member_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "has_reply", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "event", kind: "enum", T: proto3.getEnumType(DialogQueueStatusChangedEvent_Event) },
    { no: 5, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DialogQueueStatusChangedEvent {
    return new DialogQueueStatusChangedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DialogQueueStatusChangedEvent {
    return new DialogQueueStatusChangedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DialogQueueStatusChangedEvent {
    return new DialogQueueStatusChangedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: DialogQueueStatusChangedEvent | PlainMessage<DialogQueueStatusChangedEvent> | undefined, b: DialogQueueStatusChangedEvent | PlainMessage<DialogQueueStatusChangedEvent> | undefined): boolean {
    return proto3.util.equals(DialogQueueStatusChangedEvent, a, b);
  }
}

/**
 * Enumerates queue status events for dialog.
 *
 * @generated from enum gdx.events.v1.DialogQueueStatusChangedEvent.Event
 */
export enum DialogQueueStatusChangedEvent_Event {
  /**
   * @generated from enum value: EVENT_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: EVENT_RELEVANT = 1;
   */
  RELEVANT = 1,

  /**
   * @generated from enum value: EVENT_UN_RELEVANT = 2;
   */
  UN_RELEVANT = 2,

  /**
   * @generated from enum value: EVENT_COMPLETED_OP = 3;
   */
  COMPLETED_OP = 3,

  /**
   * @generated from enum value: EVENT_COMPLETED_AI = 4;
   */
  COMPLETED_AI = 4,

  /**
   * @generated from enum value: EVENT_UNREAD = 5;
   */
  UNREAD = 5,

  /**
   * @generated from enum value: EVENT_PROCESSING = 6;
   */
  PROCESSING = 6,
}
// Retrieve enum metadata with: proto3.getEnumType(DialogQueueStatusChangedEvent_Event)
proto3.util.setEnumType(DialogQueueStatusChangedEvent_Event, "gdx.events.v1.DialogQueueStatusChangedEvent.Event", [
  { no: 0, name: "EVENT_INVALID" },
  { no: 1, name: "EVENT_RELEVANT" },
  { no: 2, name: "EVENT_UN_RELEVANT" },
  { no: 3, name: "EVENT_COMPLETED_OP" },
  { no: 4, name: "EVENT_COMPLETED_AI" },
  { no: 5, name: "EVENT_UNREAD" },
  { no: 6, name: "EVENT_PROCESSING" },
]);

/**
 * Occurs when profile duplicate is banned.
 * ebus:message
 *
 * @generated from message gdx.events.v1.ProfileDuplicateBannedEvent
 */
export class ProfileDuplicateBannedEvent extends Message<ProfileDuplicateBannedEvent> {
  /**
   * @generated from field: int32 banned_count = 1;
   */
  bannedCount = 0;

  /**
   * @generated from field: string primary_user_id = 2;
   */
  primaryUserId = "";

  /**
   * @generated from field: repeated string banned_user_ids = 3;
   */
  bannedUserIds: string[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 4;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<ProfileDuplicateBannedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ProfileDuplicateBannedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "banned_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "primary_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "banned_user_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileDuplicateBannedEvent {
    return new ProfileDuplicateBannedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileDuplicateBannedEvent {
    return new ProfileDuplicateBannedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileDuplicateBannedEvent {
    return new ProfileDuplicateBannedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileDuplicateBannedEvent | PlainMessage<ProfileDuplicateBannedEvent> | undefined, b: ProfileDuplicateBannedEvent | PlainMessage<ProfileDuplicateBannedEvent> | undefined): boolean {
    return proto3.util.equals(ProfileDuplicateBannedEvent, a, b);
  }
}

/**
 * Occurs when profile distribution is changed.
 * ebus:message
 *
 * @generated from message gdx.events.v1.DistributionUpdatedEvent
 */
export class DistributionUpdatedEvent extends Message<DistributionUpdatedEvent> {
  /**
   * @generated from field: string profile_id = 1;
   */
  profileId = "";

  /**
   * @generated from field: gdx.common.v1.ProfileLocation to_location = 2;
   */
  toLocation?: ProfileLocation;

  /**
   * @generated from field: bool additional_distribution = 3;
   */
  additionalDistribution = false;

  /**
   * @generated from field: repeated gdx.events.v1.DistributionUpdatedEvent.Distribution distributed = 4;
   */
  distributed: DistributionUpdatedEvent_Distribution[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 5;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<DistributionUpdatedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.DistributionUpdatedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profile_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "to_location", kind: "message", T: ProfileLocation },
    { no: 3, name: "additional_distribution", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "distributed", kind: "message", T: DistributionUpdatedEvent_Distribution, repeated: true },
    { no: 5, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DistributionUpdatedEvent {
    return new DistributionUpdatedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DistributionUpdatedEvent {
    return new DistributionUpdatedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DistributionUpdatedEvent {
    return new DistributionUpdatedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: DistributionUpdatedEvent | PlainMessage<DistributionUpdatedEvent> | undefined, b: DistributionUpdatedEvent | PlainMessage<DistributionUpdatedEvent> | undefined): boolean {
    return proto3.util.equals(DistributionUpdatedEvent, a, b);
  }
}

/**
 * Describes distributed profile.
 *
 * @generated from message gdx.events.v1.DistributionUpdatedEvent.Distribution
 */
export class DistributionUpdatedEvent_Distribution extends Message<DistributionUpdatedEvent_Distribution> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: gdx.common.v1.ProfileLocation location = 2;
   */
  location?: ProfileLocation;

  constructor(data?: PartialMessage<DistributionUpdatedEvent_Distribution>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.DistributionUpdatedEvent.Distribution";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "location", kind: "message", T: ProfileLocation },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DistributionUpdatedEvent_Distribution {
    return new DistributionUpdatedEvent_Distribution().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DistributionUpdatedEvent_Distribution {
    return new DistributionUpdatedEvent_Distribution().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DistributionUpdatedEvent_Distribution {
    return new DistributionUpdatedEvent_Distribution().fromJsonString(jsonString, options);
  }

  static equals(a: DistributionUpdatedEvent_Distribution | PlainMessage<DistributionUpdatedEvent_Distribution> | undefined, b: DistributionUpdatedEvent_Distribution | PlainMessage<DistributionUpdatedEvent_Distribution> | undefined): boolean {
    return proto3.util.equals(DistributionUpdatedEvent_Distribution, a, b);
  }
}

/**
 * Occurs when profile duplicate reminder needs to be sent.
 * ebus:message
 *
 * @generated from message gdx.events.v1.ProfileDuplicatesReminderEvent
 */
export class ProfileDuplicatesReminderEvent extends Message<ProfileDuplicatesReminderEvent> {
  /**
   * @generated from field: string duplicate_list_id = 1;
   */
  duplicateListId = "";

  /**
   * @generated from field: gdx.events.v1.ProfileDuplicatesReminderEvent.ReminderType type = 2;
   */
  type = ProfileDuplicatesReminderEvent_ReminderType.INVALID;

  /**
   * @generated from field: repeated string profile_ids = 3;
   */
  profileIds: string[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 4;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<ProfileDuplicatesReminderEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ProfileDuplicatesReminderEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "duplicate_list_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: proto3.getEnumType(ProfileDuplicatesReminderEvent_ReminderType) },
    { no: 3, name: "profile_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileDuplicatesReminderEvent {
    return new ProfileDuplicatesReminderEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileDuplicatesReminderEvent {
    return new ProfileDuplicatesReminderEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileDuplicatesReminderEvent {
    return new ProfileDuplicatesReminderEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileDuplicatesReminderEvent | PlainMessage<ProfileDuplicatesReminderEvent> | undefined, b: ProfileDuplicatesReminderEvent | PlainMessage<ProfileDuplicatesReminderEvent> | undefined): boolean {
    return proto3.util.equals(ProfileDuplicatesReminderEvent, a, b);
  }
}

/**
 * Describes what reminder template needed.
 *
 * @generated from enum gdx.events.v1.ProfileDuplicatesReminderEvent.ReminderType
 */
export enum ProfileDuplicatesReminderEvent_ReminderType {
  /**
   * @generated from enum value: REMINDER_TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: REMINDER_TYPE_FIRST = 1;
   */
  FIRST = 1,

  /**
   * @generated from enum value: REMINDER_TYPE_SECOND = 2;
   */
  SECOND = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(ProfileDuplicatesReminderEvent_ReminderType)
proto3.util.setEnumType(ProfileDuplicatesReminderEvent_ReminderType, "gdx.events.v1.ProfileDuplicatesReminderEvent.ReminderType", [
  { no: 0, name: "REMINDER_TYPE_INVALID" },
  { no: 1, name: "REMINDER_TYPE_FIRST" },
  { no: 2, name: "REMINDER_TYPE_SECOND" },
]);

/**
 * Occurs when primary profile selected from duplicates.
 * ebus:message
 *
 * @generated from message gdx.events.v1.ProfileDuplicatesPrimaryAccountSelectedEvent
 */
export class ProfileDuplicatesPrimaryAccountSelectedEvent extends Message<ProfileDuplicatesPrimaryAccountSelectedEvent> {
  /**
   * @generated from field: string duplicate_list_id = 1;
   */
  duplicateListId = "";

  /**
   * @generated from field: string account_id = 2;
   */
  accountId = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 3;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<ProfileDuplicatesPrimaryAccountSelectedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ProfileDuplicatesPrimaryAccountSelectedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "duplicate_list_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileDuplicatesPrimaryAccountSelectedEvent {
    return new ProfileDuplicatesPrimaryAccountSelectedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileDuplicatesPrimaryAccountSelectedEvent {
    return new ProfileDuplicatesPrimaryAccountSelectedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileDuplicatesPrimaryAccountSelectedEvent {
    return new ProfileDuplicatesPrimaryAccountSelectedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileDuplicatesPrimaryAccountSelectedEvent | PlainMessage<ProfileDuplicatesPrimaryAccountSelectedEvent> | undefined, b: ProfileDuplicatesPrimaryAccountSelectedEvent | PlainMessage<ProfileDuplicatesPrimaryAccountSelectedEvent> | undefined): boolean {
    return proto3.util.equals(ProfileDuplicatesPrimaryAccountSelectedEvent, a, b);
  }
}

/**
 * Occurs when other than primary account is banned in duplicates.
 * ebus:message
 *
 * @generated from message gdx.events.v1.ProfileDuplicatedBannedAccountsEvent
 */
export class ProfileDuplicatedBannedAccountsEvent extends Message<ProfileDuplicatedBannedAccountsEvent> {
  /**
   * @generated from field: string primary_account_id = 1;
   */
  primaryAccountId = "";

  /**
   * @generated from field: repeated string banned_account_ids = 2;
   */
  bannedAccountIds: string[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 3;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<ProfileDuplicatedBannedAccountsEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ProfileDuplicatedBannedAccountsEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "primary_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "banned_account_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileDuplicatedBannedAccountsEvent {
    return new ProfileDuplicatedBannedAccountsEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileDuplicatedBannedAccountsEvent {
    return new ProfileDuplicatedBannedAccountsEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileDuplicatedBannedAccountsEvent {
    return new ProfileDuplicatedBannedAccountsEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileDuplicatedBannedAccountsEvent | PlainMessage<ProfileDuplicatedBannedAccountsEvent> | undefined, b: ProfileDuplicatedBannedAccountsEvent | PlainMessage<ProfileDuplicatedBannedAccountsEvent> | undefined): boolean {
    return proto3.util.equals(ProfileDuplicatedBannedAccountsEvent, a, b);
  }
}

/**
 * Occurs when confirmation code must be sent to user.
 * ebus:message
 *
 * @generated from message gdx.events.v1.ConfirmationCodeGeneratedEvent
 */
export class ConfirmationCodeGeneratedEvent extends Message<ConfirmationCodeGeneratedEvent> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: gdx.common.v1.CodeType type = 3;
   */
  type = CodeType.INVALID;

  /**
   * @generated from field: google.protobuf.StringValue email = 4;
   */
  email?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 5;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<ConfirmationCodeGeneratedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ConfirmationCodeGeneratedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "type", kind: "enum", T: proto3.getEnumType(CodeType) },
    { no: 4, name: "email", kind: "message", T: StringValue },
    { no: 5, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConfirmationCodeGeneratedEvent {
    return new ConfirmationCodeGeneratedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConfirmationCodeGeneratedEvent {
    return new ConfirmationCodeGeneratedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConfirmationCodeGeneratedEvent {
    return new ConfirmationCodeGeneratedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ConfirmationCodeGeneratedEvent | PlainMessage<ConfirmationCodeGeneratedEvent> | undefined, b: ConfirmationCodeGeneratedEvent | PlainMessage<ConfirmationCodeGeneratedEvent> | undefined): boolean {
    return proto3.util.equals(ConfirmationCodeGeneratedEvent, a, b);
  }
}

/**
 * Occurs when confirmation code must be sent to user.
 * ebus:message
 *
 * @generated from message gdx.events.v1.ProfileDuplicatesUpdatedEvent
 */
export class ProfileDuplicatesUpdatedEvent extends Message<ProfileDuplicatesUpdatedEvent> {
  /**
   * @generated from field: string duplicate_list_id = 1;
   */
  duplicateListId = "";

  /**
   * @generated from field: repeated string added = 2;
   */
  added: string[] = [];

  /**
   * @generated from field: repeated string removed = 3;
   */
  removed: string[] = [];

  /**
   * @generated from field: string team_member_email = 4;
   */
  teamMemberEmail = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 5;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<ProfileDuplicatesUpdatedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ProfileDuplicatesUpdatedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "duplicate_list_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "added", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "removed", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "team_member_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileDuplicatesUpdatedEvent {
    return new ProfileDuplicatesUpdatedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileDuplicatesUpdatedEvent {
    return new ProfileDuplicatesUpdatedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileDuplicatesUpdatedEvent {
    return new ProfileDuplicatesUpdatedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileDuplicatesUpdatedEvent | PlainMessage<ProfileDuplicatesUpdatedEvent> | undefined, b: ProfileDuplicatesUpdatedEvent | PlainMessage<ProfileDuplicatesUpdatedEvent> | undefined): boolean {
    return proto3.util.equals(ProfileDuplicatesUpdatedEvent, a, b);
  }
}

/**
 * Describes order linked with chargeback.
 *
 * @generated from message gdx.events.v1.Order
 */
export class Order extends Message<Order> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: int64 amount = 2;
   */
  amount = protoInt64.zero;

  /**
   * @generated from field: string currency = 3;
   */
  currency = "";

  /**
   * @generated from field: string status = 4;
   */
  status = "";

  constructor(data?: PartialMessage<Order>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.Order";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Order {
    return new Order().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Order {
    return new Order().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Order {
    return new Order().fromJsonString(jsonString, options);
  }

  static equals(a: Order | PlainMessage<Order> | undefined, b: Order | PlainMessage<Order> | undefined): boolean {
    return proto3.util.equals(Order, a, b);
  }
}

/**
 * Description of connection stats for connection events.
 *
 * @generated from message gdx.events.v1.ConnectionStats
 */
export class ConnectionStats extends Message<ConnectionStats> {
  /**
   * @generated from field: uint64 deletes = 1;
   */
  deletes = protoInt64.zero;

  /**
   * @generated from field: uint64 messages = 2;
   */
  messages = protoInt64.zero;

  /**
   * @generated from field: uint64 depth = 3;
   */
  depth = protoInt64.zero;

  constructor(data?: PartialMessage<ConnectionStats>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.ConnectionStats";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "deletes", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "messages", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "depth", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConnectionStats {
    return new ConnectionStats().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConnectionStats {
    return new ConnectionStats().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConnectionStats {
    return new ConnectionStats().fromJsonString(jsonString, options);
  }

  static equals(a: ConnectionStats | PlainMessage<ConnectionStats> | undefined, b: ConnectionStats | PlainMessage<ConnectionStats> | undefined): boolean {
    return proto3.util.equals(ConnectionStats, a, b);
  }
}

/**
 * Description of package for payment application event.
 *
 * @generated from message gdx.events.v1.Package
 */
export class Package extends Message<Package> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string offer_id = 2;
   */
  offerId = "";

  /**
   * @generated from field: uint64 base_amount = 3;
   */
  baseAmount = protoInt64.zero;

  /**
   * @generated from field: uint32 discount_amount = 4;
   */
  discountAmount = 0;

  /**
   * @generated from field: uint32 tax_amount = 8;
   */
  taxAmount = 0;

  /**
   * @generated from field: string currency = 5;
   */
  currency = "";

  /**
   * @generated from field: gdx.events.v1.PackageType type = 6;
   */
  type = PackageType.INVALID;

  /**
   * @generated from field: string title = 7;
   */
  title = "";

  constructor(data?: PartialMessage<Package>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.events.v1.Package";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "offer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "base_amount", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "discount_amount", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 8, name: "tax_amount", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "type", kind: "enum", T: proto3.getEnumType(PackageType) },
    { no: 7, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Package {
    return new Package().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Package {
    return new Package().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Package {
    return new Package().fromJsonString(jsonString, options);
  }

  static equals(a: Package | PlainMessage<Package> | undefined, b: Package | PlainMessage<Package> | undefined): boolean {
    return proto3.util.equals(Package, a, b);
  }
}

